// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/frontage-bold-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/frontage-bold-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/frontage-bold-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/frontage-bold-webfont.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/frontage-regular-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fonts/frontage-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/fonts/frontage-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/fonts/frontage-regular-webfont.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#frontagebold" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___, { hash: "#\"Open Sans\", sans-serif" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;

/* Light Theme */
.light-theme {
    --container-bg: #ffffff; /* White for light mode */
    --shotcusttext: #171717;
    --grey-comment: grey;
    --container2-bg: #fff;
    --viewBtn: #afafaf;
    --tag: #ababab;
    --userName: #000;
    --hover-noti-color: #9f9f9f;
    --hover-convo: #a6a6a6;
    --event-box-shadow:1px 1px 10px gray;
    --img-brightness:brightness(0);
    --ourbelief-p:#202020;
    --widget-bg:#fff;
    --notes-textarea-color:#000;
    --box-shadow:1px 1px 10px gray
}

/* Dark Theme */
.dark-theme {
    --container-bg: #171717; /* Existing dark background */
    --container2-bg: #202020;
    --shotcusttext: #fff;
    --viewBtn: #4b4b4b;
    --tag: #2f2f2f;
    --userName: #fff;
    --hover-noti-color: #353535;
    --hover-convo: #393737;
    --event-box-shadow:unset;
    --img-brightness:brightness(1);
    --ourbelief-p:#b4b4b4;
    --widget-bg:#151515;
    --notes-textarea-color:#fff;
    --box-shadow:unset
}

.light-theme .shortcuticon img {
    filter: brightness(0); /* Darkens the image completely */
}

/* Dark Theme - Normal Images */
.dark-theme .shortcuticon img {
    filter: brightness(1); /* Normal brightness */
}

.light-theme .profileimgUploadIcon img {
    filter: brightness(0); /* Darkens the image completely */
}

/* Dark Theme - Normal Images */
.dark-theme .profileimgUploadIcon img {
    filter: brightness(1); /* Normal brightness */
}

.light-theme .postaction ul li img {
    filter: brightness(0);
}

.dark-theme .postaction ul li img {
    filter: brightness(1);
}

.dashbaoad-main {
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
}

.admin-dashboard-right {
    width: calc(100% - 330px);
    padding: 0px 40px 90px;
}

.header-menu-main-left ul {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
}

.header-menu-main-left ul li + li {
    margin: 0;
    margin-top: 12px;
}

.header-menu-main-left ul li a::before {
    display: none;
}

.header-menu-main-left ul li a {
    display: block;
    width: 100%;
    padding: 18px;
    border-radius: 0;
}

.header-menu-main-left ul li {
    width: 100%;
}
header {
    background: #0e0e0e;
}
.header-menu-main-left ul li.active a,
.header-menu-main-left ul li:hover a {
    background: #3478ff;
    color: #fff;
}
.admin-screen h2 {
    color: #3478ff;
    font-size: 48px;
    font-weight: 700;
    line-height: 62px;
    /* font-family: "ITCAvantGardeStd-Bold"; */
}
.cate-tabs.quote-tabs ul li a {
    border: 2px solid #393737 !important;
    background: transparent !important;
    color: rgb(255 255 255 / 40%) !important;
    transition: 0.3s !important;
    text-transform: capitalize !important;
    width: auto !important;
    padding: 15px 40px !important;
}

.cate-tabs.quote-tabs ul li a.active,
.cate-tabs.quote-tabs ul li:hover a {
    color: #161414 !important;
    background: #fff !important;
    opacity: 1 !important;
    border: 2px solid #ffffff !important;
}

.cate-tabs.quote-tabs ul#nav-tab {
    display: flex;
    justify-content: flex-start;
}
.quote-content-inner {
    padding: 18px;
    border-radius: 12px;
    background: #1b1919;
}

.quote-content-inner h3 {
    color: #fff;
    font-size: 22px;
    line-height: 34px;
    margin: 0 0 10px;
}

.price-profit {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0 20px;
}

.price-profit span {
    text-transform: uppercase;
    color: rgb(255 255 255 / 50%);
    font-size: 12px;
    line-height: 24px;
    display: block;
}

.price-profit h4 {
    color: #fff;
    font-size: 22px;
    line-height: 30px;
    margin: 5px 0 0;
}

.right-profit h4 {
    color: #40cc57;
}

.quote-by {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.user-img {
    margin-right: 20px;
}

.quote-by span {
    text-transform: uppercase;
    color: rgb(255 255 255 / 50%);
    font-size: 15px;
    line-height: 24px;
    display: block;
}

.quote-by h4 {
    color: #fff;
    font-size: 18px;
    line-height: 26px;
    margin: 0px 0 0;
}
.quote-tab-content-main {
    margin-top: 30px;
}
.quote-content-inner a {
    text-decoration: none !important;
}
.item-title h3 {
    color: #fff;
    opacity: 0.5;
    font-size: 24px;
    text-transform: uppercase;
}

.item-title a {
    background: #fff;
    width: 175px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
    color: #1f2020;
    font-size: 16px;
    font-weight: 600;
    text-decoration: none;
}

.iten-cart-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.qupte-img {
    width: 190px;
    height: 140px;
    background: rgb(255 255 255 / 4%);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    padding: 4px;
}

.qupte-img img {
    max-width: 100%;
    height: auto;
}

.quote-content-details h3 {
    font-size: 24px;
    line-height: 30px;
    margin: 0;
    color: #fff;
    margin-bottom: 12px;
}

.quote-content-details p {
    font-size: 18px;
    line-height: 24px;
    margin: 0;
    opacity: 0.6;
}

.quote-row-inner {
    display: flex;
    align-items: center;
}

.quote-content-details {
    margin-left: 25px;
    width: calc(100% - 215px);
}

.cont-price {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.cont-price input,
.cont-price select {
    width: 60px;
    height: 30px;
    background: transparent;
    outline: none;
    border: none;
    border-bottom: 1px solid #333131;
    color: #fff;
}

.cont-price span {
    color: #fff;
    opacity: 0.5;
    font-size: 16px;
    line-height: 20px;
    margin-right: 20px;
}

.cont-price {
    color: #fff;
    font-size: 20px;
    line-height: 24px;
    width: 100%;
    margin-top: 12px;
}

.item-cost.apply-dis {
    display: flex;
    align-items: center;
    margin-left: 30px;
    background: #1f1d1d;
    padding: 6px 15px;
    border-radius: 5px;
}

.item-cost.qnty {
    margin-left: 30px;
}

.item-cost.apply-dis b {
    color: #fff;
    opacity: 0.5;
    font-size: 16px;
    line-height: 20px;
    margin-right: 20px;
    margin-left: 20px;
    font-weight: 400;
}

.input-dis input {
    border: none;
    width: 50px;
    padding: 0;
    text-align: right;
    padding-right: 12px;
}

.input-dis {
    border-bottom: 1px solid #333131;
}

.input-dis span {
    margin: 0;
}
.item-in-cart-main {
    margin-bottom: 10px;
    margin-top: 30px;
}
.cont-price-left {
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.cont-price select option {
    color: #333;
    font-size: 16px;
}
.pack-main .cont-price {
    justify-content: flex-start;
}
.pack-main > h3 {
    color: #fff;
    font-size: 28px;
    margin-bottom: 35px;
}

.pack-main {
    background: #1d1b1b;
    padding: 40px;
    border-radius: 15px;
}
.packag-main {
    margin-top: 40px;
}
.quote-row + .quote-row {
    border-top: 1px solid #262424;
    margin-top: 30px;
    padding-top: 30px;
}
.add-cart-left {
    width: 40%;
    display: flex;
}

.add-cart-left .item-title + .item-title {
    margin-left: 15px;
}

.add-cart-left .item-title a {
    width: auto;
    padding: 0 30px;
}

.add-to-cart-inner {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
}
.add-cart-right ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.add-cart-right ul li {
    color: #fff;
    font-size: 30px;
    line-height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.add-cart-right {
    width: 26%;
}

.add-cart-right ul li span {
    opacity: 0.5;
}

.add-cart-right ul li + li {
    margin-top: 5px;
}
/*popup */
.popup-inner {
    background: #1f2020;
    width: 1250px;
    border-radius: 25px;
    padding: 40px;
    position: relative;
}

.popup-main {
    background: rgb(18 17 17 / 88%);
    position: absolute;
    top: 5%;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 10;
}

.admin-screen {
    position: relative;
}
.popup-main {
    background: rgb(18 17 17 / 90%);
    position: absolute;
    top: 5%;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
}

.admin-screen {
    position: relative;
}

.popup-inner {
    background: #1f2020;
    width: 1150px;
    border-radius: 25px;
    position: relative;
    top: 3%;
    padding: 40px;
}

.poppup-close-btn {
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
    z-index: 999;
}

.popup-content h3 {
    color: #fff;
    font-size: 40px;
    margin: 0 0 25px;
}

.popup-content {
    background-color: transparent !important;
    width: fit-content !important;
}

.popup-form label {
    margin: 0;
    color: #fff;
    opacity: 0.5;
    font-size: 14px;
    line-height: 20px;
    display: block;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.8px;
}

.popup-form input,
.popup-form select,
.popup-form textarea {
    background: transparent;
    border: none;
    outline: none;
    width: 100%;
    color: #fff;
    padding: 8px 0;
    border-bottom: 1px solid rgb(255 255 255 / 10%);
    border-radius: 0;
    resize: none;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
}

.popup-form input::placeholder,
.popup-form select::placeholder {
    color: #fff;
}
.field-has {
    margin-top: 35px;
}

.field-has.fullwidth {
    width: 75%;
}

.field-has.halfwidth {
    width: 45%;
}

.field-has.halfwidth-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 75%;
}

.field-has.halfwidth-main .field-has {
    margin: 0;
}
.popup-btn-submit {
    margin-top: 35px;
}
.popup-main {
    display: none;
}
.popup-main.active {
    display: flex !important;
}
.popup-form select option {
    color: #333;
}
/*popup end*/
.title-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
}

.sales-inner-box {
    padding: 30px;
    border-radius: 12px;
    background: #1b1919;
    text-align: center;
}

.sales-inner-image img {
    width: 110px;
    height: 110px;
    border-radius: 100%;
    object-fit: cover;
    object-position: top;
}

.sales-title {
    color: #fff;
    font-size: 30px;
    line-height: 34px;
    margin: 0;
    position: relative;
    display: inline-block;
}

.sales-inner-image {
    margin-bottom: 12px;
}

.sales-title.online:after {
    content: "";
    background: #40cc57;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    position: absolute;
    top: 7px;
    right: -25px;
}

.totl-revenue span {
    text-transform: uppercase;
    color: rgb(255 255 255 / 50%);
    font-size: 12px;
    line-height: 21px;
    display: block;
}

.totl-revenue h5 {
    color: #fff;
    font-size: 22px;
    line-height: 25px;
    margin: 8px 0 0;
}

.totl-revenue {
    margin-top: 20px;
}

.send-chat-btn a {
    text-decoration: none;
    display: inline-block;
    background: #3478ff;
    color: #fff;
    font-size: 16px;
    width: 170px;
    height: 50px;
    line-height: 50px;
    border-radius: 45px;
}

.send-chat-btn {
    margin-top: 20px;
}
.sale-main {
    margin-bottom: 30px;
}
.field-has.add-photo-box {
    display: flex;
    align-items: center;
}

.field-has.add-photo-box .item-title {
    margin-left: 35px;
}
.regis-product-main {
    margin-top: 60px;
}
.reg-pro-title-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.reg-pro-title-btn h3 {
    margin: 0;
}

.reg-pro-title-btn {
    margin-bottom: 12px;
}

.cont-price.regis-product-content span {
    display: block;
    margin-bottom: 8px;
}

.cont-price.regis-product-content {
    justify-content: flex-start;
}

.cont-price.regis-product-content .item-cost {
    min-width: 15%;
}
.reg-pro-title-btn h3 a {
    color: #fff;
    text-decoration: none;
}
.popup-content h5 {
    /* background: rgb(255 255 255 / 25%); */
    /* display: inline-block; */
    width: 170px;
    font-size: 15px;
    color: #fff;
    /* text-align: center; */
    /* line-height: 45px; */
    border-radius: 60px;
    /* margin: 0 0 0 40px; */
}
.popup-content.pro-reg-pop h3 {
    margin: 0;
}
p[contentEditable="true"]:empty:before {
    content: attr(data-placeholder);
    color: #b1a4a4; /* Set placeholder color */
}
.popup-content.pro-reg-pop {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.quote-content-details-popup .cont-price.regis-product-content {
    flex-wrap: wrap;
}

.quote-content-details-popup .cont-price.regis-product-content .item-cost {
    width: 33.3%;
    margin-top: 30px;
}

.quote-content-details-popup .reg-pro-title-p.cont-price p {
    font-size: 16px;
    line-height: 26px;
    margin-top: 8px;
}
.main-thumb-left {
    display: flex;
    align-items: stretch;
    margin-top: 40px;
    margin-bottom: 30px;
}
.ads-thumnails {
    width: 100%;
    height: calc(33.3% - 9px);
    border-radius: 15px;
    cursor: pointer;
    background: rgb(255 255 255 / 5%);
    max-width: 100%;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.ads-thumnails img {
    max-width: 100%;
    height: 100%;
}
.ads-main-img {
    width: calc(100% - 255px);
    border-radius: 15px;
    overflow: hidden;
    background: rgb(255 255 255 / 5%);
    height: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}
.ads-main-img img {
    height: auto;
    max-width: 100%;
}
.ads-thumnails-main {
    width: 240px;
    margin-left: 15px;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 0;
    justify-content: space-between;
    height: 350px;
}
.sales-title h4 {
    font-size: 20px;
}
.helllo-name h3 {
    color: #fff;
    font-size: 40px;
    line-height: 58px;
}

.helllo-name h3 span {
    display: block;
    font-size: 30px;
}

.helllo-name {
    margin-bottom: 50px;
    display: block;
}
.pro-tab.cate-tabs ul#nav-tab li a {
    display: flex;
    flex-direction: column;
    border-radius: 15px;
    padding: 40px 0 !important;
}

.pro-tab.cate-tabs ul#nav-tab li {
    width: 32%;
}

.pro-tab.cate-tabs ul#nav-tab li img {
    max-width: 155px;
    height: auto !important;
    margin: 0 auto;
}

.pro-tab.cate-tabs ul li a.active,
.pro-tab.cate-tabs ul li:hover a {
    background: transparent !important;
    color: #fff !important;
}
.pro-main .reg-pro-title-btn h3 {
    display: flex;
    align-items: center;
}

.pro-main .reg-pro-title-btn h3 .feature {
    width: 140px;
    margin-left: 30px;
}

.pro-main .reg-pro-title-btn h3 input {
    width: 15px;
    margin-right: 7px;
}

.pro-main .reg-pro-title-btn h3 label {
    font-size: 16px;
    margin: 0;
}
.pro-main .item-cost {
    color: #40cc57;
}

.pro-main .item-cost.red {
    color: red;
}
.pro-main .item-title.showing a {
    background: #3478ff;
    color: #fff;
}
.pro-main .item-title.showing a i.fa {
    margin-right: 7px;
}
.item-title.hidden a {
    background: rgb(255 255 255 / 10%);
    color: #fff;
}

.item-title.hidden a i.fa {
    margin-right: 7px;
}
a.add-feat {
    transition: 0.3s;
    font-size: 20px;
    line-height: 24px;
    display: table;
    padding: 11px 48px;
    color: #fff !important;
    border-radius: 60px;
    text-decoration: none;
    outline: none;
    border: 2px solid #fff;
    margin-left: 15px;
}
.popup-btn-submit.pro-btn-two {
    display: flex;
    align-items: center;
}
.detail-view-left {
    width: 50%;
    display: flex;
    align-items: center;
}

.detail-con {
    margin-left: 20px;
}

.detail-con h3 {
    color: #fff;
    font-size: 28px;
    line-height: 34px;
    margin: 0 0 9px;
}

.detail-con h5 {
    color: #fff;
    opacity: 0.5;
    font-size: 15px;
    margin: 0 0 10px;
}

.detail-con h4 {
    color: #ffff;
    opacity: 0.7;
    font-size: 18px;
}

.detail-con h4 span {
    opacity: 0.5;
    font-size: 15px;
}
.detail-view-right {
    width: 50%;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
}

.detail-view-right a {
    text-align: center;
}

.detail-view {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.detail-view-right .send-chat-btn {
    margin-top: 5px;
    display: flex;
    justify-content: flex-end;
}
.chart-img {
    margin-top: 50px;
}
.remove-dealer a {
    color: red;
    padding-left: 20px;
}

.remove-dealer {
    margin-top: 20px;
}
.dealer-ass > h5 {
    font-size: 30px;
    color: #fff;
    opacity: 0.6;
    margin-bottom: 20px;
}

.dealer-ass {
    margin-top: 50px;
}
.detail-view-right .send-chat-btn a + a {
    margin-left: 12px;
}

.detail-view-right .send-chat-btn.client-more-detail a {
    background: #272424;
}

.detail-view-right .send-chat-btn.client-more-detail {
    margin-top: 18px;
}
.bix-det-view h3 {
    color: #fff;
    margin: 0;
    font-size: 24px;
}

.bix-det-view {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.client-ass {
    margin-top: 50px;
}
.order-list ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.order-list ul li {
    background: #343232;
    border-radius: 6px;
    text-align: left;
    padding: 25px 28px;
    color: #fff;
    font-size: 20px;
}

.order-list ul li + li {
    margin-top: 12px;
}

.order-list {
    margin-top: 30px;
    height: 380px;
    overflow-y: auto;
    padding-right: 10px;
}
.scrol-bar::-webkit-scrollbar {
    width: 4px;
}

/* Track */
.scrol-bar::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0px grey;
    border-radius: 10px;
}
/* Handle */
.scrol-bar::-webkit-scrollbar-thumb {
    background: #6a6a6a;
    border-radius: 10px;
}

/* Handle on hover */
.scrol-bar::-webkit-scrollbar-thumb:hover {
    background: #6a6a6a;
}
.reg-pro-list img {
    max-width: 130px;
}

.reg-pro-list .qupte-img {
    width: 140px;
    height: 100px;
}

.reg-pro-list .quote-content-details {
    text-align: left;
}
.reg-pro-list {
    margin-top: 30px;
    height: 380px;
    overflow-y: auto;
    padding-right: 10px;
}
.chart-img img {
    max-width: 100%;
}
.ticket-box {
    background: #1b1919;
    border-radius: 25px;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
}

.ticket-box-left {
    padding: 28px;
    width: 70%;
}

.ticket-title h3,
.ticket-title h3 a {
    color: #fff;
    font-size: 26px;
    line-height: 34px;
    margin: 0;
    text-decoration: none;
}

.send-chat-btn.tick-btn a {
    width: auto;
    padding: 0 20px;
}
.send-chat-btn.tick-btn {
    margin: 0;
    margin-left: 40px;
}

.ticket-title {
    display: flex;
    align-items: center;
}
.tick-date h4,
.tuckt-desc h4 {
    color: #fff;
    opacity: 0.5;
    font-size: 14px;
    text-transform: uppercase;
}

.tick-date p,
.tuckt-desc p {
    font-size: 14px;
    line-height: 24px;
}

.tuckt-desc {
    margin-top: 20px;
}

.ticket-title {
    margin-bottom: 20px;
}
.ticket-box-right {
    width: 30%;
    background: #272525;
    padding: 30px;
    border-radius: 0 25px 25px 0;
}

.notes-main-sc .tick-date + .tick-date {
    margin-top: 15px;
    padding-top: 14px;
    border-top: 1px solid #353333;
}
.notes-main-sc.scrol-bar {
    height: 200px;
    overflow-y: auto;
    padding-right: 10px;
}
.ticket-row + .ticket-row {
    margin-top: 30px;
}
.tick-green a {
    background: #40cc57;
}
.tick-gray a {
    background: #494747;
}

.tick-det .ticket-box {
    background: transparent;
    border-radius: 0;
}

.tick-det .ticket-box .ticket-box-left {
    padding-left: 0;
}

.tick-det .ticket-box .ticket-box-left .tick-poin {
    position: relative;
    padding-left: 30px;
}

.tick-det .ticket-box .ticket-box-left .tick-poin:before {
    content: "";
    width: 15px;
    height: 15px;
    border-radius: 100%;
    background: #ffffff;
    position: absolute;
    left: 0;
    top: 8px;
    opacity: 0.2;
}

.tick-det .ticket-box .ticket-box-left .tick-poin:after {
    content: "";
    width: 3px;
    height: 70%;
    border-radius: 0;
    background: #ffffff;
    position: absolute;
    left: 6px;
    top: 33px;
    opacity: 0.2;
}
.tick-poin h3 {
    font-size: 26px;
    color: #fff;
    margin-bottom: 15px;
}

.tick-poin p {
    font-size: 15px;
    line-height: 27px;
}

.tick-poin p span {
    display: block;
    margin-bottom: 2px;
}

.tick-det .ticket-box .ticket-box-left .tick-poin + .tick-poin {
    margin-top: 40px;
}
.ticket-box-right.tick-det-not {
    background: transparent;
    padding: 0;
    border-radius: 0;
}

.ticket-box-right.tick-det-not .notes-main-sc {
    background: #272525;
    padding: 30px;
    border-radius: 20px;
}

.ticket-box-right.tick-det-not .notes-main-sc + .notes-main-sc {
    margin-top: 30px;
}
/*chat box */
.group-chat-left {
    width: 70%;
    background: #222020;
    border-radius: 12px;
    box-shadow: 0 0 10px #0e0e0e;
    padding: 20px 30px;
}
.chat-box-right .group-chat-left {
    width: 100%;
    width: 340px;
    padding: 12px;
    border-radius: 12px 12px 0 0;
}
.group-chat-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 22px;
    border-bottom: 1px solid rgb(51 48 48);
    margin-bottom: 30px;
}
.group-chat-bar-left {
    display: flex;
    align-items: center;
}
.comnam {
    margin-left: 13px;
}
.comnam h3 {
    color: #fff;
    font-size: 22px;
    line-height: 30px;
    margin: 0px 0 2px;
}
.comnam h4 {
    color: #fff;
    font-size: 13px;
    line-height: 13px;
    margin: 4px 0px 0;
    opacity: 0.4;
}
.member-chats ul {
    display: flex;
    flex-direction: column;
    width: 100%;
}
.chat-box-right .member-chats ul {
    min-height: 260px;
    padding: 0;
}
.member-chats li {
    display: flex;
    margin-bottom: 45px;
    max-width: 100%;
}
.member-chats li.right {
    width: 100%;
    flex-direction: column;
}
.list-box {
    display: flex;
    align-items: center;
    width: 100%;
}
.member-chats .list-box {
    align-items: flex-end;
    position: relative;
    width: auto;
}
.member-chats li.right .list-box {
    flex-direction: row-reverse;
}
.member-chats li.right .list-box .mem-chat {
    margin: 0;
    margin-right: 12px;
    border-radius: 12px 12px 0px 12px;
    background: #3478ff;
    margin: 0 !important;
    padding: 12px;
    position: relative;
}
.chat-box-right .group-chat-left .mem-chat p {
    font-size: 14px;
    line-height: 16px;
    color: #fff;
    opacity: 1;
}
.member-chats .list-box .date {
    position: absolute;
    color: #9999a5;
    bottom: -28px;
    right: 0;
}
.member-chats .right .list-box .date {
    right: initial;
    left: 3px;
}
.member-chats .list-box .date h6 {
    font-size: 12px;
}
.chat-box-right .group-chat-left .left .mem-chat {
    background: #2d2b2b;
    border-radius: 12px 12px 12px 0px;
    margin: 0 !important;
    padding: 12px;
}
.chat-type-box {
    display: flex;
    align-items: center;
    border-top: 1px solid rgb(52 51 75 / 8%);
    margin-top: 20px;
    padding-top: 20px;
}
.chat-box-right .chat-type-box {
    padding: 12px 0 0;
    display: none;
}
.chat-type-box textarea {
    padding: 20px 0 0;
    resize: none;
    width: 100%;
    border: none;
    outline: none;
}
.chat-box-right .chat-type-box textarea {
    height: 44px;
    padding: 10px 0 0;
    background: transparent;
}
.chat-box-right .chat-type-box button {
    background: #f39721;
    border: none;
    color: #fff;
    width: 40px !important;
    height: 40px;
    border-radius: 100%;
    font-size: 16px;
    font-family: "gilroysemibold";
    margin-left: 20px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    cursor: pointer;
    padding: 0 14px;
    -webkit-appearance: button;
}
.member-chats li a {
    text-decoration: none;
    pointer-events: none;
}
.chat-box-right {
    display: flex !important;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding-right: 20px;
    margin-top: 60px;
}
.no-pad-bottom {
    padding-bottom: 0 !important;
}
/*chat box end*/

/*client CRM*/
.title-quote h3 {
    margin-bottom: 8px;
}

.title-quote {
    margin-bottom: 8px;
}
h4.def-heading {
    color: #fff;
    text-decoration: none;
    font-size: 28px;
    margin-bottom: 20px;
}
.cont-price.regis-product-content-quote-client-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
}

.cont-price.regis-product-content-quote-client-left {
    width: 40%;
    justify-content: flex-start;
}

.cont-price.regis-product-content-quote-client-left .item-cost + .item-cost {
    margin-left: 30px;
}

.cont-price.regis-product-content-quote-client-right {
    width: 30%;
    display: flex;
    justify-content: flex-end;
}
.regis-product-content-quote-client-main .item-cost {
    min-width: auto;
}

.regis-product-content-quote-client-main .item-cost span {
    display: inline-block;
}
.regis-product-main-quo-inner {
    background: #1d1b1b;
    border-radius: 25px;
    padding: 0;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
}

h4.def-heading span {
    color: #fff;
    opacity: 0.4;
    font-size: 14px;
    margin-left: 20px;
}

h4.def-heading span i {
    font-style: normal;
}

h4.def-heading {
    display: flex;
    align-items: center;
}

.list-slider-inner {
    background: #262424;
    padding: 20px;
    border-radius: 20px;
    margin-right: 12px;
}

.list-slider-inner img {
    display: table;
    margin: 0 auto;
    max-width: 100%;
}
.title-desc h3 {
    color: #fff;
    font-size: 18px;
    line-height: 24px;
    margin: 0;
}

.title-desc {
    margin-top: 20px;
}

.title-desc h4 {
    color: #fff;
    font-size: 14px;
    line-height: 24px;
    opacity: 0.4;
    margin: 5px 0 0;
}

.title-desc h2 {
    font-size: 20px;
    font-weight: 400 !important;
    margin-top: 4px;
    line-height: 30px;
}
.slick-next:before {
    content: "" !important;
    width: 11px !important;
    height: 20px !important;
    position: absolute;
    left: -12px;
    top: 0;
}
.slick-prev:before {
    content: "" !important;
    width: 11px !important;
    height: 20px !important;
    position: absolute;
    left: 4px;
    top: 0;
    transform: rotate(180deg);
}
.quot-cl-left {
    width: 78%;
    padding: 30px;
}
.quote-cl-right {
    width: 22%;
    background: #262424;
    border-radius: 25px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}
.status-box h5 {
    background: #e6aa4f;
    border-radius: 40px;
    color: #fff;
    text-align: center;
    font-size: 16px;
    padding: 9px 20px;
}
.status-box.green h5 {
    background: #40cc57;
}

.status-box {
    display: flex;
    align-items: center;
    justify-content: center;
}

.quote-cl-right h4 {
    color: #fff;
    opacity: 0.4;
    text-align: center;
    font-size: 18px;
}

.item-view-all a {
    color: #333;
    background: #fff;
    padding: 12px 30px;
    border-radius: 50px;
    text-decoration: none;
}

.item-view-all {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.total-cost-quote h3 {
    color: #3478ff;
    text-align: center;
    font-weight: 600;
}
.regis-product-main-quo + .regis-product-main-quo {
    margin-top: 30px;
}
.client-crm-account {
    display: flex;
    align-items: center;
}

.client-crm-account .sales-inner-image {
    margin-right: 30px;
}
.account-left-det .popup-inner {
    width: 100%;
    box-sizing: border-box;
    position: static;
}

.account-left-det .popup-inner .field-has.halfwidth-main {
    width: 100%;
}
.sales-inner-image h4 {
    font-size: 28px;
    margin: 20px 0 5px;
    color: #fff;
}

.sales-inner-image h5 {
    color: #fff;
    opacity: 0.4;
    font-size: 16px;
    margin-bottom: 30px;
}

.sales-inner-image {
    text-align: center;
}

.sales-inner-image p {
    opacity: 0.6;
    font-size: 16px;
    line-height: 35px;
}
.row.ac-row {
    display: flex;
    align-items: stretch;
}

.account-left-det.account-right-det .popup-inner {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}
.sales-inner-box.blue-gra {
    background: rgb(52, 120, 255);
    background: linear-gradient(
        0deg,
        rgba(52, 120, 255, 1) 0%,
        rgba(160, 187, 241, 1) 100%
    );
}
.sales-inner-box.green-gra {
    background: rgb(63, 220, 94);
    background: linear-gradient(
        0deg,
        rgba(63, 220, 94, 1) 0%,
        rgba(138, 233, 157, 1) 100%
    );
}

.account-det-gra .sales-inner-box li {
    background: transparent;
    padding: 20px 0 16px;
}

.account-det-gra .sales-inner-box li + li {
    border-top: 1px solid;
    border-radius: 0;
}
/* Track */
.account-det-gra .scrol-bar::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0px #fff;
    border-radius: 10px;
}
/* Handle */
.account-det-gra .scrol-bar::-webkit-scrollbar-thumb {
    background: #fff;
    border-radius: 10px;
}

/* Handle on hover */
.account-det-gra .scrol-bar::-webkit-scrollbar-thumb:hover {
    background: #fff;
}
/*client CRM END*/
/*dealer crm */
.admin-dashboard-right.dealer-accountpage {
    padding: 0;
}

.admin-dashboard-right.dealer-accountpage .quote-main-right {
    padding: 40px 40px 100px;
}

.banner-dealer {
    position: relative;
}

.banner-dealer img {
    width: 100%;
    height: auto;
}

.banner-dealer .banner-text {
    position: absolute;
    bottom: 60px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;
    text-align: center;
}

.banner-dealer .banner-text h3 {
    color: #fff;
    font-weight: 700;
    font-size: 50px;
    line-height: 60px;
    margin-bottom: 10px;
}

.banner-dealer .banner-text p {
    font-size: 24px;
    line-height: 30px;
}
/*dealer crm end*/

/*redefinie-css start*/
.admin-main-dashboard.redefine-crm {
    padding-top: 120px;
    padding-bottom: 90px;
}
.top-menu-inner ul {
    list-style: none;
    margin: 0;
    padding: 0;
    background: #0e0e0e;
    display: flex;
    align-items: center;
    justify-content: center;
}

.top-menu-inner ul li a {
    color: #6a6a6a;
    font-size: 21px;
    text-decoration: none;
    padding: 20px 0;
    display: block;
}

.top-menu-inner ul li + li {
    padding-left: 100px;
}

.top-dashboard-menu {
    border-radius: 12px !important;
    max-width: 80%;
    margin: 0 auto 30px;
    overflow: hidden;
}
.titbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.titbar h2 {
    color: #fff;
    font-family: "Open Sans", sans-serif !important;
    font-size: 48px;
}

.titbar a {
    background: #3478ff;
    color: #fff;
    display: block;
    padding: 11px 20px;
    margin-top: -4px;
    border-radius: 20px;
}

.titbar {
    margin-bottom: 30px;
}
.checkin-group {
    background: #171717;
    border-radius: 12px;
    padding: 30px;
}

.checkin-group-title h3 {
    color: #fff;
    font-size: 30px;
}

.checkin-group-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.checkin-group-title a {
    text-decoration: underline;
    color: #6a6a6a;
    text-underline-position: under;
    font-weight: 600;
}
.inner-box-grp {
    background: #232323;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 230px;
    border-radius: 12px;
}

.group-box .row {
    display: flex;
    align-items: stretch;
}

.group-box {
    margin-top: 20px;
}
.checkin-group + .checkin-group {
    margin-top: 40px;
}
.checkin-group .popup-form {
    max-width: 50%;
}

.checkin-group .field-has.fullwidth {
    width: 100%;
}
.checkin-group button.has-btn {
    background: #fff;
    color: #080808;
    padding: 12px 30px;
}
.checkpbox label {
    text-transform: capitalize !important;
    font-family: "Open Sans", sans-serif;
    font-size: 18px;
    /* color: #3478ff; */
    opacity: 0.5;
    font-weight: 600;
}

label {
}

.checkpbox {
    display: flex;
    align-items: center;
}

.checkpbox input {
    width: 17px;
    position: relative;
    top: 0px;
    height: 14px;
}

.checkpbox label + label {
    margin-left: 21px;
}
.bannerfull-content h3 {
    font-size: 60px !important;
    margin: 0 0 10px;
    color: #fff !important;
}

.full-banner-dash {
    position: relative;
}

.bannerfull-content {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: rgb(0 0 0 / 45%);
    padding: 20px 0;
}

.bannerfull-content p {
    padding-left: 15px;
}
.full-input.dolr input:first-child {
    width: 12px;
}
.full-input.dolr.do_one_time {
    display: flex;
}
.full-input.dolr.do_one_time {
    display: flex;
}

i.fa.fa-calendar {
}

.full-input.date-pic i.fa {
    position: absolute;
    right: 20px;
    top: 13px;
}

.full-input.date-pic {
    position: relative;
}
.white-con {
    background: #fff;
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    border-radius: 20px;
    height: 100%;
}

.white-con-inner {
    width: 100%;
    text-align: left;
    display: flex;
    flex-direction: column;
    height: 100%;
}
.per-img img {
    max-width: 92%;
}

.has-sec-2-group-.home-giv-form .row {
    display: flex;
    align-items: stretch;
}

.white-con-inner h2 {
    color: #fc6060;
    font-size: 80px;
    line-height: 90px;
}

.white-con-inner h3 {
    color: #fc5858;
}

.white-con-inner p {
    color: #000;
    max-width: 450px;
    margin: 0 auto;
    font-size: 20px;
}
.sec-2asd .white-con {
    text-align: left;
}

.sec-2asd .white-con-inner-select {
    display: flex;
    align-items: flex-start;
}
.sec-2asd .white-con-inner-select {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    margin-bottom: 110px;
}
.sec-2asd .col-md-6.white-content {
    min-height: 450px;
}
.has-2statemnt .white-con-inner {
    display: flex;
    align-items: center;
    justify-content: center;
}
.has-2statemnt {
    position: relative;
}
.white-con-inner-select select {
    height: 45px;
    width: 150px;
    padding: 0 4px;
}
.has-2statemnt h2 {
    font-size: 180px;
    position: absolute;
    left: 0;
    opacity: 0.2;
}

.has-2statemnt h4 {
    font-weight: 700;
    text-align: center;
    line-height: 34px;
}
.budg-bo-iunner a {
    text-decoration: none !important;
}
.has-white2 .box-1-giv {
    height: 450px;
    margin: 0;
}
.has-sec-12 .white-con-inner {
    width: 100%;
    text-align: left;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;
}
.give-content3-inner-purple {
    background: rgb(213, 175, 255);
    background: linear-gradient(
        90deg,
        rgba(213, 175, 255, 1) 0%,
        rgba(157, 83, 241, 1) 100%
    );
    border-radius: 20px;
    padding: 20px;
    min-height: 48%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.give-content3-inner-purple h3 {
    color: #fff;
    font-size: 44px;
    line-height: 58px;
}

.titl-eg h3 {
    font-size: 36px;
}

.boton-g-content p {
    color: #000;
    font-size: 20px;
    line-height: 28px;
}
.caht-mem-main-inner {
    background: #171717;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    text-align: center;
}

.caht-mem-main-inner h3 {
    color: #fff;
    font-size: 20px;
    margin: 10px 0 10px;
}

.mem-btn a {
    background: #3478ff;
    color: #fff;
    width: 150px;
    display: block;
    margin: 0 10px;
    padding: 8px 10px;
    border-radius: 5px;
    text-decoration: none;
    transition: 0.3s;
}

.mem-btn {
    display: flex;
    align-items: center;
    margin-top: 22px;
}
.caht-mem-main {
    margin-top: 30px;
}
.mem-btn a:hover {
    background: #204ba0;
}
.box-content-jhas-orange {
    background: rgb(245, 123, 79);
    background: linear-gradient(
        90deg,
        rgba(245, 123, 79, 1) 0%,
        rgba(217, 77, 46, 1) 100%
    );
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48%;
    margin-top: 17px;
}

.box-content-jhas-orange img {
    max-width: 350px;
    height: auto;
    width: 100%;
}

.box-content-jhas {
    height: 50%;
}
.box-content-jhas {
    background: #fff;
    border-radius: 20px;
    padding: 20px;
}

.box-content-jhas h2 {
    color: #000;
    font-size: 35px;
}

.box-content-jhas ul {
    list-style: none;
    padding: 0;
    margin: 20px 0 0;
}

.box-content-jhas ul li {
    font-size: 20px;
}

.box-content-jhas ul li + li {
    margin-top: 13px;
    border-top: 1px solid #ccc;
    padding-top: 12px;
}
.weljor h3.wel-back span {
    display: block;
    font-size: 60px;
    margin-top: 20px;
}
.weljor .not-you-btn a {
    background: #fff;
    color: #4d88fd;
    text-decoration: none;
    text-align: center;
    padding: 12px 10px;
    margin: 5px 0;
    border-radius: 5px;
}

.weljor .not-you-btn {
    width: 250px;
    display: flex;
    flex-direction: column;
}

.weljor .home-about-form {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
h3.wel-back span {
    display: block;
}
.full-input.fwidth textarea {
    resize: none;
    height: 60px;
    margin-top: 20px;
}
.give-form textarea {
    background: 0 0;
    border: none;
    outline: 0;
    border-bottom: 1px solid #fff;
    border-radius: 0;
    padding: 12px 0;
    width: 100%;
    color: #fff;
    color: #fff;
    margin-bottom: 15px;
    font-size: 15px;
    font-family: "Open Sans", sans-serif;
}
.watch-main .white-con-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}
.wahtc-3 .give-content3-inner-purple {
    height: 412px;
}
.give-content3-inner-purple.box-content-jhas-orange {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    margin: 0;
}
.col-md-6.white-content.orange-bg {
    position: relative;
}

img.ab-img {
    position: absolute;
    width: 310px;
    right: 40px;
    top: 20px;
}
.col-md-12.title-co h3 {
    text-align: center;
    color: #fff;
    font-size: 36px;
}

.sec.dont-forget {
    margin-top: 50px;
}

.for-box-innner {
    background: #171717;
    border-radius: 20px;
    padding: 30px;
    color: #fff;
}

.for-box-innner h4 {
    font-size: 22px;
    font-weight: 600;
}

.for-box-innner h5 {
    opacity: 0.7;
    font-size: 16px;
    margin: 15px 0 20px;
    font-family: "Open Sans", sans-serif;
}

.btn-accpt-dec {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
}

.btn-accpt-dec a {
    color: #fff;
    background: #28a830;
    margin: 0 10px;
    width: 190px;
    height: 55px;
    line-height: 55px;
    border-radius: 5px;
    text-align: center;
}
.btn-accpt-dec a + a {
    background: #ff3434;
}
.col-md-12.title-co {
    margin-bottom: 30px;
}
.sec.celife-code {
    margin-top: 50px;
    margin-bottom: 40px;
}

.sec.celife-code h2 {
    color: #fff;
    font-size: 36px;
    margin-bottom: 20px;
}

.sec.celife-code .for-box-innner + .for-box-innner {
    margin-top: 30px;
}

.sec.celife-code .for-box-innner {
    height: 50%;
}

.mainlead {
    display: flex;
}

.lead-img {
    margin-right: 20px;
}

.sec.celife-code p {
    font-size: 18px;
    line-height: 30px;
}
.ful-cob-sec .for-box-innner {
    height: calc(100% + 30px) !important;
}

.ful-cob-sec .for-box-innner ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.ful-cob-sec .for-box-innner ul li + li {
    margin-top: 20px;
    font-family: "Open Sans", sans-serif;
}

.ful-cob-sec .for-box-innner ul li {
    font-family: "Open Sans", sans-serif;
    font-size: 20px;
    line-height: 36px;
}
.titbar.search-field input {
    background: transparent;
    border: 1px solid #3b3939;
    width: 82%;
    height: 60px;
    border-radius: 7px;
    color: #fff;
}
.titbar.search-field input:focus {
    outline: none;
}
.limit-chars-with-dots {
    width: auto;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.cht-box-inner {
    background: #232323;
    border-radius: 8px;
}

.cht-box-inner img {
    width: 100%;
    height: 250px;
}

.peo-con {
    background-color: black;
    padding: 20px 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.peo-con a {
    color: #fff;
}

.cat-main {
    margin-bottom: 30px;
}
.detail-people {
    height: 100%;
    background: #b5cbf6;
    background: linear-gradient(149deg, #b5cbf6 0, #3478ff 100%);
    border-radius: 20px 20px 0 0;
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.fam-left {
    /*width: 75%;*/
    display: flex;
    align-items: self-start;
}

.fam-right {
    width: 25%;
}

.det0pro {
    margin-left: 30px;
}

.det0pro h3 {
    color: #fff;
    font-size: 34px;
    line-height: 48px;
}

.det0pro h5 {
    color: #fff;
}

.det0pro h6 {
    color: #fff;
    margin-top: 60px;
}

.det0pro ul {
    display: flex;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
    margin-top: 15px;
}

.det0pro ul li img {
    max-width: 45px;
}

.det0pro ul li + li {
    margin-left: 10px;
}

.phot-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

.phot-btn a {
    color: #fff;
    background: #377aff;
    padding: 12px;
    border-radius: 6px;
    margin-top: 20px;
}
.fam-right ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.fam-right ul li {
    text-align: center;
    background: rgb(255 255 255 / 22%);
    padding: 12px 20px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
}

.fam-right ul li + li {
    margin-top: 12px;
}

.fam-right ul li p {
    font-size: 18px;
    line-height: 26px;
}
.white-det {
    background: #fff;
    border-radius: 0 0 20px 20px;
}

.white-det ul {
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
    align-items: center;
    justify-content: space-around;
}

.white-det ul li a {
    color: #000;
    font-size: 18px;
    font-weight: 700;
    padding: 16px 0;
    display: block;
}
.col2-info-fam .ful-cob-sec .for-box-innner ul li span {
    opacity: 0.5;
    width: 39%;
    display: inline-block;
}

.col2-info-fam .ful-cob-sec .for-box-innner ul li {
    font-family: "Open Sans", sans-serif !important;
    font-size: 16px;
    line-height: 32px;
}
.check-boxin input {
    width: 15px;
    margin-right: 10px;
}

.check-boxin label {
    font-family: "Open Sans", sans-serif;
    font-size: 19px;
    margin-bottom: 11px;
}

.check-boxin {
    display: flex;
    flex-direction: column;
    margin-top: 17px;
}

.form-edit-pro h4 {
    opacity: 0.6;
}
.for-box-innner h4 {
    opacity: 0.6;
}

.form-edit-pro {
    margin-bottom: 30px;
}
.rest-pas input {
    border: none;
    background: transparent;
    outline: none;
    border-bottom: 1px solid #3c3c3c;
    padding: 10px 0;
    border-radius: 0;
}

.rest-pas input[type="submit"] {
    color: #fff;
    color: #fff;
    background: #377aff;
    padding: 12px 30px;
    border-radius: 6px;
    margin-top: 20px;
    margin-left: 20px;
    width: auto;
}
.col2-info-fam .ful-cob-sec .for-box-innner ul li span {
    opacity: 0.5;
    width: 27%;
    display: inline-block;
    font-family: "Open Sans", sans-serif;
}
.bel-asign-team a {
    color: #fff;
    background: #377aff;
    padding: 12px;
    border-radius: 6px;
    margin-top: 20px;
    margin-right: 20px;
}

.tik-bell {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
}

.tik-bell h2 {
    margin: 0 !important;
}

.tik-bell {
}
.new-h .ful-cob-sec {
    margin-bottom: 60px;
}
.has-tim .for-box-innner {
    height: auto !important;
}

.has-tim .col-md-12.for-box.ful-cob-sec {
    margin-bottom: 30px;
}

.new-h .ful-cob-sec h4 {
    font-family: "Open Sans", sans-serif;
}

.new-h .ful-cob-sec h4 span {
    display: block;
    margin-bottom: 12px;
    opacity: 0.6;
}

.new-h .ful-cob-sec h4 {
    opacity: 1;
}
.sec.celife-code h2 span {
    font-size: 14px;
    line-height: 18px;
    position: relative;
    top: -7px;
    left: 20px;
    opacity: 0.6;
}

.bel-asign-team {
    display: flex;
}

.bel-asign-team p {
    margin-right: 20px;
}
.sec.celife-code p {
    font-size: 18px;
    line-height: 30px;
    opacity: 0.6;
}
.che-ans a {
    background: #28a830;
    color: #fff;
    display: inline-block;
    padding: 15px 30px;
    border-radius: 5px;
    margin-top: 40px;
}

.che-ans .tik-bell {
    margin-bottom: 20px;
}
.sch-list + .sch-list {
    margin-top: 30px;
}
.gra-1 {
    background: rgb(252, 57, 95);
    background: linear-gradient(
        90deg,
        rgba(252, 57, 95, 1) 0%,
        rgba(50, 157, 204, 1) 100%
    );
}
.gra-2 {
    background: rgb(177, 101, 176);
    background: linear-gradient(
        90deg,
        rgba(177, 101, 176, 1) 0%,
        rgba(86, 201, 228, 1) 100%
    );
}
.gra-3 {
    background: rgb(242, 124, 133);
    background: linear-gradient(
        90deg,
        rgba(242, 124, 133, 1) 0%,
        rgba(224, 164, 255, 1) 100%
    );
}
.gra-4 {
    background: rgb(21, 158, 142);
    background: linear-gradient(
        90deg,
        rgba(21, 158, 142, 1) 0%,
        rgba(56, 236, 127, 1) 100%
    );
}
.sch-list h3 {
    color: #fff;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.sch-list h3 span {
    font-size: 14px;
    font-weight: 400;
    font-family: "Open Sans", sans-serif;
    /*margin-right: 40px;*/
    /*padding-left: 40px;*/
    text-align: right;
}

.sch-list2 {
    padding: 30px;
    border-radius: 20px;
}
.ad-songinner {
    background: #0e0e0e;
    padding: 30px;
    border-radius: 20px;
    display: flex;
}

.song-img {
    margin-right: 20px;
}

.son-con h3 {
    color: #fff;
    font-size: 16px;
    opacity: 0.6;
    font-family: "Open Sans", sans-serif;
}
.son-con h3 + h3 {
    margin-top: 20px;
}

.son-con h2 {
    color: #fff;
    font-size: 34px;
    margin-bottom: 20px;
}
.ad-song-btn a {
    color: #000;
    background: #fff;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 65px;
    border-radius: 12px;
    font-size: 22px;
    font-weight: 700;
    text-decoration: none;
}
.extrabtn .ad-song-btn {
    display: flex;
    align-items: center;
    margin-top: 30px;
}

.extrabtn .ad-song-btn a {
    width: 280px;
}
.extrabtn .ad-song-btn a + a {
    margin-left: 15px;
}
.popup-btn-submit button {
    background: #3478ff;
    color: #fff;
    display: block;
    padding: 18px 40px;
    border-radius: 5px;
    outline: none;
}
.cht-box-inner .gra-box {
    height: 220px;
    border-radius: 8px 8px 0 0;
}
.cht-box-inner .peo-con {
    padding: 15px;
}

.cht-box-inner .peo-con h3 {
    color: #fff;
}
.cht-box-inner .tag-name {
    position: relative;
    top: 10px;
    left: 10px;
    border-radius: 15px !important;
}
.check-half input[type="checkbox"] {
    width: 15px;
    margin-right: 8px;
    position: relative;
    top: 1px;
}
.gra-box.team-img-box {
    height: auto;
}
.team-box-main .cht-box-inner {
    border-radius: 12px;
    position: relative;
    overflow: hidden;
}
.team-box-main .cht-box-inner .peo-con {
    font-family: "Open Sans", sans-serif;
    position: absolute;
    bottom: 0;
    background: rgb(24 25 26 / 90%);
    width: 100%;
    text-align: left;
    justify-content: flex-start;
}
.team-box-main .cht-box-inner .peo-con h3 {
    font-size: 22px;
    line-height: 28px;
}
.team-bar-inner {
    background: #18191a;
    padding: 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 7px;
}

.team-bar-inner h3 {
    margin: 0;
    color: #fff;
    font-family: "Open Sans", sans-serif;
    font-size: 28px;
    line-height: 38px;
}
.team-bar + .team-bar {
    margin-top: 15px;
}
.popup-form .popup-content {
    margin-top: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.add-person h4 {
    font-family: "Open Sans", sans-serif;
    font-size: 18px;
    color: #fff;
    margin: 0;
    margin-left: 15px;
}
.field-has.fullwidth .add-person {
    margin-top: 30px;
}
.add-person {
    display: flex;
    align-items: center;
}
ul.list-per {
    padding: 0;
    margin: 0;
}

ul.list-per img {
    max-width: 50px !important;
    margin-right: 12px;
}

ul.list-per li {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-family: "Open Sans", sans-serif;
}

ul.list-per {
    display: flex;
}

ul.list-per li + li {
    margin-left: 20px;
}
.main-song-box {
    background: #0e0e0e;
    padding: 20px;
    border-radius: 20px;
}

.main-song.box-inner {
    display: flex;
    align-items: flex-start;
}

.song-content h3 {
    color: #fff;
}

.song-content h4 {
    color: #fff;
    opacity: 0.6;
}

.date-son p {
    font-size: 14px;
    opacity: 0.4;
    margin-left: 10px;
    margin-top: 20px;
}
.titbar.search-field h2 {
    font-family: "Open Sans", sans-serif !important;
    font-weight: 500;
}

.song-title {
    margin-top: 40px;
}
.ver-inner {
    background: #0e0e0e;
    border-radius: 10px;
    padding: 20px;
    font-family: "Open Sans", sans-serif !important;
}

.ver-inner h4 {
    color: #fff;
    font-size: 20px;
    line-height: 30px;
    margin: 0 0 15px;
}

.ver-inner ul li {
    color: #fff;
    font-size: 14px;
}

.ver-inner ul {
    margin: 10px 0 0;
    padding: 0;
    list-style: none;
}

.ver-inner ul li + li {
    margin-top: 12px;
}
.radio-left.ver-inner {
    background: transparent;
    padding: 0;
}

.radio-left.ver-inner ul {
    display: flex;
    align-items: center;
}

.radio-left.ver-inner ul li + li {
    margin: 0 0 0 30px;
}

.radio-left.ver-inner ul li span {
    min-width: 60px;
}
.ver-inner ul li span {
    opacity: 0.5;
    min-width: 70px;
    display: inline-block;
}
.radio-version-inner {
    background: #171717;
    padding: 20px;
    border-radius: 20px;
    margin-top: 20px;
}

.radio-version-inner .song-title {
    margin: 0px;
}
.ver-de h3 {
    color: #fff;
    font-family: "Open Sans", sans-serif !important;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    margin: 0 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.col-md-3.seq-left a {
    background: #3478ff;
    color: #fff;
    display: table;
    padding: 12px 12px;
    border-radius: 5px;
    margin-top: 30px;
    margin: 30px auto 0;
}
.ver-de .row {
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
}
.ver-de .row {
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
}

.seq-left-inner {
    height: 100%;
    background: #0e0e0e;
    border-radius: 15px;
    padding: 20px;
}
.ver-de .row {
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
}

.seq-left-inner {
    height: 100%;
    background: #0e0e0e;
    border-radius: 15px;
    padding: 20px;
}

.int-box {
    background: #0e0e0e;
    border-radius: 15px;
    padding: 20px;
    height: 100%;
    min-height: 210px;
}

.int-box ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

.int-box ul li {
    font-size: 12px;
    font-family: "Open Sans", sans-serif !important;
    color: #fff;
    opacity: 0.5;
}
.seq-right .col-md-4 {
    margin-bottom: 30px;
}
.int-box ul li + li {
    margin-top: 12px;
}
.seq-left-inner ul {
    margin: 20px 0 0;
    padding: 0;
    list-style: none;
}

.seq-left-inner ul li {
    color: #fff;
    font-size: 16px;
    font-family: "Open Sans", sans-serif !important;
    line-height: 24px;
}
.titleaboutLInk a {
    color: #fff;
}
.seq-left-inner ul li + li {
    margin-top: 12px;
}
.ver-de h3 i.fa {
    opacity: 0.5;
}
.seq-main {
    background: rgb(255 255 255 / 5%);
    border-radius: 15px;
    min-height: 450px;
    padding: 20px;
    position: relative;
}
.newpromainwrap {
    /* padding-bottom: 60px; */
}
.seq-main ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
}

.seq-main ul li {
    color: #fff;
    background: transparent;
    width: auto;
    display: flex;
}
.seq-main ul li span {
    background: #3478ff;
    padding: 8px;
    font-size: 13px;
    border-radius: 4px;
}
.seq-right .seq-main ul li span {
    background: #fff;
    color: #000;
}

.seq-main ul li + li {
    margin-top: 10px;
}
.ad-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    background: rgb(20 21 21 / 32%);
    padding: 10px 18px;
    border-radius: 0 0 15px 15px;
}
.ad-label input {
    outline: none;
    border: none;
}
.ad-label button {
    background: transparent;
    border: none;
}

.ad-label button i.fa {
    color: #3478ff;
    font-size: 24px;
}
.song-list-table {
    font-family: "Open Sans", sans-serif;
    color: #fff;
}

.song-list-table th,
.song-list-table td {
    border: none !important;
    color: #fff;
    font-size: 13px;
    font-weight: 400;
}

.song-list-table thead {
    background: rgb(255 255 255 / 9%);
    border-radius: 5px !important;
    overflow: hidden;
    margin-bottom: 10px !important;
}

.song-list-table th {
    opacity: 0.5;
    font-size: 13px;
    font-weight: 400;
}

.song-list-table tbody tr {
    background: #18191a !important;
}

.song-list-table tbody {
}
.song-list-table tbody tr td {
    padding: 15px 0.75rem;
    border-top: 10px solid #080808 !important;
    border-bottom: 10px solid #080808 !important;
}
.song-list-table tbody tr td a {
    color: #fff;
}
.exp-box {
    background: #18191a;
    width: 48%;
    padding: 4%;
    border-radius: 12px;
}

.sch-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.exp-box h3 {
    margin: 0;
    text-align: center;
}

.exp-box.active {
    background: #fff;
}

.exp-box.active h3 {
    color: #18191a;
}
.get-box {
    background: #3478ff;
    color: #fff;
    border-radius: 5px;
    padding: 12px;
    width: 49%;
}

.get-box h4 {
    margin: 0;
    text-align: center;
    font-size: 20px;
    font-family: "Open Sans", sans-serif;
    line-height: 28px;
}

.get-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
}
.sch-main-box {
    font-family: "Open Sans", sans-serif;
    margin-top: 30px;
}

.col-sch-title {
    background: rgb(255 255 255 / 80%);
    padding: 12px 0px;
    text-align: center;
    border-radius: 10px;
}

.sch-col {
    width: 160px;
    height: auto;
}

.col-sch-title h4 {
    line-height: 24px;
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 700;
    padding: 0 10px;
}

.col-sch-title h5 {
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 600;
    margin: 0;
}
ul.dec-sch {
    padding: 0;
    margin: 0;
    background: #18191a;
    list-style: none;
    border-radius: 10px;
    margin-top: 15px;
    overflow: hidden;
}

li.titlesch {
    text-align: center;
    color: rgb(255 255 255 / 60%);
    font-size: 12px;
    background: #131414;
    justify-content: center;
}

ul.dec-sch li {
    padding: 13px 10px;
    color: #fff;
    opacity: 0.8;
    font-size: 12px;
    line-height: 19px;
    display: flex;
    align-items: flex-start;
}

ul.dec-sch li span {
    font-weight: 700;
    opacity: 0.2;
    margin-right: 7px;
    min-width: 36px;
    display: inline-block;
}

input[type="radio"] {
}

.radio-btn input[type="radio"] {
    background: #fff;
    width: 12px;
    height: 12px;
    padding: 0;
    margin: 0;
    -webkit-appearance: radio;
}

.radio-btn i {
    font-size: 10px;
    line-height: 12px;
    font-style: normal;
    text-align: center;
    margin-top: 10px;
}

.radio-btn {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.sch-col + .sch-col {
    margin-left: 15px;
}

.sch-main-box {
    display: flex;
    align-items: flex-start;
}
.send-sch-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
}
li.titlesch.Deptitle {
    background: #0e0e0f;
}
.sch-main-box.center-li {
}

.sch-main-box.center-li ul.dec-sch li {
    justify-content: center;
}
li.circle {
    position: relative;
}

li.circle:before {
    content: "";
    width: 12px;
    height: 12px;
    background: red;
    border-radius: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 15px;
}
li.green.circle:before {
    background: #00ff30;
}
li.orange.circle:before {
    background: #ff7a00;
}
li.red.circle:before {
    background: #ff0000;
}
.radio-btn input[type="radio"]:checked::before {
    display: none;
}
.error {
    color: red;
    font-size: 15px;
}
.select2-container--default.select2-container--open {
    width: 100% !important;
    z-index: 9999999;
}
span.select2.select2-container {
    width: 100% !important;
}
.ui-timepicker-container {
    z-index: 99999 !important;
}
.timer {
    display: none;
}
.active {
    display: block;
}
.add-more-time {
    height: 20px;
    width: 20px;
    position: absolute;
    display: inherit;
}

.menu_icon {
    display: none;
}
/*peoplenew page style */
.row.hasnewpeoplesearch input,
.row.hasnewpeoplesearch select {
    background: transparent;
    border: 1px solid #3b3939;
    width: 100%;
    height: 60px !important;
    border-radius: 7px;
    color: #fff;
    display: block;
    box-shadow: none;
    --ck-color-input-background: none;
}

.hasnewpeoplesearch .titbar.search-field a.btn-blue {
    padding: 18px 20px !important;
    border-radius: 8px !important;
    width: 100%;
    position: relative;
    top: 2px;
    text-align: center;
    font-family: "Open Sans", sans-serif;
}
.row.hasnewpeoplesearch select option {
    color: #000;
}
.card-headerhas {
    font-family: "Open Sans", sans-serif;
    color: #fff;
    font-size: 32px;
    line-height: 40px;
    font-weight: 500;
    margin: 0 0 20px;
}
.titbar.search-field {
}
.cht-box-inner-has-new img {
    width: 100%;
    height: 260px;
    object-fit: cover;
    object-position: center;
}

.hasnewpeoplewrap {
    border-radius: 12px;
    overflow: hidden;
    position: relative !important;
    font-family: "Open Sans", sans-serif;
}
.haseopledeelteBtn {
    position: absolute;
    right: 30px;
    top: 10px;
    margin: 0 !important;
    background: #fff;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}

.peo-con-has {
    background: #171717;
    padding: 15px;
}

.peopplename {
    color: #fff;
    font-size: 18px;
    line-height: 34px;
}

.cht-box-inner-has-new {
    border-radius: 12px;
    overflow: hidden;
}

.actionpeoplebtns a {
    color: #fff;
    opacity: 0.7;
    width: 25%;
    text-align: center;
    text-decoration: underline !important;
    text-underline-position: under !important;
}
.actionpeoplebtns a.sendmes {
    width: 50%;
    text-align: left;
}

.actionpeoplebtns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 5px;
}

/*peoplenew page style end*/

.actionpeoplebtns a + a {
    border-left: 1px solid #343434;
}

.admin-dashboard-right {
    width: calc(100% - 280px);
    padding: 0px 40px 90px;
    margin-top: 0;
}
/* .admin-dashboard-left {
    margin-left: 0px;
    border-radius: 0;
} */
.dashbaoad-main {
    margin-top: 0;
}
.admin-dashboard-right {
}

.top-menu {
    width: calc(100% + 80px);
    margin-left: -40px;
    margin-bottom: 50px;
}

.top-menu-inner ul {
    border-radius: 0 !important;
}
.admin-main-dashboard.redefine-crm {
    padding-top: 0px;
}
.admin-main-dashboard.redefine-crm .container.mb-3 {
    width: 100%;
    margin: 0 !important;
    padding: 0;
    background: #18191a !important;
}
.detpinnercol > ul > li {
    padding: 12px 30px !important;
}
.detpinnercol > ul {
    padding: 0 15px !important;
}
/* .header-menu.newmenuDesign {
    padding-top: 44px;
} */
.hasscheduleNewDesign .detpinnercol > ul {
    padding: 0 !important;
}
.kidboxinner {
    background: #121212;
    padding: 30px 30px;
    border-radius: 20px;
    font-family: "Open Sans", sans-serif;
    color: #fff;
    text-align: center;
    position: relative;
    margin-top: 30px;
}

.kidsbtnAction ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.kidsbtnAction ul li {
    width: 20%;
}

.kidsbtnAction ul li img,
.kidsbtnAction ul li a {
    width: 100%;
    height: auto;
    display: inline-block;
}

.kidsbtnAction {
    margin-top: 20px;
}

.col-md-3.mainkidsbox {
    position: a;
}

.deleeIConkids {
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
}

.kidsContent h3 {
    font-size: 26px;
    line-height: 34px;
    margin-bottom: 8px;
}

.kidsContent h5 {
    color: #fff;
    opacity: 0.5;
    font-size: 18px;
    line-height: 24px;
}

.checkedWrap h4 {
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
    position: relative;
    display: inline-block;
    padding-left: 14px;
}

.checkedWrap.in h4 {
    color: #28a830;
}
.checkedWrap.out h4 {
    color: #ff3434;
}
.checkedWrap {
    position: relative;
    margin-bottom: 8px;
}

.checkedWrap.in h4:before {
    content: "";
    background: #28a830;
    width: 8px;
    height: 8px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 100%;
}
.mainDetailsInnerpage {
    margin-top: 30px;
}
.checkedWrap.out h4:before {
    content: "";
    background: #ff3434;
    width: 8px;
    height: 8px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 100%;
}

.locationKid span {
    background: #414141;
    padding: 10px 15px;
    display: inline-block;
    font-size: 14px;
}

.kidsImage img {
    border-radius: 100%;
    width: 100px;
    height: 100px;
    object-fit: cover;
    object-position: top;
}

.kidsImage {
    margin-bottom: 18px;
}

.locationKid {
    margin-bottom: 25px;
}
.kidsNameCheck .checkedWrap h4 {
    color: #28a830;
    margin: 0 !important;
}
.kidsNameCheck .checkedWrap {
    margin-left: 70px;
}
.kidsNameCheck h3 {
    display: flex;
    contain: content;
    justify-content: flex-start;
}
.kidsDaata ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.kidsDaata ul li {
    color: #fff;
    font-family: "Open Sans", sans-serif;
    font-size: 22px;
    line-height: 34px;
    font-weight: 600;
}

.kidsDaata ul li span {
    opacity: 0.8;
}
.familyDaata ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: start;
}

.familyDaata ul li img {
    width: 35px;
    height: 35px;
    object-fit: cover;
    object-position: top;
    border-radius: 100%;
}

.familyDaata ul li + li {
    margin-left: 10px;
}

.familyDaata {
    margin-top: 30px;
}
.yellowbarInner {
    background: #c49c2c;
    padding: 30px;
    border-radius: 20px;
    margin: 30px 0 0;
}

.yellotitleedit {
    font-family: "Open Sans", sans-serif;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.editbtn {
    font-size: 26px;
}
.tagllgmain {
    font-family: "Open Sans", sans-serif;
    color: #fff;
    display: flex;
    align-items: start;
}

.allegmainleft {
    margin-right: 100px;
}

.allegmainleft ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: start;
}

.allegmainleft ul li + li {
    margin-left: 15px;
}

.allegmainleft ul li {
    padding: 8px 12px;
    background: #fff;
    color: #c49c2c;
    font-weight: 600;
    border-radius: 4px;
}

.allegmainleft h3 {
    font-size: 21px;
    margin: 0 0 11px;
}

.allegmainleft.redTags ul li {
    background: #ff3434;
    color: #fff;
}
.profilekidsboxes .sec.celife-code {
    margin-top: 30px;
}
.familydetkids {
    width: 60%;
    display: flex;
    align-items: center;
}

.kidsFamilyList .kidsbtnAction {
    width: 40%;
}

.kidsFamilyList {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.kidsFamilyList .kidsbtnAction li img {
    max-width: 50px;
    height: auto;
}

.kidsFamilyList .kidsbtnAction ul {
    justify-content: flex-end;
}

.kidsFamilyList .kidsbtnAction ul li + li {
    margin-left: 8px !important;
    margin-top: 0 !important;
}

.familydetkids h3 {
    margin: 0;
    display: flex;
    align-items: center;
    font-size: 20px;
    width: 100%;
    margin-left: 20px;
}

.familydetkids h3 span {
    opacity: 0.4;
    font-size: 16px;
    margin-left: 12px;
}

.familydetkids img {
    width: 60px !important;
    height: 60px !important;
}
.haskidsbox {
    margin-bottom: 30px;
}

.haskidsbox .for-box-innner {
    height: 100% !important;
}
.kidsFamilyList .kidsbtnAction ul li {
    line-height: 16px;
}
.imageeader img {
    width: 100%;
    height: auto;
    border-radius: 15px;
}

.imageleaderText {
    position: absolute;
    bottom: 0;
    left: 0;
    background: rgb(0 0 0 / 68%);
    width: 100%;
    border-radius: 0 0 15px 15px;
}

.leaderimagebox {
    border-radius: 15px;
    overflow: hidden;
}

.leaderimagebox a {
    position: relative;
    border-radius: 15px;
    overflow: hidden;
}

.imageleaderText h2 {
    font-family: "Open Sans", sans-serif;
    color: #fff;
    font-size: 24px;
    font-weight: 500;
    padding: 20px;
    line-height: 24px;
}
.addleaderpop.active,
.addcirculam.active {
    display: flex;
}
.mainPopuphsaNew {
    left: 0;
}
.leaderimagebox.leaderdetailBnnaer img {
    width: 100%;
    height: 350px;
    object-fit: cover;
    object-position: center;
}
.mainTitle h3 {
    color: #fff;
    font-family: "Open Sans", sans-serif;
    font-size: 34px;
    line-height: 44px;
    margin-bottom: 0;
    margin-top: 20px;
}
.leaderimagebox.leaderdetailBnnaer {
    margin-bottom: 30px;
}
.leaderDetailamin .kidsbtnAction ul {
    justify-content: center;
}

.leaderDetailamin .kidsbtnAction ul li + li {
    margin-left: 15px;
}
.editRoombtn a {
    padding: 12px 20px !important;
    border-radius: 5px !important;
    width: 150px;
    position: relative;
    top: 2px;
    text-align: center;
    font-family: "Open Sans", sans-serif;
    background: #fff;
    color: #000;
    font-weight: 600;
    display: inline-block;
    position: absolute;
    right: 30px;
    top: 30px;
}
.leaderimagebox {
    margin-bottom: 30px;
}
.leaderdetailBnnaer {
    position: relative;
}
.checkindetailsmainInner {
    background: #121212;
    padding: 30px 30px;
    border-radius: 15px;
}
.contentDetiails p {
    margin: 0;
    font-size: 18px;
    line-height: 30px;
}
.editbtn i.fa.fa-plus {
    -webkit-text-stroke: 3px #121212;
    font-size: 30px;
    position: relative;
    top: 3px;
    margin-left: 12px;
}
.checkindetailsmainInner.TeamDetailsInner {
    display: block;
}
.checkindetailsmain {
    margin-bottom: 30px;
}
.checkindetailsmainInner .kidboxinner {
    background: #1e1e1e;
}
.yellotitleedit.kidsTitleDetails {
    margin: 0;
}
.kidboxinner.psdMainbox {
    margin: 0;
    text-align: left;
}

.mainkidsbox.psdMainboxwrap:nth-child(n + 5) {
    margin-top: 30px;
}

.kidboxinner.psdMainbox h3 {
    font-size: 24px;
    margin-bottom: 12px;
}

.kidboxinner.psdMainbox h4 {
    font-size: 22px;
}

.kidboxinner.psdMainbox ul {
    list-style: none;
    padding: 0;
    margin: 25px 0 0;
}

.kidboxinner.psdMainbox ul li {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: start;
}
.formFiled textarea {
    height: 90px;
}
.opencirrForm {
    cursor: pointer;
}
.kidboxinner.psdMainbox ul li span {
    margin-left: 11px;
}
@media (max-width: 850px) {
    .dashbaoad-main {
        flex-direction: column;
    }

    .admin-dashboard-right {
        width: 100% !important;
        padding: 0 15px !important;
    }

    .titbar.search-field input {
        width: 66% !important;
    }

    .titbar a {
        width: 32%;
    }

    .eventBoxmain .has-box-inner img {
        height: 200px !important;
    }

    .hasnewBoxDetails h3 {
        font-size: 18px;
        line-height: 24px;
    }

    .hasnewBoxDetails {
        padding: 12px 15px;
    }

    .cht-box-inner img {
        height: 200px;
        object-fit: cover;
        object-position: center;
        border-radius: 12px;
    }
    .eventInnerbarImage .has-box-inner img {
        height: 200px !important;
    }

    .sec.celife-code {
        margin: 0 0 30px !important;
    }

    .for-box-innner {
        padding: 20px 20px !important;
    }

    .newtitleHas {
        font-size: 24px;
        line-height: 30px;
    }

    .sch-list.sch-listMain h3 {
        font-size: 18px;
        flex-direction: column;
        align-items: start;
        line-height: 28px;
    }

    .sch-list.sch-listMain p {
        margin: 0;
    }

    .rightnewtimes ul li {
        width: calc(100% + 40px);
        margin-left: -20px;
    }
    .hasboxinnerlist.gra-1 {
        flex-direction: column;
        align-items: flex-start;
        padding: 20px;
    }

    .listhasleft {
        margin-bottom: 12px;
    }

    .detail-people {
        padding: 20px;
        margin-top: 12px;
        height: auto !important;
    }

    .for-box-innner.ttol.Song .quote-main-right {
        padding: 0 20px;
    }

    .header-main .header-menu ul {
        display: flex;
        flex-direction: column;
        align-items: self-start;
        padding: 21px 0px;
        width: calc(100% + 30px);
        position: absolute;
        left: -30px;
        background: #18191a;
        top: 45px;
        padding: 22px 10px;
        display: none;
    }

    .header-main .header-menu ul li {
        margin: 0;
    }

    .header-main .header-menu ul li + li {
        margin-top: 12px;
    }
    .menu_icon {
        display: block;
        position: absolute;
        right: 20px;
        font-size: 24px;
        top: -16px;
        color: #fff;
    }
    ul.headerMenuhas.showMenu {
        display: block !important;
    }
    .top-menu-inner ul li + li {
        padding-left: 40px !important;
    }
    .fam-left {
        flex-direction: column;
        align-items: center;
    }

    .detail-people {
        flex-direction: column;
        align-items: center;
        border-radius: 12px;
        margin-bottom: 25px;
    }

    .phot-btn {
        margin-bottom: 20px;
    }

    .det0pro {
        margin: 0;
        text-align: center;
        margin-bottom: 30px;
    }

    .det0pro h3 {
        font-size: 22px;
        margin-top: 20px;
    }

    .fam-right {
        width: 100%;
    }

    .fam-right ul li p {
        margin: 0;
    }

    .fam-left a.btn.btn-sm.btn-primary {
        padding: 15px;
        background: #18191a;
        border: 1px solid #18191a;
    }

    .sec.celife-code h2 {
        font-size: 24px;
        line-height: 30px;
    }

    .notify-icon-btn {
        margin-right: 20px;
    }

    .for-box-innner ul li img.add-people-img {
        max-width: 150px;
        height: auto;
        margin-top: 10px;
    }

    .col2-info-fam .ful-cob-sec .for-box-innner ul li span {
        width: 40%;
    }

    .ful-cob-sec .for-box-innner ul li + li {
        margin-top: 12px;
    }

    .ful-cob-sec .for-box-innner ul li {
        font-size: 14px !important;
    }
    .admin-dashboard-right {
        width: 100% !important;
        padding: 0 15px !important;
    }
    .admin-dashboard-right .top-menu {
        display: none;
    }
    .header-Icon {
        max-width: 100% !important;
    }
}

/* font-family: 'Open Sans', sans-serif; */
@media (min-width: 767px) {
    .padding-full {
        padding-right: 15px;
        padding-left: 15px;
    }
    .no-padding {
        padding-left: 0;
        padding-right: 0;
    }
    .no-padding-left {
        padding-left: 0;
    }
    .no-padding-right {
        padding-right: 0;
    }
}
@font-face {
    font-family: frontagebold;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
            format("embedded-opentype"),
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"),
        url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
    font-weight: 400;
    font-style: normal;
}
@font-face {
    font-family: "Open Sans", sans-serif;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___})
            format("embedded-opentype"),
        url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff"),
        url(${___CSS_LOADER_URL_REPLACEMENT_9___})
            format("svg");
    font-weight: 400;
    font-style: normal;
}
p + p {
    margin-top: 15px;
}
.header-menu ul li + li {
    margin-left: 50px;
}

/*landing page*/
.slider-banner-content h1 {
    color: #fff;
    font-size: 70px;
    line-height: initial;
    text-transform: capitalize;
}
.slider-banner-content h1 span {
    font-size: 45px;
    display: block;
}
header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
    padding: 5px 0;
}
.fp-section {
    height: 100vh;
}
.has-title h2 {
    color: #fff;
    font-size: 56px;
    line-height: 74px;
    text-align: center;
}
.has-btn-main a {
    border: 2px solid #fff;
    border-radius: 5px;
    color: #fa7373;
    font-size: 30px;
    line-height: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    margin: 0 40px;
    transition: 0.3s;
    padding: 0 50px;
}
.has-btn-main {
    display: flex;
    align-items: center;
    margin-top: 220px;
    justify-content: center;
}
.has-btn-main a:hover,
.submit-btn input:hover {
    border: 2px solid #fa7373;
    color: #fff;
    background: #fa7373;
}
.fomr-login-has {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 100px;
}
.has-field input {
    background: 0 0;
    border: none !important;
    border-bottom: 1px solid rgb(112 112 112 / 22%) !important;
    width: 710px;
    padding: 12px 0;
    margin-bottom: 12px;
    font-family: "Open Sans", sans-serif;
    color: #fa7373;
    outline: 0;
}
.submit-btn input {
    border: 2px solid #fff;
    border-radius: 5px;
    color: #fa7373;
    font-size: 18px;
    line-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: auto;
    text-decoration: none;
    margin: 0 40px;
    transition: 0.3s;
    background: 0 0;
    width: auto;
    padding: 5px 20px;
    margin: 0;
    transition: 0.3s;
}
.has-field input::placeholder {
    color: #fa7373;
}
.submit-btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 12px;
}
.continue-as-guest a {
    color: #fff;
    text-decoration: underline;
    text-underline-position: under;
    font-size: 36px;
    line-height: 48px;
}
.continue-as-guest {
    margin-top: 70px;
}
/*menu*/
.header-menu ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.header-menu ul li {
    margin: 0 0;
}
header.no-landing {
    background: #171717;
    padding: 15px 0;
}
header.no-landing .row {
    display: flex;
    align-items: center;
}
.inner-sec-has1 h1 {
    font-size: 60px !important;
    text-align: center;
    margin: 0 0 30px;
}
.slider-banner-content {
    width: 100%;
}
.has-sec-1-group .fp-tableCell {
    vertical-align: bottom;
}
.group-content1-inner {
    background: #b694e0;
    background: linear-gradient(167deg, #b694e0 0, #8e53df 100%);
    padding: 50px;
    border-radius: 15px;
}
.group-content h3 {
    font-size: 60px;
    line-height: 80px;
    margin: 0 0 5px;
    color: #fff;
}
.group-content p {
    padding-left: 12px;
}
.ptop .fp-tableCell {
    padding-top: 85px !important;
}

/*footer*/
div#footer-sec {
    background: #171717;
}
.footer-col {
    width: 20%;
    flex: 0 0 20%;
    max-width: 20%;
}
.footer-col h4 {
    font-size: 24px;
    color: #fff;
    font-family: "Open Sans", sans-serif;
    line-height: 52px;
}
.footer-col ul li a {
    color: #fff;
    opacity: 0.4;
    font-family: "Open Sans", sans-serif;
    font-size: 20px;
    font-weight: 400;
    transition: 0.3s;
    text-decoration: none;
}
.footer-col ul li a:hover {
    color: #3478ff;
    opacity: 1;
}
.footer-col ul {
    list-style: none;
    margin: 0;
    padding: 0;
}
.footer-col ul li + li {
    margin-top: 12px;
}
.has-footer-bottom {
    border-top: 1px solid rgb(255 255 255 / 5%);
}
.footer-b-right ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.footer-b-right ul li a i {
    color: #fff;
    font-size: 24px;
    opacity: 0.4;
}
.footer-b-right ul li + li {
    margin-left: 10px;
}
.footer-b-left p {
    color: #fff;
    opacity: 0.4;
    font-size: 18px;
    line-height: 26px;
}
.footer-bottom .row {
    display: flex;
    align-items: center;
}
.footer-bottom {
    padding: 25px 0;
}
.has-footer-top {
    padding: 70px 0;
}

/*home*/
.video-banner-bg {
    /* height: 450px; */
    border-radius: 20px;
}
.banner-title h2 {
    color: #fff;
    font-size: 52px;
    line-height: 70px;
}
.video-banner-bg {
    display: flex;
    align-items: flex-end;
    padding: 0;
    overflow: hidden;
    height: 606px;
}
.tag-name {
    display: table;
    position: relative;
}
.tag-name h4 {
    margin: 0;
    color: #fff;
    font-family: "Open Sans", sans-serif;
    font-weight: 400;
    font-size: 16px;
    padding: 8px 16px;
    position: relative;
    z-index: 10;
}
.blur-bg {
    background: rgb(150 150 150 / 40%);
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 9;
    filter: blur(0.8px);
    border-radius: 3px;
}
.banner-title {
    margin-top: 10px;
}
.play-btn {
    position: absolute;
    z-index: 12;
    top: 46%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.msg-inner-box {
    background: #171717;
    height: 100%;
    border-radius: 20px;
}
.play-btn i {
    color: #fff;
    font-size: 100px;
}
.messages-list {
    height: 88%;
    overflow: hidden;
}
.messages-list {
    height: 88%;
    overflow: hidden;
    padding: 20px;
}
.messages-list ul {
    list-style: none;
    margin: 0;
    padding: 0;
}
.messages-list li span {
    color: #3478ff;
    opacity: 0.5;
    font-size: 16px;
    line-height: 24px;
    font-family: "Open Sans", sans-serif;
    font-weight: 600;
    display: block;
}
.messages-list li {
    font-family: "Open Sans", sans-serif;
    color: #fff;
    opacity: 0.6;
    font-size: 15px;
    line-height: 22px;
}
.messages-list li + li {
    margin-top: 15px;
}
.typing-msg {
    border-top: 1px solid rgb(255 255 255 / 10%);
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    height: 12%;
    padding: 0 20px;
}
.typing-msg form {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
.typbox input {
    background: 0 0;
    border: none;
    outline: 0;
    font-family: "Open Sans", sans-serif;
    padding: 0;
    color: #fff;
    opacity: 0.6;
}
.typbox {
    width: 70%;
}
.btn-submit {
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.btn-submit input {
    width: auto;
    background: #3478ff;
    border: none;
    color: #fff;
    padding: 6px 20px;
    outline: 0;
    display: flex;
}

.take-note-field textarea {
    background: 0 0;
    width: 100%;
    height: 100%;
    outline: 0;
    border: none;
    padding: 25px;
    resize: none;
    color: #fff;
    font-family: "Open Sans", sans-serif;
    height: 100%;
}
.take-note-field {
    height: 100%;
}
.take-notes-inner {
    height: 100%;
    background: #171717;
    border-radius: 20px 0 0 20px;
}
.sermon-left,
.sermon-right {
    background: #131313;
    height: 100%;
    padding: 20px;
}
.sermon-left h4,
.sermon-right h4 {
    color: #fff;
    opacity: 0.2;
    font-size: 20px;
    margin-bottom: 20px;
}
.sermon-left ul li {
    color: #fff;
    opacity: 0.6;
    font-family: "Open Sans", sans-serif;
    padding-left: 5px;
}
.sermon-left ul,
.sermon-right ul {
    margin: 0;
    padding: 0;
    list-style: none;
}
.sermon-left ul li + li {
    margin-top: 18px;
    padding-top: 18px;
    border-top: 1px solid rgb(255 255 255 / 18%);
}
.sermon-right {
    background: #101010;
    height: 100%;
    border-radius: 0 20px 20px 0;
}
.sermon-right ul li {
    color: #fff;
    opacity: 0.6;
    padding-left: 5px;
    font-family: "Open Sans", sans-serif;
}
.sermon-right ul li + li {
    margin-top: 12px;
}
.take-notes-main-right .row {
    height: 100%;
}
.home-img-4 img {
    max-width: 100%;
    display: table;
    margin: 0 auto;
}
.has-sec-5-home .group-content1-inner {
    text-align: center;
    padding: 8% 0;
}
.has-sec-5-home .group-content1-inner h3 {
    color: #fff;
    font-size: 52px;
    line-height: 68px;
}
.home-form-main img {
    max-width: 100%;
}
.homebox-inner h3 {
    color: #fff;
    font-size: 48px;
    line-height: 54px;
}
.homebox-inner p {
    opacity: 0.6;
    font-weight: 400;
    padding-left: 12px;
    font-size: 22px;
    line-height: 32px;
    max-width: 1050px;
}
.homebox-inner {
    margin-top: 15%;
}
.has-sec-1-btm .fp-tableCell {
    vertical-align: bottom;
}
.has-give-sec-2 .group-content1-inner {
    background: #fff;
}
.has-give-sec-2 .group-content1-inner p {
    color: #fa7373;
}
.give-content3-inner {
    background: #f8acac;
    background: linear-gradient(149deg, #f8acac 0, #fc4f4f 100%);
    padding: 50px;
    border-radius: 20px;
}
.give-content3-inner h3 {
    color: #fff;
    text-align: center;
    font-size: 44px;
    line-height: 50px;
    margin: 0;
}
.annual-bo-iunner h4 {
    text-align: center;
    color: #fff;
    margin: 0 0 15px;
}
.annual-bo-iunner {
    border: 2px solid #fff;
    border-radius: 5px;
    padding: 20px 0;
}
.give-con-inner {
    margin-bottom: 60px;
}
.has-sec-5-group .give-content3-inner h3 {
    text-align: left;
}
.has-sec-3-group .give-content3-inner h3 {
    text-align: left;
}
.budg-bo-iunner {
    background: #fff;
    padding: 40px;
    border-radius: 8px;
}
.budg-bo-iunner h4 {
    color: #fa7373;
    font-size: 34px;
    line-height: 45px;
    margin-bottom: 20px;
}
.budg-box {
    margin: 15px 0;
}
.radio-form input {
    width: auto;
    position: relative;
    top: 0;
    margin-right: 6px;
}
.radio-form label {
    width: 100%;
    color: #fff;
}
.radio-form {
    margin: 25px 0 0;
}
.give-form input::placeholder {
    color: #fff;
}
.has-sec-3-group .give-con-inner {
    margin-bottom: 20px;
}
.has-sec-3-group .give-content3-inner {
    padding: 35px;
}
.half-input .full-input {
    width: 46%;
}
.half-input {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
}
.form-checkbox ul li {
    background: #fff;
    color: #fb5656;
    font-size: 14px;
    padding: 6px 10px;
    border-radius: 2px;
    letter-spacing: -2px;
}
.form-checkbox ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
}
.form-checkbox ul li + li {
    margin-left: 12px;
}
.form-checkbox {
    margin: 20px 0;
}

.box-1-giv {
    width: 100%;
    height: calc(50% - 15px);
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px;
    border-radius: 20px;
}
.box-giv-con h5 {
    color: #1d1f20;
    font-size: 40px;
}
.box-giv-con {
    margin-left: 20px;
}
.box-giv-con p {
    color: #fa7b7b;
    font-family: "Open Sans", sans-serif !important;
}
.box-2-giv {
    margin-top: 30px;
}
.home-giv-form .give-content3-inner {
    padding: 35px;
}
.home-giv-form .give-content3-inner h3 {
    text-align: left;
}
.home-giv-form .give-content3-inner .give-con-inner {
    margin-bottom: 20px;
}
.give-content3-inner.home-about-form {
    height: 100%;
    background: #b5cbf6;
    background: linear-gradient(149deg, #b5cbf6 0, #3478ff 100%);
}
.give-content3-inner.home-about-form .submit-btn-give input {
    color: #397bfe;
    margin-bottom: 0 !important;
}
.give-content3-inner.home-about-form .give-form input {
    padding: 15px 0;
    margin-bottom: 18px;
}
.has-bannew {
    height: 75vh;
}

.has-bannew .has-sec1 {
    height: 100%;
    display: flex;
    align-items: center;
}

.has-ptb {
    padding: 30px 0 0 !important;
}
.btp-no-footer {
    padding-bottom: 90px !important;
}
.fullpage-nav {
    padding: 85px 0 0 !important;
}
.fullpage-nav div#footer-sec {
    margin-top: 30px;
}
.has-sec1-group,
.has-sec1-group .container,
.has-sec1-group .row {
    height: 100%;
}

.has-sec1-group .slider-banner-content {
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}
.landing-sec-3 {
    display: none;
    height: 100vh;
    align-items: center;
}
.landing-sec-3.show {
    display: flex;
}
.landing-sec-2 {
    height: 90vh;
    padding: 50px 0 !important;
}

.landing-sec-2 .row {
    display: flex;
    justify-content: center;
    height: 100%;
}

.landing-sec-2 .has-sec-2 {
    height: 100%;
}

.landing-sec-2 .container {
    height: 100%;
}
.has-sec-1-home,
.typnote {
    padding: 30px 0 0 !important;
}
input[type="radio"] {
    width: 18px;
    height: 18px;
    margin: 0;
    -webkit-appearance: none;
    border: 1px solid #fff;
    border-radius: 100%;
    outline: none !important;
    margin-right: 6px;
    position: relative;
    font-size: 16px;
    color: #fff !important;
    padding: 6px 6px;
    position: relative;
    top: 3px;
}
input[type="radio"]:checked::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    background: #fff;
    width: 10px;
    border-radius: 100%;
    height: 10px;
}
.has-bannew-full {
    height: calc(100vh - 86px);
}
.pas-btn a {
    color: #fff;
    text-decoration: underline;
    text-underline-position: under;
    margin-top: 15px;
    display: block;
}
.reg-step-2 {
    display: none;
}

div#resi-video-player {
    width: 100%;
    height: auto;
}
.messages-list {
    height: 88%;
    overflow: hidden;
    padding: 20px;
    max-height: 525px;
    overflow-y: scroll;
}
.messages-list ul {
    padding-bottom: 25px;
}
.scrol-bar::-webkit-scrollbar {
    width: 8px;
}

/* Track */
.scrol-bar::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0px grey;
    border-radius: 10px;
}
.msg-inner-box {
    border-radius: 20px;
    overflow: hidden;
}
/* Handle */
.scrol-bar::-webkit-scrollbar-thumb {
    background: #6a6a6a;
    border-radius: 10px;
}

/* Handle on hover */
.scrol-bar::-webkit-scrollbar-thumb:hover {
    background: #6a6a6a;
}

::-webkit-calendar-picker-indicator {
    filter: invert(1);
}
.no-reg {
    pointer-events: none;
}
div#ifYes {
    display: none;
}
.construction-content {
    text-align: center;
    padding: 100px 0;
}

.construction-content h1 {
    color: #fff;
    padding-top: 30px;
}
.about-content1-inner {
    background: #171717;
    border-radius: 20px;
}

.about-content1-inner a {
    color: #fff;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 40px;
}

.about-content1-inner a h3 {
    font-size: 40px;
    line-height: 48px;
    margin: 25px 0 0;
}
.has-about-sec-2 {
    padding: 60px 0;
}
.beliefs-content h2,
.leader-content h2,
.code-content h2 {
    font-size: 40px;
    color: #fff;
    margin: 0;
    font-weight: 600;
}

.beliefs-content h4 {
    color: #fff;
    font-size: 30px;
    font-weight: 600;
    line-height: 40px;
    margin: 50px 0 10px;
}

.beliefs-content p {
    opacity: 1;
    color: #b4b4b4;
}

.beliefs-content p b {
    font-size: 20px;
    opacity: 1;
    color: #fff;
}

.beliefs-content,
.leader-content,
.code-content {
    padding: 30px 15px;
}
.code-content h4 {
    color: #fff;
    opacity: 0.5;
    font-size: 30px;
    line-height: 38px;
    margin: 0 0 10px;
    text-transform: initial;
}

.code-content h3 {
    color: #fff;
    font-size: 40px;
    line-height: 48px;
    font-family: "Open Sans", sans-serif;
    margin: 0 0 50px;
}
.code-points {
    background: rgb(23 23 23 / 30%);
    padding: 15px;
    border-radius: 15px;
}
.code-points i {
    font-family: "Open Sans", sans-serif;
    font-size: 22px;
    color: #fff;
    opacity: 0.6;
}

.code-points p {
    opacity: 1;
}

.code-points + .code-points {
    margin-top: 15px;
}

.code-content h2 {
    margin-bottom: 30px;
}
.leader-content h3 {
    font-size: 34px;
    color: #fff;
    margin: 20px 0 16px;
    font-weight: 600;
}

.leader-content p {
    font-size: 20px;
}

.leader-content h2 {
    margin-bottom: 40px;
}
.leader-img img {
    width: 100%;
    height: auto;
}

.leader-content .row + .row {
    margin-top: 70px;
}
#page-header-bg h1:after {
    content: "About";
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: #3fb6ab;
    color: transparent;
    opacity: 0.3;
    text-transform: uppercase;
    font-size: 150px;
    position: absolute;
    left: -190px;
    bottom: -135px;
}
.normal_form {
    top: -60px !important;
    width: 100% !important;
}
.swal-overlay {
    z-index: 999999 !important;
}
.map {
    height: 100vh;
    filter: grayscale(100%) invert(92%) contrast(83%);
}

/*anup css start */
/* AN css giving page */
.innerContet {
    background-color: #5f5f5bf2;
    padding: 20px 0px;
}
.innerContet h3 {
    font-size: 20px;
    color: #fff;
}
.innerContet p {
    font-size: 14px;
    color: #fff;
    line-height: 25px;
    font-weight: 500;
}
.givingContentCls .amount input {
    width: 100% !important;
}
.givingContentCls .radio-form label {
    font-weight: 500 !important;
    text-transform: capitalize !important;
    font-family: "Open Sans" !important;
    font-size: 14px;
}
.givingContentCls .giveNow {
    font-size: 13px !important;
    font-weight: 600;
    padding: 10px 30px !important;
    border-radius: 6px;
    margin-bottom: 0px;
}
.givingContentCls .payment-check li {
    border-radius: 5px !important;
}
.givingContentCls .payment-check .frequency {
    font-weight: 600;
    font-size: 10px;
    letter-spacing: -1.9px;
}
/* progress bar */
.give-progressCls .progress {
    border-radius: 8px;
}
.give-progressCls .progress-bar-vertical {
    width: 45px;
    min-height: 100%;
    background: #ececec;
    display: flex;
    align-items: flex-end;
    -webkit-align-items: flex-end;
}

.give-progressCls .progress-bar-vertical .progress-bar {
    width: 100%;
    height: 0;
    transition: height 0.6s ease;
}

.give-progressCls .progress-striped {
    background-image: linear-gradient(#f8a8a8, #fb5151);
    border-radius: 5px;
}
/* progress bar */
.give-progressCls .box-1-giv {
    height: 100%;
}
.right-progressCon {
    height: 100%;
    text-align: center;
}
.right-progressCon h2 {
    font-size: 75px;
    color: #fb6d6d;
}
.right-progressCon span {
    font-size: 38px;
    color: #fb6d6d;
    font-weight: 200 !important;
    padding: 0px 20px;
    position: relative;
}
.right-progressCon span:nth-child(1)::after {
    content: "";
    position: absolute;
    top: 13px;
    right: -5px;
    width: 3px;
    height: 62%;
    background-color: #fb6d6d;
}
.right-progressCon p {
    color: #202020;
    font-size: 15px;
    text-transform: uppercase;
    font-weight: 600;
    line-height: 25px;
    max-width: 70%;
    margin: 0px auto;
    margin-top: 30px;
}
.priceBudgetCls {
    height: 100%;
    width: 100%;
    background: #fff;
    padding: 50px 30px;
    border-radius: 20px;
}
.priceBudgetCls select.recurring_amount {
    border: 1px solid #ccc;
    border-radius: 8px;
    color: #8b8b8b;
    font-size: 13px;
    font-weight: 500;
    padding: 10px 5px !important;
}
.pricCls h5 {
    color: #202020;
    font-size: 22px;
    font-weight: 600;
}
.pricCls h2 {
    font-size: 40px;
    color: #fb6d6d;
    font-weight: 600;
    margin-top: 15px;
    margin-bottom: 15px;
}
.pricNwCls h2 {
    font-size: 100px;
    color: #fff0f0;
    font-weight: 900;
    margin-bottom: 0px;
}
.pricNwCls h5 {
    font-size: 22px;
    color: #202020;
    font-weight: 700;
    margin-bottom: 0px;
    line-height: 29px;
}

/* bar chart */
.charCotCls select.recurring_amount {
    border: 1px solid #fff;
    border-radius: 8px;
    color: #2b2a2a;
    font-size: 13px;
    font-weight: 500;
    padding: 10px 5px !important;
    background: transparent;
    outline: none;
    width: 100%;
}
/* end */
.iconCls img {
    width: 75px;
    height: 75px;
}
.conteCls h3 {
    font-size: 22px !important;
    color: #202020 !important;
    font-weight: 800 !important;
    margin-bottom: 0px;
    line-height: 29px;
    text-align: left !important;
}
.conteCls p {
    color: #fa7373;
    font-size: 14px;
    line-height: 25px;
    margin-top: 10px;
    letter-spacing: 3.1px !important;
}
.vidStCls {
    height: max-content;
}
.tobMiddleHeader {
    background-color: #232323;
    padding: 10px 0px;
    margin: 20px 0px;
}
a.setGoal {
    background: linear-gradient(149deg, #f8acac 0, #fc4f4f 100%);
    padding: 6px 10px;
    border-radius: 5px;
    color: #fff !important;
    font-size: 14px;
}
/* End */
/* Giving page css */
.category-cat-list ul {
    margin: 0px;
}
.category-cat-list ul li {
    display: inline-block;
}
.checkAddress input[type="radio"] {
    width: 30px !important;
    height: 30px !important;
    border-radius: 50px !important;
    margin-right: 0px;
}
.catgry_chose input[type="radio"]:before {
    opacity: 1;
}
.catgry_chose input[type="radio"]:before {
    position: absolute;
    content: "";
    display: block;
    top: 6px;
    left: 11px;
    width: 8px;
    height: 14px;
    border-color: #fff;
    border-style: solid;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
    opacity: 0;
}
.catgry_chose input[type="radio"]:checked::before {
    position: absolute;
    content: "";
    display: block;
    top: -3px;
    left: 1px;
    width: 8px;
    height: 14px;
    border-color: #3679ff;
    border-style: solid;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
    opacity: 1 !important;
    border-radius: unset;
    background-color: unset;
}
.clrGrid input[type="radio"]:checked {
    background-color: #fff;
}
.accList {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.accList h3 {
    margin: 0px;
    font-size: 14px;
    font-family: sans-serif;
    text-transform: capitalize;
    font-weight: 600;
}
.createAcc-contents {
    background-color: #202020;
    padding: 7px 13px;
    border-radius: 10px;
}
.checkAddress {
    width: 30px;
    min-width: 30px;
    height: 30px;
    display: inline-table;
}
.clrGrid {
    background-color: #3478ff;
}
.givingBudget1 {
    background: linear-gradient(149deg, #96e599 0, #50b954 100%);
    text-align: center;
}
.givingBudget1 .pricCls h5 {
    color: #fff;
    line-height: 40px;
    font-weight: 500;
    font-size: 27px;
    margin: 0px;
}
.givingBudget2 {
    background: linear-gradient(149deg, #a9c3f6 0, #4583fd 100%);
    text-align: center;
}
.givingBudget2 .pricCls h5 {
    color: #fff;
    line-height: 40px;
    font-weight: 500;
    font-size: 27px;
    margin: 0px;
}

/* budget css */
.budgetMiddle-header {
    background-color: #c8c8c8;
}
.budgetFrm {
    border-radius: 10px;
    padding: 15px;
    background-color: #171717;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.budgetFrm .give-con-inner h3 {
    font-size: 24px;
    margin: 0px;
}
.budgetFrm .give-con-inner h5 {
    font-size: 18px;
    margin: 0px;
}
.balNc p {
    margin: 0px;
    color: #2d703e;
    text-transform: uppercase;
    font-size: 20px;
    text-align: center;
}
.budgetFrm_inner {
    border-radius: 10px;
    padding: 10px;
    padding-left: 55px;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
}
.budgetFrm_inner .give-con-inner h5 {
    margin: 0px;
    font-size: 16px;
    color: #c6c5c5;
}
.budgetFrm_inner .balNc p {
    margin: 0px;
    color: #c6c5c5;
    text-transform: uppercase;
    font-size: 16px;
    text-align: center;
}
.grenClr p {
    color: #2b5474;
}
.buttonAdd a {
    background-color: #393838;
    display: block;
    width: 30px;
    height: 30px;
    border-radius: 25px;
    color: #ffffff !important;
    text-align: center;
    line-height: 32px;
    font-size: 13px;
    cursor: pointer;
}

/* tooltip css */
.tooltip {
    display: inline;
    position: relative;
}

.tooltip:hover {
    color: #c00;
    text-decoration: none;
}

.tooltip:hover:after {
    background: #111;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 0.5em;
    bottom: 1.35em;
    color: #fff;
    content: attr(title);
    display: block;
    left: 1em;
    padding: 0.3em 1em;
    position: absolute;
    text-shadow: 0 1px 0 #000;
    white-space: nowrap;
    z-index: 98;
}

.tooltip:hover:before {
    border: solid;
    border-color: #111 transparent;
    border-color: rgba(0, 0, 0, 0.8) transparent;
    border-width: 0.4em 0.4em 0 0.4em;
    bottom: 1em;
    content: "";
    display: block;
    left: 2em;
    position: absolute;
    z-index: 99;
}

/*anup css end */

/*schedule css*/
/* .header-menu ul li a {
    font-size: 18px !important;
} */
.header-menu ul li + li {
    margin-left: 30px;
}
.titbar.search-field input {
    font-family: "Open Sans", sans-serif;
    padding: 12px 20px;
}
.hasbtnstyle {
    padding: 18px 20px !important;
    border-radius: 8px !important;
    width: 16%;
    position: relative;
    top: 2px;
    text-align: center;
    font-family: "Open Sans", sans-serif;
}
a.nav-link p {
    margin: 0;
}
.has-box-inner img {
    width: 100%;
    height: auto;
}

.cat-main {
    position: relative;
}

.removebtnHas {
    position: absolute;
    right: 30px;
    top: 10px;
    color: #fff;
    background: #1d1f20;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    display: none;
}

.removebtnHas i {
    font-size: 12px;
    position: relative;
    top: -2px;
    left: 0px;
}

.cat-main:hover .removebtnHas {
    display: flex;
}

.Has-box-inner {
    position: relative;
    overflow: hidden;
    border-radius: 12px;
}

.hasnewBoxDetails {
    position: absolute;
    bottom: 0;
    background: rgb(23 23 23 / 80%);
    padding: 18px 25px;
    width: 100%;
}

.hasnewBoxDetails h3 {
    font-family: "Open Sans", sans-serif;
    color: #fff;
    font-size: 24px;
    line-height: 30px;
    font-weight: 600;
    margin: 0 0 8px;
}

.hasDateBox h4 {
    font-family: "Open Sans", sans-serif;
    color: rgb(255 255 255 / 50%);
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    margin: 0 0 4px;
}
.eventInnerbarImage {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
}
.eventDetailsDetailMain {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.eventDetailsDetailRight a {
    background: #fff;
    color: #171717 !important;
    border: none;
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    font-weight: 600;
}
.newtitleHas {
    font-family: "Open Sans", sans-serif;
    color: #fff;
    font-size: 32px;
    line-height: 40px;
    font-weight: 500;
    margin: 0 0 20px;
}
.sch-listMain > a {
    width: 100%;
}
.sch-list.sch-listMain h3 {
    font-family: "Open Sans", sans-serif;
    color: #fff;
    font-size: 26px;
    line-height: 40px;
    font-weight: 600;
    margin: 0 0 0px;
}
.sch-list.sch-listMain .sch-list2 {
    padding: 20px;
}

.sch-list.sch-listMain p {
    font-size: 16px;
}
.rightnewtimes ul li b {
    font-weight: 600;
}

.rightnewtimes ul li {
    background: rgb(255 255 255 / 4%);
    padding: 10px 30px;
    width: 100%;
    margin-left: -30px;
    padding: 5px 12px !important;
}

.rightnewtimes ul li + li {
    margin-top: 8px !important;
}
.rightnewtimes ul li a.righttimebtn {
    padding: 5px 10px !important;
    border-radius: 4px !important;
    width: 150px;
    position: relative;
    top: 0;
    text-align: center;
    font-family: "Open Sans", sans-serif;
    background: #3478ff;
    color: #fff;
    display: block;
}
.rightnewtimes h5 {
    margin: 25px 0 12px !important;
}
/* body {
    background: #080808 !important;
} */

.listhasleft h4 {
    font-family: "Open Sans", sans-serif;
    color: #fff;
    font-size: 24px;
    line-height: 30px;
    font-weight: 600;
    margin: 0 0 8px;
    opacity: 1 !important;
}
.titledate {
    font-family: "Open Sans", sans-serif;
}
.hasboxinnerlist.gra-1 {
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 12px 12px 0 0;
}
.tab button.tablinks {
    width: 32.3%;
    height: 45px;
    padding: 0px;
    background: rgb(255 255 255 / 20%);
    border-radius: 6px !important;
    color: rgb(255 255 255 / 60%) !important;
    font-family: "Open Sans", sans-serif !important;
    margin: 0 !important;
}

.tab button.tablinks.active,
.tab button.tablinks:hover {
    color: #000 !important;
}
.songListsMain {
    padding: 10px 20px !important;
}

ul#sortableList li.sortable-item {
    margin: 0 0 10px !important;
}
.titleSchedule {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.deptBox {
    background: rgb(255 255 255 / 4%);
    border-radius: 8px;
    padding-bottom: 12px;
}

.for-box-innner h4.deptTitle {
    font-family: "Open Sans", sans-serif;
    opacity: 1;
    font-size: 20px;
    line-height: 24px;
    padding: 12px 15px;
    border-bottom: 1px solid rgb(255 255 255 / 5%);
    margin-bottom: 12px;
}

.for-box-innner .detpinnercol h6 {
    font-family: "Open Sans", sans-serif;
    opacity: 1;
    font-size: 16px;
    line-height: 14px;
    padding: 0px 15px;
    opacity: 0.6;
    font-weight: 600;
    margin: 25px 0 12px;
}

.detpinnercol ul li {
    background: rgb(255 255 255 / 4%);
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.rightList img {
    max-width: 35px;
    border-radius: 0px !important;
    width: auto !important;
    height: auto !important;
    cursor: pointer;
}

.for-box-innner .leftList h5 {
    margin: 0;
    opacity: 1;
    font-weight: 600;
    font-size: 16px;
    position: relative;
}

.status {
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background: #fff;
    position: absolute;
    right: -20px;
    top: 4.5px;
}

.green {
    background: #28a830;
}
.red {
    background: #ff3434;
}
.orange {
    background: #ff7a00;
}
.detpinnercol ul li + li {
    margin: 8px 0 0 !important;
}
.personNeeded a {
    font-weight: 600;
    color: #3478ff;
    text-decoration: underline !important;
    text-underline-position: under !important;
}
.deptBox + .deptBox {
    margin-top: 15px;
}
.tab button.tablinks + button.tablinks {
    margin-left: 1.5% !important;
}
.admin-main-dashboard.redefine-crm {
    overflow: hidden !important;
}
.quote-main-right {
    padding-bottom: 50px;
}
.top-menu-inner ul,
/* .admin-dashboard-left, */
.songsList,
.for-box-innner {
    background: #18191a !important;
}
.sendAddbtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
}

a.hasaddbtnnew {
    background: transparent !important;
    border: none !important;
    outline: none !important;
    padding: 0;
}
button.hasbtnSend,
a.hasbtnnewblue {
    padding: 12px 20px !important;
    border-radius: 8px !important;
    width: auto;
    position: relative;
    top: 2px;
    text-align: center;
    font-family: "Open Sans", sans-serif;
    background: #3478ff;
    color: #fff;
    outline: none !important;
    display: block;
}
a.hasbtnnewblue {
    display: table;
    padding: 7px 25px !important;
    border-radius: 5px !important;
    font-size: 16px !important;
}
img.smallAddbtn {
    max-width: 18px;
}
.for-box-innner h5 a img {
    margin-left: 6px;
}

.eventBoxmain .has-box-inner img {
    width: 100%;
    height: 270px !important;
    object-fit: cover !important;
    object-position: center !important;
}

.eventInnerbarImage .has-box-inner img {
    width: 100% !important;
    height: 350px;
    object-fit: cover;
    object-position: center;
}

/* .header-menu.newmenuDesign ul li a {
    font-family: "Open Sans", sans-serif;
    color: #fff;
} */

/* .header-menu.newmenuDesign ul li a img {
    margin-right: 12px;
}

.header-menu.newmenuDesign ul li a span {
    position: relative;
    top: 1px;
} */
.btn-primary.focus,
.btn-primary:focus {
    box-shadow: none !important;
}
.hasaddbtnnew {
    cursor: pointer;
}

.menuSlideup {
    position: absolute;
    bottom: 130%;
    background: #080808;
    width: 180px;
    right: 0;
    border-radius: 12px;
    padding: 12px 0;
    display: none;
}

.rightbtn {
    position: relative;
}

.menuSlideup ul li a {
    padding: 0px 15px;
    display: block;
    color: #fff !important;
    opacity: 0.9;
    animation-duration: 0.3s;
}

.ful-cob-sec .for-box-innner ul li {
    margin: 0 !important;
    padding: 5px 0;
}

.ful-cob-sec .for-box-innner ul li + li {
    margin-top: 10px !important;
}

.menuSlideup ul li:hover a {
    color: #3478ff;
}

.menuSlideup:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #080808;
    position: absolute;
    right: 17px;
    bottom: -7px;
}

.menuSlideup.show {
    display: block;
}
.hasaddbtnnew img {
    transition: 0.3s;
}

.menuPlusbtn.hasaddbtnnew.activeMenuHas img {
    transform: rotate(45deg);
}

.top-menu-inner.hasdashmenu img {
    opacity: 0.7;
}

/*profile page*/
.profileBluebox {
    height: 100%;
    background: #b5cbf6;
    background: linear-gradient(149deg, #b5cbf6 0, #3478ff 100%);
    border-radius: 20px 20px 0 0;
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.profileBlueboxtop {
    width: 100%;
    display: flex;
    align-items: start;
}

.profilePicture {
    width: 25%;
    text-align: center;
}

.prfileDetailsandFamily {
    width: 50%;
}

.prfileDetailsandFamily h3 {
    color: #fff;
    font-family: "Open Sans", sans-serif;
    font-size: 34px;
    line-height: 44px;
    margin-bottom: 20px;
}
.prfileDetailsandFamily h4 {
    color: #fff;
    font-family: "Open Sans", sans-serif;
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 40px;
    text-transform: uppercase;
}

.prfileDetailsandFamily h6 {
    color: #fff;
    font-family: "Open Sans", sans-serif;
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 10px;
    text-transform: uppercase;
}

a.hasbtnstylepro {
    padding: 10px 10px !important;
    border-radius: 4px !important;
    width: 150px;
    position: relative;
    top: 0;
    text-align: center;
    font-family: "Open Sans", sans-serif;
    background: #3478ff;
    color: #fff;
    display: table;
    margin: 40px auto 0;
}
.condetails {
    width: 25%;
}

.condetails .fam-right {
    width: 100%;
}

.condetails .fam-right li p {
    margin: 0;
}
.col2-info-fam h2 {
    font-family: "Open Sans", sans-serif;
    font-weight: 400 !important;
}
.newprofileInner .for-box-innner ul li img.add-people-img {
    width: auto;
    height: auto;
    margin-right: 12px;
}

.profileBluebox {
    flex-direction: column;
    padding: 0;
    overflow: hidden;
    border-radius: 20px;
}

.profileBlueboxbottom {
    width: 100%;
}

.profileBlueboxtop {
    padding: 30px;
}

.custom-tab-list ul {
    list-style: none;
    margin: 0;
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.custom-tab-list ul li {
    width: 33%;
    text-align: center;
}

.custom-tab-list {
    padding: 20px;
    background: #fff;
    border-radius: 0 0 20px 20px;
}

.custom-tab-list ul li a {
    color: #000;
    font-family: "Open Sans", sans-serif;
    text-transform: uppercase;
    font-weight: 600 !important;
    transition: 0.3s;
}

.custom-tab-list ul li + li {
    border-left: 1px solid #ccc;
}

.custom-tab-list ul li.active a,
.custom-tab-list ul li:hover a {
    color: #3478ff;
}

[class^="box-"] {
    display: none;
}

[class^="box-"].showfirst {
    display: block;
}

.hasnweboxInner {
    border-radius: 20px;
    padding: 30px;
    color: #fff;
    background: #18191a !important;
    margin-top: 60px;
}

.titlenewDrop {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.dropdown select {
    padding: 15px 15px;
    width: 160px;
    background: #2d2f30;
    border: none;
    outline: none;
    border-radius: 10px;
    color: #fff;
    font-size: 16px;
}

.checkboxesadmin h4 {
    color: #fff;
    font-size: 16px;
    margin-bottom: 20px;
    font-family: "Open Sans", sans-serif;
    font-weight: 400 !important;
    text-transform: uppercase;
    opacity: 0.6;
}

h4 {
}

.checkboxesadmin ul li,
.checkboxesadmin ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.checkboxesadmin ul li input {
    width: 15px;
    margin-right: 10px;
}

.checkboxesadmin ul li label {
    font-family: "Open Sans", sans-serif;
    font-weight: 400 !important;
}

.confrmpasschanges input {
    background: transparent;
    border: none;
    border-bottom: 1px solid #ccc;
    padding: 9px 0;
    width: 100%;
    border-radius: 0;
    font-family: "Open Sans", sans-serif;
}

.checkboxesadmin ul {
    margin-bottom: 30px;
}

.confirmpassinner {
    width: 25%;
}

.confrmpasschanges {
    display: flex;
    align-items: center;
}

.confirmpassinner + .confirmpassinner {
    margin-left: 20px;
}

.confirmpassinner.submitconfirmbtn input {
    padding: 10px 10px !important;
    border-radius: 4px !important;
    width: 150px;
    position: relative;
    top: 0;
    text-align: center;
    font-family: "Open Sans", sans-serif;
    background: #3478ff;
    color: #fff;
    display: table;
    margin: 0;
    border: sienna;
}

.involmentBoxmain {
    border-radius: 20px;
    padding: 30px;
    color: #fff;
    background: #18191a !important;
    margin-top: 30px;
}

.titlewithbtnnotification {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
}

.nnotco {
    display: flex;
    align-items: center;
    justify-content: start;
    position: relative;
    margin-left: 20px;
}

.assgnbtnnot {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.assgnbtnnot a {
    padding: 10px 10px !important;
    border-radius: 4px !important;
    width: 150px;
    position: relative;
    top: 0;
    text-align: center;
    font-family: "Open Sans", sans-serif;
    background: #3478ff;
    color: #fff;
    display: table;
}

.notcount {
    background: #3bab43;
    font-family: "Open Sans", sans-serif;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    position: absolute;
    top: -2px;
    right: -9px;
}

.titlewithbtnnotification h3 {
    font-family: "Open Sans", sans-serif;
    margin: 0;
}

.rect-auto,
.c100.p51 .slice,
.c100.p52 .slice,
.c100.p53 .slice,
.c100.p54 .slice,
.c100.p55 .slice,
.c100.p56 .slice,
.c100.p57 .slice,
.c100.p58 .slice,
.c100.p59 .slice,
.c100.p60 .slice,
.c100.p61 .slice,
.c100.p62 .slice,
.c100.p63 .slice,
.c100.p64 .slice,
.c100.p65 .slice,
.c100.p66 .slice,
.c100.p67 .slice,
.c100.p68 .slice,
.c100.p69 .slice,
.c100.p70 .slice,
.c100.p71 .slice,
.c100.p72 .slice,
.c100.p73 .slice,
.c100.p74 .slice,
.c100.p75 .slice,
.c100.p76 .slice,
.c100.p77 .slice,
.c100.p78 .slice,
.c100.p79 .slice,
.c100.p80 .slice,
.c100.p81 .slice,
.c100.p82 .slice,
.c100.p83 .slice,
.c100.p84 .slice,
.c100.p85 .slice,
.c100.p86 .slice,
.c100.p87 .slice,
.c100.p88 .slice,
.c100.p89 .slice,
.c100.p90 .slice,
.c100.p91 .slice,
.c100.p92 .slice,
.c100.p93 .slice,
.c100.p94 .slice,
.c100.p95 .slice,
.c100.p96 .slice,
.c100.p97 .slice,
.c100.p98 .slice,
.c100.p99 .slice,
.c100.p100 .slice {
    clip: rect(auto, auto, auto, auto);
}

.pie,
.c100 .bar,
.c100.p51 .fill,
.c100.p52 .fill,
.c100.p53 .fill,
.c100.p54 .fill,
.c100.p55 .fill,
.c100.p56 .fill,
.c100.p57 .fill,
.c100.p58 .fill,
.c100.p59 .fill,
.c100.p60 .fill,
.c100.p61 .fill,
.c100.p62 .fill,
.c100.p63 .fill,
.c100.p64 .fill,
.c100.p65 .fill,
.c100.p66 .fill,
.c100.p67 .fill,
.c100.p68 .fill,
.c100.p69 .fill,
.c100.p70 .fill,
.c100.p71 .fill,
.c100.p72 .fill,
.c100.p73 .fill,
.c100.p74 .fill,
.c100.p75 .fill,
.c100.p76 .fill,
.c100.p77 .fill,
.c100.p78 .fill,
.c100.p79 .fill,
.c100.p80 .fill,
.c100.p81 .fill,
.c100.p82 .fill,
.c100.p83 .fill,
.c100.p84 .fill,
.c100.p85 .fill,
.c100.p86 .fill,
.c100.p87 .fill,
.c100.p88 .fill,
.c100.p89 .fill,
.c100.p90 .fill,
.c100.p91 .fill,
.c100.p92 .fill,
.c100.p93 .fill,
.c100.p94 .fill,
.c100.p95 .fill,
.c100.p96 .fill,
.c100.p97 .fill,
.c100.p98 .fill,
.c100.p99 .fill,
.c100.p100 .fill {
    position: absolute;
    border: 0.09em solid #000000;
    width: 0.82em;
    height: 0.82em;
    clip: rect(0em, 0.5em, 1em, 0em);
    border-radius: 50%;
    transform: rotate(0deg);
}

.pie-fill,
.c100.p51 .bar:after,
.c100.p51 .fill,
.c100.p52 .bar:after,
.c100.p52 .fill,
.c100.p53 .bar:after,
.c100.p53 .fill,
.c100.p54 .bar:after,
.c100.p54 .fill,
.c100.p55 .bar:after,
.c100.p55 .fill,
.c100.p56 .bar:after,
.c100.p56 .fill,
.c100.p57 .bar:after,
.c100.p57 .fill,
.c100.p58 .bar:after,
.c100.p58 .fill,
.c100.p59 .bar:after,
.c100.p59 .fill,
.c100.p60 .bar:after,
.c100.p60 .fill,
.c100.p61 .bar:after,
.c100.p61 .fill,
.c100.p62 .bar:after,
.c100.p62 .fill,
.c100.p63 .bar:after,
.c100.p63 .fill,
.c100.p64 .bar:after,
.c100.p64 .fill,
.c100.p65 .bar:after,
.c100.p65 .fill,
.c100.p66 .bar:after,
.c100.p66 .fill,
.c100.p67 .bar:after,
.c100.p67 .fill,
.c100.p68 .bar:after,
.c100.p68 .fill,
.c100.p69 .bar:after,
.c100.p69 .fill,
.c100.p70 .bar:after,
.c100.p70 .fill,
.c100.p71 .bar:after,
.c100.p71 .fill,
.c100.p72 .bar:after,
.c100.p72 .fill,
.c100.p73 .bar:after,
.c100.p73 .fill,
.c100.p74 .bar:after,
.c100.p74 .fill,
.c100.p75 .bar:after,
.c100.p75 .fill,
.c100.p76 .bar:after,
.c100.p76 .fill,
.c100.p77 .bar:after,
.c100.p77 .fill,
.c100.p78 .bar:after,
.c100.p78 .fill,
.c100.p79 .bar:after,
.c100.p79 .fill,
.c100.p80 .bar:after,
.c100.p80 .fill,
.c100.p81 .bar:after,
.c100.p81 .fill,
.c100.p82 .bar:after,
.c100.p82 .fill,
.c100.p83 .bar:after,
.c100.p83 .fill,
.c100.p84 .bar:after,
.c100.p84 .fill,
.c100.p85 .bar:after,
.c100.p85 .fill,
.c100.p86 .bar:after,
.c100.p86 .fill,
.c100.p87 .bar:after,
.c100.p87 .fill,
.c100.p88 .bar:after,
.c100.p88 .fill,
.c100.p89 .bar:after,
.c100.p89 .fill,
.c100.p90 .bar:after,
.c100.p90 .fill,
.c100.p91 .bar:after,
.c100.p91 .fill,
.c100.p92 .bar:after,
.c100.p92 .fill,
.c100.p93 .bar:after,
.c100.p93 .fill,
.c100.p94 .bar:after,
.c100.p94 .fill,
.c100.p95 .bar:after,
.c100.p95 .fill,
.c100.p96 .bar:after,
.c100.p96 .fill,
.c100.p97 .bar:after,
.c100.p97 .fill,
.c100.p98 .bar:after,
.c100.p98 .fill,
.c100.p99 .bar:after,
.c100.p99 .fill,
.c100.p100 .bar:after,
.c100.p100 .fill {
    transform: rotate(180deg);
}

.c100 {
    position: relative;
    font-size: 160px;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    float: left;
    margin: 0;
    /* background-color: #dfe8ed; */
}
.c100 *,
.c100 *:before,
.c100 *:after {
    box-sizing: content-box;
}
.c100 > span {
    position: absolute;
    width: 100%;
    z-index: 1;
    left: 0;
    top: 0;
    width: 5em;
    line-height: 5em;
    font-size: 0.2em;
    color: #fff;
    display: block;
    font-weight: 400 !important;
    text-align: center;
    white-space: nowrap;
    transition-property: all;
    transition-duration: 0.2s;
    transition-timing-function: ease-out;
    font-weight: 400 !important;
}
.c100:after {
    position: absolute;
    top: 0.09em;
    left: 0.09em;
    display: block;
    content: " ";
    border-radius: 50%;
    /* background-color: #ffffff; */
    width: 0.82em;
    height: 0.82em;
    transition-property: all;
    transition-duration: 0.2s;
    transition-timing-function: ease-in;
    font-family: "Open Sans", sans-serif;
}
.c100 .slice {
    position: absolute;
    width: 1em;
    height: 1em;
    clip: rect(0em, 1em, 1em, 0.5em);
}
.c100.p1 .bar {
    transform: rotate(3.6deg);
}
.c100.p2 .bar {
    transform: rotate(7.2deg);
}
.c100.p3 .bar {
    transform: rotate(10.8deg);
}
.c100.p4 .bar {
    transform: rotate(14.4deg);
}
.c100.p5 .bar {
    transform: rotate(18deg);
}
.c100.p6 .bar {
    transform: rotate(21.6deg);
}
.c100.p7 .bar {
    transform: rotate(25.2deg);
}
.c100.p8 .bar {
    transform: rotate(28.8deg);
}
.c100.p9 .bar {
    transform: rotate(32.4deg);
}
.c100.p10 .bar {
    transform: rotate(36deg);
}
.c100.p11 .bar {
    transform: rotate(39.6deg);
}
.c100.p12 .bar {
    transform: rotate(43.2deg);
}
.c100.p13 .bar {
    transform: rotate(46.8deg);
}
.c100.p14 .bar {
    transform: rotate(50.4deg);
}
.c100.p15 .bar {
    transform: rotate(54deg);
}
.c100.p16 .bar {
    transform: rotate(57.6deg);
}
.c100.p17 .bar {
    transform: rotate(61.2deg);
}
.c100.p18 .bar {
    transform: rotate(64.8deg);
}
.c100.p19 .bar {
    transform: rotate(68.4deg);
}
.c100.p20 .bar {
    transform: rotate(72deg);
}
.c100.p21 .bar {
    transform: rotate(75.6deg);
}
.c100.p22 .bar {
    transform: rotate(79.2deg);
}
.c100.p23 .bar {
    transform: rotate(82.8deg);
}
.c100.p24 .bar {
    transform: rotate(86.4deg);
}
.c100.p25 .bar {
    transform: rotate(90deg);
}
.c100.p26 .bar {
    transform: rotate(93.6deg);
}
.c100.p27 .bar {
    transform: rotate(97.2deg);
}
.c100.p28 .bar {
    transform: rotate(100.8deg);
}
.c100.p29 .bar {
    transform: rotate(104.4deg);
}
.c100.p30 .bar {
    transform: rotate(108deg);
}
.c100.p31 .bar {
    transform: rotate(111.6deg);
}
.c100.p32 .bar {
    transform: rotate(115.2deg);
}
.c100.p33 .bar {
    transform: rotate(118.8deg);
}
.c100.p34 .bar {
    transform: rotate(122.4deg);
}
.c100.p35 .bar {
    transform: rotate(126deg);
}
.c100.p36 .bar {
    transform: rotate(129.6deg);
}
.c100.p37 .bar {
    transform: rotate(133.2deg);
}
.c100.p38 .bar {
    transform: rotate(136.8deg);
}
.c100.p39 .bar {
    transform: rotate(140.4deg);
}
.c100.p40 .bar {
    transform: rotate(144deg);
}
.c100.p41 .bar {
    transform: rotate(147.6deg);
}
.c100.p42 .bar {
    transform: rotate(151.2deg);
}
.c100.p43 .bar {
    transform: rotate(154.8deg);
}
.c100.p44 .bar {
    transform: rotate(158.4deg);
}
.c100.p45 .bar {
    transform: rotate(162deg);
}
.c100.p46 .bar {
    transform: rotate(165.6deg);
}
.c100.p47 .bar {
    transform: rotate(169.2deg);
}
.c100.p48 .bar {
    transform: rotate(172.8deg);
}
.c100.p49 .bar {
    transform: rotate(176.4deg);
}
.c100.p50 .bar {
    transform: rotate(180deg);
}
.c100.p51 .bar {
    transform: rotate(183.6deg);
}
.c100.p52 .bar {
    transform: rotate(187.2deg);
}
.c100.p53 .bar {
    transform: rotate(190.8deg);
}
.c100.p54 .bar {
    transform: rotate(194.4deg);
}
.c100.p55 .bar {
    transform: rotate(198deg);
}
.c100.p56 .bar {
    transform: rotate(201.6deg);
}
.c100.p57 .bar {
    transform: rotate(205.2deg);
}
.c100.p58 .bar {
    transform: rotate(208.8deg);
}
.c100.p59 .bar {
    transform: rotate(212.4deg);
}
.c100.p60 .bar {
    transform: rotate(216deg);
}
.c100.p61 .bar {
    transform: rotate(219.6deg);
}
.c100.p62 .bar {
    transform: rotate(223.2deg);
}
.c100.p63 .bar {
    transform: rotate(226.8deg);
}
.c100.p64 .bar {
    transform: rotate(230.4deg);
}
.c100.p65 .bar {
    transform: rotate(234deg);
}
.c100.p66 .bar {
    transform: rotate(237.6deg);
}
.c100.p67 .bar {
    transform: rotate(241.2deg);
}
.c100.p68 .bar {
    transform: rotate(244.8deg);
}
.c100.p69 .bar {
    transform: rotate(248.4deg);
}
.c100.p70 .bar {
    transform: rotate(252deg);
}
.c100.p71 .bar {
    transform: rotate(255.6deg);
}
.c100.p72 .bar {
    transform: rotate(259.2deg);
}
.c100.p73 .bar {
    transform: rotate(262.8deg);
}
.c100.p74 .bar {
    transform: rotate(266.4deg);
}
.c100.p75 .bar {
    transform: rotate(270deg);
}
.c100.p76 .bar {
    transform: rotate(273.6deg);
}
.c100.p77 .bar {
    transform: rotate(277.2deg);
}
.c100.p78 .bar {
    transform: rotate(280.8deg);
}
.c100.p79 .bar {
    transform: rotate(284.4deg);
}
.c100.p80 .bar {
    transform: rotate(288deg);
}
.c100.p81 .bar {
    transform: rotate(291.6deg);
}
.c100.p82 .bar {
    transform: rotate(295.2deg);
}
.c100.p83 .bar {
    transform: rotate(298.8deg);
}
.c100.p84 .bar {
    transform: rotate(302.4deg);
}
.c100.p85 .bar {
    transform: rotate(306deg);
}
.c100.p86 .bar {
    transform: rotate(309.6deg);
}
.c100.p87 .bar {
    transform: rotate(313.2deg);
}
.c100.p88 .bar {
    transform: rotate(316.8deg);
}
.c100.p89 .bar {
    transform: rotate(320.4deg);
}
.c100.p90 .bar {
    transform: rotate(324deg);
}
.c100.p91 .bar {
    transform: rotate(327.6deg);
}
.c100.p92 .bar {
    transform: rotate(331.2deg);
}
.c100.p93 .bar {
    transform: rotate(334.8deg);
}
.c100.p94 .bar {
    transform: rotate(338.4deg);
}
.c100.p95 .bar {
    transform: rotate(342deg);
}
.c100.p96 .bar {
    transform: rotate(345.6deg);
}
.c100.p97 .bar {
    transform: rotate(349.2deg);
}
.c100.p98 .bar {
    transform: rotate(352.8deg);
}
.c100.p99 .bar {
    transform: rotate(356.4deg);
}
.c100.p100 .bar {
    transform: rotate(360deg);
}
.c100:hover {
    cursor: default;
}
.c100:hover > span {
    /* width: 3.33em; */
    /* line-height: 3.33em; */
    /* font-size: 0.3em; */
    color: #3c4761;
}
.c100:hover:after {
    top: 0.07em;
    left: 0.07em;
    width: 0.86em;
    height: 0.86em;
}
.c100.blue .bar,
.c100.blue .fill {
    border-color: #30bae7 !important;
}
.c100.blue:hover > span {
    color: #fff;
}
.c100.pink .bar,
.c100.pink .fill {
    border-color: #d74680 !important;
}
.c100.pink:hover > span {
    color: #3c4761;
}
.c100.green .bar,
.c100.green .fill {
    border-color: #15c7a8 !important;
}
.c100.green:hover > span {
    color: #3c4761;
}
.c100.orange .bar,
.c100.orange .fill {
    border-color: #eb7d4b !important;
}
.c100.orange:hover > span {
    color: #3c4761;
}
.rateTitle h4 {
    color: #fff;
    font-size: 16px;
    margin-bottom: 20px;
    font-family: "Open Sans", sans-serif;
    font-weight: 400 !important;
    text-transform: uppercase;
    opacity: 0.6;
    margin: 0;
}

.rateTitle {
    width: 180px;
}

.ratesMain {
    display: flex;
    align-items: center;
}

.involmentDetails ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.serv.col2-info-fam .for-box-innner {
    padding: 0;
    margin-top: 20px;
}

.involRight ul li {
    border-radius: 20px;
    padding: 20px;
    color: #fff;
    background: #18191a !important;
    margin-top: 30px;
    font-family: "Open Sans", sans-serif;
}

.involRight ul {
    padding: 0;
    margin: 0;
    list-style: none;
}

.dateinvol {
    font-family: "Open Sans", sans-serif;
    opacity: 0.6;
    margin-bottom: 12px;
}

.titlewithbtnnotification h3 span {
    font-family: "Open Sans", sans-serif;
    margin: 0;
    font-size: 19px;
    opacity: 0.3;
}

.messgtnotemain .titlewithbtnnotification h3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 200px;
}

.messgtnotemain .titlewithbtnnotification {
}

.notedate {
    font-family: "Open Sans", sans-serif;
    margin: 0;
    margin-right: 30px;
}

.noteDetails p {
    font-size: 16px;
    line-height: 26px;
    opacity: 0.6;
}

.notetypebox {
    border-radius: 20px;
    padding: 30px;
    color: #fff;
    background: #18191a !important;
    margin-top: 30px;
}

.notetextarea textarea {
    width: 100%;
    resize: none;
    background: none;
    outline: none;
    border: none;
    border-bottom: 1px solid #3c3c3c;
    margin-bottom: 20px;
}

.notetypebox .confrmpasschanges {
    display: flex;
    align-items: center;
    justify-content: end;
    margin-right: 0;
}

.notetextarea h5 {
    font-family: "Open Sans", sans-serif;
    margin: 0;
    font-size: 19px;
    opacity: 0.3;
}
.notetypebox .confirmpassinner {
    width: auto;
}
.btngreen a {
    padding: 10px 10px !important;
    border-radius: 4px !important;
    width: 150px;
    position: relative;
    top: 0;
    text-align: center;
    font-family: "Open Sans", sans-serif;
    background: #28a830;
    color: #fff;
    display: table;
    margin: 0;
}
.titlenewDrop h2 {
    margin: 0 !important;
}
/*new profilepage*/
.bannerProfilephoto img {
    width: 100%;
    border-radius: 15px;
    height: 250px;
    object-fit: cover;
    object-position: center;
}

.profilePic {
    border-radius: 100%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
}

.profileimage {
    width: 150px;
    height: 150px;
    border-radius: 100%;
    /* overflow: hidden; */
    margin-left: 35px;
    border: 4px solid #080808;
}

.nameconnection {
    font-family: "Open Sans", sans-serif;
    color: #fff;
    margin-left: 30px;
    margin-top: 50px;
}

.nameconnection h5 {
    opacity: 0.5;
    color: var(--userName);
}

.nameconnection h3 {
    margin-bottom: 15px;
    color: var(--userName);
}

.prfileimageconnection {
    width: 60%;
}

.profileeditmain {
    width: 40%;
    margin-top: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.profileimageEditprofilemain {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    top: -50px;
    border-bottom: 1px solid rgb(255 255 255 / 10%);
    padding-bottom: 50px;
}

.prfileimageconnection {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.newpromainwrap {
    font-family: "Open Sans", sans-serif;
    /* margin-top: 50px; */
}

p.hasnewbtn {
    background: #3478ff;
    color: #fff;
    padding: 6px 25px;
    border-radius: 8px;
    outline: none;
    border: none;
    transition: 0.3s;
    cursor: pointer;
}
p.hasnewbtn:hover {
    background: #3456ff;
    color: #fff;
}
.hasboxbg {
    background-color: var(--container-bg);
    /* background: #171717; */
    border-radius: 15px;
    padding: 20px;
    /* margin-bottom: 15px; */
    margin-bottom: calc(var(--bs-gutter-x) * 1);
    /* word-break: break-all; */
}

.hasboxbg-no-bottom-margin {
    margin-bottom: 0px !important;
}

.prosecleft {
    /* width: 35%; */
}

.prosecright {
    /* width: calc(65% - 30px); */
}

.profilesecionmainwrwap {
    display: flex;
    align-items: start;
    justify-content: space-between;
}

.titleaboutLInk {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
}

.titleaboutLInk h5 {
    color: var(--userName);
    /* color: #fff; */
    margin: 0;
    font-size: 24px;
    font-weight: 500;
}

.titleaboutLInk a {
    text-decoration: underline !important;
    font-size: 14px;
}

.aboutifo {
    margin-top: 20px;
}

.aboutifo ul {
    padding: 0;
    margin: 0;
    list-style: none;
}

.aboutifo ul li {
    color: var(--userName);
    /* color: #fff; */
    font-size: 16px;
}

.aboutifo ul li span {
    opacity: 0.5;
    margin-right: 10px;
}

.aboutifo ul li + li {
    margin-top: 12px;
}

.familyboxinfo {
    /* height: 450px; */
    overflow-y: scroll;
    max-height: 450px;
}
.familyboxinfo::-webkit-scrollbar {
    width: 0.5em !important;
    display: none;
}

.familyboxinfo ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.familyboxinfo ul li {
    width: 31%;
    margin-top: 5%;
}

.familyboxinfo ul {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    column-gap: 15px;
    /* justify-content: space-between; */
}

.imageFamily img {
    width: 100%;
    height: 100px;
    object-fit: cover;
    object-position: top;
    border-radius: 12px;
}

.nameFamily {
    color: #fff;
    margin-top: 10px;
}

.nameFamily h5 {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 3px;
    font-weight: 400;
    color: var(--userName);
}

.nameFamily h6 {
    opacity: 0.5;
    font-size: 12px;
}
.upcomingifo ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.upcomingifo ul li {
    color: #fff;
}

.upcmgtitle h5 {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 3px;
    color: var(--shotcusttext);
}

.comingImageTitle img {
    width: 100%;
    height: 150px;
    object-fit: cover;
    object-position: center;
    border-radius: 12px;
    margin-bottom: 10px;
}

.upcomingifo ul li + li {
    margin-top: 20px;
}

.upcomingifo {
    margin-top: 30px;
    max-height: 500px;
    overflow-y: scroll;
}
.upcomingifo::-webkit-scrollbar {
    display: none;
}

.uoloadtext {
    display: flex;
    align-items: center;
}

.profileimg img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    object-position: center;
    border-radius: 100%;
}

.profileimg {
    margin-right: 12px;
}

.blur-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Dark overlay */
    backdrop-filter: blur(4px); /* Blur effect */
    border-radius: 10px;
    overflow: hidden;
  }
  
.profileText h4 {
    margin: 0;
    font-size: 17px;
    color: var(--shotcusttext);
    /* color: #ffffff; */
    /* opacity: 0.5; */
    font-weight: 400;
}

.mindUpload {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.profileimgUploadIcon img {
    height: 22px;
}

.uoloadtextmain .profileText h4 {
    opacity: 1;
    margin-bottom: 1px;
}

.uoloadtextmain .profileText span {
    opacity: 0.6;
    color: #fff;
    font-size: 14px;
}

.uoloadtext span.tag {
    background: var(--tag);
    /* background: #2f2f2f; */
    padding: 4px 15px;
    /* color: rgb(255 255 255 / 50%); */
    color: #ffffff;
    display: inline-block;
    border-radius: 4px;
    font-size: 14px;
    margin-left: 2%;
}
.comenttag span.tag {
    background: #2f2f2f;
    padding: 8px 15px;
    color: rgb(255 255 255 / 50%);
    display: inline-block;
    border-radius: 6px;
    font-size: 14px;
}

.comenttag {
    /* width: 50%; */
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.comenttag span.time {
    color: var(--shotcusttext);
    /* color: #fff; */
    /* opacity: 0.4; */
    font-size: 12px;
}

.uoloadtextmain .uoloadtext {
    /* width: 50%; */
}

.uoloadtextmain {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.postContent p {
    font-size: 16px;
    line-height: 28px;
    margin: 0;
    color: var(--shotcusttext);
    /* color: #fff; */
}

.postaction {
    flex-wrap: wrap;
    row-gap: 10px;
}

.postaction ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.postaction ul li + li {
    margin-left: 40px;
}

.postaction ul li img {
    height: 25px;
    margin-right: 10px;
}

.postaction ul li span {
    /* color: #8b8b8b; */
    /* color: #ffffff; */
    color: var(--grey-comment);
}

.postContent {
    border-bottom: 1px solid rgb(255 255 255 / 10%);
    padding-bottom: 20px;
    margin: 20px 0 20px;
}

.postedImage {
    margin-block: 10px;
    /* margin-top: 15px; */
    /* margin-bottom: 5px; */
    max-width: 100%;
}

.postedImage img {
    width: 100%;
    border-radius: 12px;
}

.uoloadtext.innerPrfilePostInner {
    width: 100%;
    align-items: start;
}

.postStatus {
    margin-left: 20px;
}

.postStatus p {
    font-size: 14px;
    opacity: 0.3;
    font-weight: 400;
    margin: 0;
    line-height: 20px;
}

.postedImage.UploadProfileimage {
    position: relative;
    padding-bottom: 50px;
}

.postedImage.UploadProfileimage .profileimage {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 0;
}

.postedImage.UploadProfileimage .profileimage img {
    width: 100%;
    height: 100%;
}
.uoloadtext.innerPrfilePostInner .profileText {
    width: 500px;
}

.profileTextinner {
    display: flex;
    align-items: center;
}
.headerRightMenu ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
}
.newheaderRight {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.headerRightIcon {
    display: flex;
    align-items: center;
    margin-left: 20px;
}

.newiconheader {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.nottii > div + div {
    margin-left: 20px;
}

.newiconheader > div {
    margin-left: 18px;
}
.fullpage-nav {
    padding: 0 !important;
}
.mes {
    /* border-left: 1px solid rgb(255 255 255 / 51%); */
    padding-left: 20px;
    margin-left: 0 !important;
}

.headerRightMenu ul li a {
    font-size: 16px;
    line-height: 19px;
    /* leading-trim and text-edge are draft CSS properties.

  Read more: https://drafts.csswg.org/css-inline-3/#leading-trim
  */
    text-align: right;
    color: #ffffff;
}

.headerRightMenu.headerRightMenu ul li + li {
    margin-left: 25px;
}

.cirlenoti {
    width: 10px;
    height: 10px;
    position: absolute;
    background: #3478ff;
    border-radius: 100%;
    border: 2px solid #171717;
    top: -3px;
    right: 0;
}

.nottii {
    position: relative;
    border-left: 1px solid rgb(255 255 255 / 51%);
    padding-left: 20px;
}
.openmobilemenu,
.closeMenu {
    display: none !important;
}
.profileIMg {
    position: relative;
}

.innerdropdownmainLEft img {
    width: 35px;
    border-radius: 100%;
    height: 35px;
}

.innerdropdownmainLEft a {
    display: flex;
    align-items: center;
    color: #fff;
}

.innerdropdownmainLEft h5 {
    margin: 0;
    font-size: 15px;
    margin-left: 10px;
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.innerdropdownmain {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
/*headerNewStyle End*/
.top-menu-new {
    margin-top: 50px;
    border-radius: 8px;
    overflow: hidden;
}
.contactcenterBox .row {
    display: flex;
    align-items: center;
    justify-content: center;
}

.contactcenterBoxwrapInner {
    margin-top: 60px;
}
.evebtdate {
    font-family: "Open Sans", sans-serif;
    background: rgb(255 255 255 / 78%);
    display: inline-block;
    padding: 8px;
    border-radius: 5px;
    position: absolute;
    top: 20px;
    right: 20px;
}
.contactcenterBoxwrapInner {
    margin-top: 60px;
    margin-bottom: 70px;
    border-radius: 15px;
    overflow: hidden;
    box-shadow:  var(--event-box-shadow);
}
.contactcenterBoxImage {
    position: relative;
}
.contactimagecont {
    background: var(--container-bg);
    padding: 30px;
}

.contactimagecont h3 {
    font-family: "Open Sans", sans-serif;
    color: var(--userName);
    font-size: 22px;
    line-height: 50px;
    margin-bottom: 8px;
}

.contactimagecont h3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.contactimagecont h3 span {
    font-family: "Open Sans", sans-serif;
    color: #3478ff;
    font-size: 16px;
    line-height: 30px;
    margin-bottom: 0;
}

.contactimagecont h5 {
    font-family: "Open Sans", sans-serif;
    color: var(--userName);
    font-size: 16px;
    line-height: 34px;
    margin-bottom: 0;
    opacity: 0.5;
}
.btnconect4 a {
    background: #fff;
    font-family: "Open Sans", sans-serif;
    font-size: 20px;
    line-height: 28px;
    padding: 12px 20px;
    display: inline-block;
    width: 160px;
    text-align: center;
    border-radius: 10px;
}
.postaction ul li {
    display: flex;
    align-items: center;
}
.contactcenterBoxwrap {
    font-family: "Open Sans", sans-serif;
}
.userProfileicon img {
    width: 40px;
    height: 40px;
    border-radius: 100%;
    object-fit: cover;
    object-position: center;
}

.cahtListcomments ul li {
    display: flex;
    align-items: start;
    justify-content: flex-start;
}

.userProfileicon {
    /* margin-right: 12px; */
}

.comentbox {
    background: rgb(255 255 255 / 10%);
    padding: 10px;
    border-radius: 8px;
    word-break: break-all;
    width: fit-content;
}

.comentbox h5 {
    font-size: 15px;
    color: var(--shotcusttext);
    /* color: #fff; */
    opacity: 0.5;
    line-height: 18px;
    margin: 0 0 10px;
}

.comentbox p {
    font-size: 14px;
    margin: 0 !important;
    line-height: 22px;
}

.cahtListcomments {
    border-top: 1px solid rgb(255 255 255 / 10%);
    margin-top: 20px;
    padding-top: 30px;
    max-height: 600px;
    overflow-y: scroll;
    padding-right: 10px;
}
.cahtListcomments::-webkit-scrollbar {
    width: 0.1em !important;
    /* display: none; */
}

.cahtListcomments::-webkit-scrollbar-thumb {
    background-color: grey;
}

.userActins {
    display: flex;
    align-items: center;
    justify-content: start;
    margin-top: 7px;
}
.hashomenewcentercon .profilesecionmainwrwap {
    display: flex;
    align-items: center;
    justify-content: center;
}
.welcomeBox {
    height: 100%;
    background: #b5cbf6;
    background: linear-gradient(149deg, #b5cbf6 0, #3478ff 100%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 16px;
    border-radius: 10px;
    /* margin-bottom: 20px; */
    margin-bottom: calc(var(--bs-gutter-x) * 1);
}

.welcomeLeft h2 {
    font-size: 25px;
    /* line-height: 64px; */
    color: #fff;
    line-height: 1.2;
    font-weight: 500;
}

.welcomeLeft h2 span {
    display: block;
    font-size: 19px;
    /* line-height: 54px; */
}

.notifictionocon {
    display: flex;
}

.notifictionocon span {
    margin-right: 20px;
}
.welcomebtn a {
    background: #fff;
    color: #3478ff !important;
    width: 150px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    font-weight: bold;
    font-size: 10px;
}

.welcomebtn {
    display: flex;
    flex-direction: column;
}

.welcomebtn a + a {
    margin-top: 12px;
}
.welcomeboxright {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
}
.hashomenewcentercon .prosecright {
    /* width: 70%; */
    width: 100%;
}
.timecoments {
    color: var(--shotcusttext);
    /* color: #fff; */
    font-size: 12px;
    opacity: 0.5;
}
.serviceshortctuts h3 {
    font-size: 36px;
    line-height: 48px;
    color: #fff;
    margin: 0 0 12px;
}

.serviceshortctuts ul li {
    background-color: var(--container-bg);
    /* background: #171717; */
    width: calc(25% - 15px);
    border-radius: 6px;
    padding: 23px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.shotcusttext {
    color: var(--shotcusttext);
    /* color: #fff; */
    /* font-size: 18px; */
}
.serviceshortctuts ul {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
}
.connectSuggleft {
    background: #202020;
    padding: 30px;
    border-radius: 15px;
}

.imagelinkbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.connectSuggright {
    background: #202020;
    padding: 20px;
    border-radius: 15px;
    width: 49%;
}

.conlink img {
    width: 50px;
}
.connectconet {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}
.connectconet p {
    margin: 0;
    font-size: 18px;
    line-height: 32px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.coomainwrap {
    display: flex;
    align-items: stretch;
    /* justify-content: space-between; */
    overflow-x: scroll;
    column-gap: 10px;
}
.coomainwrap::-webkit-scrollbar {
    width: 0.5em !important;
    display: none;
}

.coomainwrap::-webkit-scrollbar-thumb {
    background-color: transparent;
}

.editable::-webkit-scrollbar {
    width: 0.5em !important;
    display: none;
}

.editable::-webkit-scrollbar-thumb {
    background-color: transparent;
}
.upcomingTabs .connectSuggleft {
    padding: 0;
    background: transparent;
}

.upcomingTabs .upcmgtitle h5 {
    color: #fff;
    font-size: 24px;
    line-height: 34px;
}
.mindUploadPost.hasboxbg h3 {
    color: #fff;
    font-size: 28px;
    line-height: 40px;
    margin-bottom: 20px;
}
.popupMain {
    background: rgb(10 10 10 / 90%);
    width: 100%;
    height: 100%;
    /* position: absolute; */
    /* top: 0; */
    z-index: 9999999;
    /* display: flex; */
    align-items: start;
    justify-content: center;
    border-radius: 10px;
    max-width: 700px;
}

.popupInner {
    /* width: 700px; */
    min-width: 700px;
    height: auto;
    /* margin-top: 100px; */
    background: #282a2a;
    border-radius: 10px;
    /* overflow: hidden; */
    /* max-width: 100%; */
    max-width: 700px;
}

.popupHeader {
    background: #242626;
    font-family: "Open Sans", sans-serif;
    color: #fff;
    padding: 20px;
    border-radius: 10px;
    justify-content: space-between;
}

.popupHeader h5 {
    opacity: 0.5;
}

.popupHeader ul {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 20px;
}

.popupHeader ul li {
    background: #454646;
    width: auto;
    height: auto;
    padding: 10px 15px;
    border-radius: 7px;
    font-size: 14px;
}
.mindUpload {
    padding: 13px 19px;
    /* padding-bottom: 0px; */
}

.popupMain .postContent {
    padding: 20px;
    padding-top: 0px;
    border: none;
    border-top: 1px solid rgb(255 255 255 / 10%);
    padding-top: 20px;
}
.popupHeader ul li + li {
    margin-left: 12px;
}
.postBtn a {
    display: inline-block;
    font-family: "Open Sans", sans-serif;
    padding: 12px 50px;
    margin-top: 20px;
}

.popupMain {
    /* display: none; */
}

.postBtn {
    display: flex;
    align-items: center;
    justify-content: end;
}
.popupHeader ul li.active {
    background: #fff;
    color: #000;
    font-size: 14px;
}
.serviceshortctuts {
    margin: 0 0 15px;
    margin-bottom: calc(var(--bs-gutter-x) * 1);
}
.shortcuticon img {
    display: table;
    margin: 0 auto;
    height: 38px;
    width: 38px;
}
.upcomingTabs p {
    font-size: 16px;
    line-height: 24px;
}
.shortcuticon {
    margin-bottom: 12px;
}
.connectconetCon h3 {
    font-size: 23px !important;
    margin: 0 0 8px !important;
}

.connectconetCon h5 {
    color: #fff;
    opacity: 0.8;
}

.penBtns a {
    width: 180px;
    background: #fff;
    height: 50px;
    display: inline-block;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.penBtns {
    display: flex;
    align-items: start;
    justify-content: flex-start;
    margin-top: 20px;
}

a.accptbtn {
    background: #28a830;
    color: #fff;
}

a.declinebtn {
    background: #ff3434;
    color: #fff;
    margin-left: 15px;
}
.likereplybtn {
    margin-left: 18px;
    color: #fff;
    opacity: 0.8;
    font-size: 14px;
    line-height: 16px;
}

.likereplybtn span + span {
    margin-left: 10px;
}

.likereplybtn span {
    color: var(--shotcusttext);
}

.userActins {
}

.cahtListcomments ul li + li {
    margin-top: 30px;
}
.contactcenterBoxwrap .mindUploadPost.hasboxbg {
    margin: 50px 0 90px;
}
.btnconect4 a + a {
    background: rgb(255 255 255 / 15%);
    color: #fff;
    margin-left: 20px;
}

.btnconect4 {
    border-top: 1px solid #3a3a3a;
    padding-top: 30px;
    margin-top: 30px;
}
.conp p {
    font-size: 16px;
    line-height: 28px;
    margin: 20px 0 0;
}
.popupMain .profileText h4 {
    font-family: "Open Sans", sans-serif;
    color: #fff;
    opacity: 1;
}

.comment-content {
    word-wrap: break-word; /* Allow long words to break and wrap onto the next line */
    overflow-wrap: break-word; /* Standard name for word-wrap property */
    max-width: 100%; /* Ensure the content doesn't exceed the width of its container */
}

@media (max-width: 991px) {
    .bannerProfilephoto img {
        height: 200px;
    }

    .profileimage {
        margin-left: 15px;
        width: 130px;
        height: 130px;
        min-width: 130px;
        position: relative;
        top: -30px;
    }

    .prfileimageconnection {
        width: 100%;
    }

    .profileeditmain {
        width: 100%;
        margin: 0;
        justify-content: end;
        padding-left: 0;
        margin-top: -10px;
    }

    .profileimageEditprofilemain {
        flex-direction: column;
        top: 0;
        padding-bottom: 20px;
        margin-bottom: 30px;
    }

    .nameconnection {
        margin-top: 0;
        margin-left: 20px;
    }

    .nameconnection h3 {
        font-size: 16px;
        line-height: 20px;
        margin-bottom: 8px;
    }

    .nameconnection h5 {
        font-size: 14px;
        line-height: 16px;
    }

    a.hasnewbtn {
        padding: 12px 15px;
        font-size: 13px;
        width: 100%;
        text-align: center;
    }

    /* .profilesecionmainwrwap {
        flex-direction: column-reverse;
    } */

    .prosecleft {
        width: 100%;
    }

    .prosecright {
        width: 100%;
    }

    .profileText h4 {
        font-size: 14px;
    }

    .hasboxbg {
        padding: 12px;
    }

    .uoloadtextmain .uoloadtext {
        width: 100%;
    }

    .comenttag {
        width: 100%;
        margin-top: 12px;
    }

    .uoloadtextmain {
        flex-direction: column;
        align-items: flex-start;
    }

    .comenttag span.tag {
        padding: 4px 12px;
        font-size: 12px;
    }

    .postContent p {
        font-size: 14px;
        line-height: 22px;
    }

    .postaction ul li span {
        font-size: 12px;
    }

    .imageFamily img {
        height: 100px;
    }

    .nameFamily h5 {
        font-size: 14px;
        line-height: 20px;
    }

    .nameFamily h6 {
        font-size: 12px;
    }

    .titleaboutLInk h5 {
        font-size: 20px;
    }

    .titleaboutLInk {
        margin-bottom: 5px;
    }

    .upcmgtitle h5 {
        font-size: 14px;
    }
    .uoloadtext.innerPrfilePostInner .profileText {
        width: 100%;
    }

    .profileTextinner {
        flex-direction: column;
        align-items: start;
    }

    .postStatus {
        margin: 4px 0 0;
    }

    .postStatus p {
        font-size: 13px;
    }

    .uoloadtextmain .profileText span {
        font-size: 11px;
    }
    .aboutifo ul li {
        font-size: 14px;
    }
}
@media (max-width: 767px) {
    .profilePicture {
        width: 100%;
    }

    .profileBlueboxtop {
        flex-direction: column;
    }

    .prfileDetailsandFamily {
        width: 100%;
        text-align: center;
        margin: 20px 0;
    }

    .condetails {
        width: 100%;
    }

    .fam-right ul li {
        padding: 0 !important;
        height: 60px !important;
    }

    .custom-tab-list ul {
        padding: 0;
        flex-direction: column;
    }

    .custom-tab-list ul li + li {
        border: none;
        margin-top: 20px;
    }

    .custom-tab-list ul li {
        width: 100%;
    }

    .profileBluebox {
        margin-bottom: 30px;
    }

    .confrmpasschanges {
        flex-direction: column;
    }

    .confirmpassinner {
        width: 100%;
    }

    .confirmpassinner + .confirmpassinner {
        margin: 30px 0 0;
    }

    .titlenewDrop {
        margin-bottom: 40px;
    }

    .titlenewDrop h2 {
        margin: 0 !important;
    }
    .titlewithbtnnotification {
        /* flex-direction: column; */
        /* text-align: left; */
        /* align-items: flex-start; */
    }

    .titlewithbtnnotification h3 {
        margin-bottom: 0;
        font-size: 22px;
    }

    .involmentBoxmain .for-box-innner {
        padding: 0 !important;
    }

    .ratesMain {
        flex-direction: column;
    }

    .rateTitle {
        width: 100%;
        text-align: center;
        margin-bottom: 30px;
    }

    .assgnbtnnot a {
        font-size: 12px;
        padding: 12px 22px !important;
        width: auto !important;
    }
    .involdatetitle h4 {
        font-size: 18px;
        margin-top: 20px;
    }
    .involmentBoxmain:first-child {
        margin: 0;
        padding: 20px;
    }
    .notedate {
        font-size: 13px;
        margin-right: 10px;
    }

    .messgtnotemain .titlewithbtnnotification h3 {
        width: auto;
    }

    .messgtnotemain .titlewithbtnnotification h3 span {
        font-size: 12px;
        margin-left: 20px;
    }

    .nnotcodelete img {
        max-width: 18px;
    }

    .noteDetails p {
        font-size: 14px;
        line-height: 22px;
        margin: 0;
    }

    .btngreen {
        margin-top: 25px;
    }
    /*    header*/
    .headerRightMenu {
        position: fixed;
        top: 0;
        width: 100%;
        left: 0;
        background: #18191a;
        padding: 20px;
        z-index: 9999;
        height: 100%;
        display: none;
    }

    .newheaderRight {
        width: 80% !important;
        justify-content: flex-end;
        display: none;
    }

    .logo-main img {
        max-width: 80%;
    }

    .logo-main {
        /* width: 20% !important; */
        padding: 0 8px;
    }

    .headerRightMenu ul {
        flex-direction: column;
        align-items: start;
        padding-top: 40px;
    }

    .headerRightMenu.headerRightMenu ul li + li {
        margin: 12px 0 0px;
        border-top: 1px solid #1e1f21;
        width: 100%;
        padding-top: 12px;
    }
    /* header.newHeader .container-fluid {
        padding: 0 24px;
    } */
    .openmobilemenu,
    .closeMenu {
        display: block !important;
    }
    .headerRightMenu.active {
        display: block;
    }
    .closeMenu {
        width: 50px;
        height: 50px;
        position: absolute;
        right: 0;
        z-index: 999;
        font-size: 25px;
    }

    /* .mobileMenuDesign .admin-dashboard-left h3 {
        font-family: "Open Sans", sans-serif;
        color: #fff;
        opacity: 0.5;
        font-size: 16px;
        margin-bottom: 10px;
    } */
    .admin-dashboard-right {
        width: 100% !important;
        padding: 0 15px !important;
    }
    .top-menu-inner ul {
        flex-direction: column;
    }

    .top-menu-inner ul li + li {
        padding: 0 !important;
    }

    .welcomeBox {
        flex-direction: column;
        align-items: start;
    }

    .welcomeLeft h2 span {
        font-size: 24px;
        line-height: 30px;
    }

    .welcomeLeft h2 {
        font-size: 32px;
        line-height: 40px;
    }

    .welcomeboxright {
        flex-direction: column;
        width: 100%;
        margin-top: 20px;
    }

    .welcomeLeft {
        width: 100%;
    }

    .notifictionocon {
        margin-bottom: 20px;
    }

    .serviceshortctuts ul li {
        width: 48%;
    }

    .serviceshortctuts ul {
        flex-wrap: wrap;
    }

    .hashomenewcentercon .prosecright {
        width: 100%;
    }

    .serviceshortctuts h3 {
        font-size: 24px;
        line-height: 30px;
    }

    .serviceshortctuts ul li:nth-child(n + 3) {
        margin-top: 4%;
    }

    .shotcusttext {
        font-size: 18px;
        text-align: center;
    }

    .coomainwrap {
        flex-direction: column;
    }

    .connectSuggleft {
        width: 100%;
    }

    .connectSuggleft + .connectSuggleft {
        margin-top: 12px;
    }

    .has-footer-top {
        padding: 40px 15px;
    }

    .footer-col {
        width: 50%;
        flex: 0 0 50%;
        max-width: 50%;
    }

    .footer-col:nth-child(n + 3) {
        margin-top: 20px;
    }

    .footer-col ul li a {
        font-size: 14px;
        line-height: 24px;
    }

    .footer-col ul li + li {
        margin-top: 5px;
    }

    .footer-col h4 {
        font-size: 18px;
    }

    .footer-b-left p {
        padding: 0 20px;
        font-size: 14px;
        text-align: center;
        line-height: 18px;
    }
    .mindUploadPost.hasboxbg h3 {
        font-size: 22px;
        line-height: 30px;
        margin-top: 12px;
    }

    .connectconet p {
        font-size: 16px;
        line-height: 24px;
        margin-top: 22px;
    }
    .newpromainwrap {
        padding-bottom: 30px;
    }
    .contactcenterBoxImage img {
        height: 250px;
        object-fit: cover;
        object-position: center;
    }

    .contactimagecont {
        padding: 15px;
    }

    .contactimagecont h3 {
        font-size: 26px;
        line-height: 44px;
        flex-direction: column;
        align-items: start;
    }

    .contactimagecont h5 {
        font-size: 18px;
        line-height: 30px;
    }
    .userProfileicon {
        min-width: 50px;
    }
    .btnconect4 {
        display: flex;
        align-items: start;
    }

    .btnconect4 a {
        font-size: 16px;
    }
    .contactcenterBoxwrap .mindUploadPost.hasboxbg {
        margin: 30px 0 50px;
    }
    .top-menu-inner ul li {
        width: 50%;
        text-align: center;
    }

    .top-menu-inner ul li a {
        font-family: "Open Sans", sans-serif;
        padding: 12px 0;
        font-size: 18px;
        color: #fff;
        opacity: 0.8;
    }

    .top-menu-inner ul {
        flex-wrap: wrap;
        flex-direction: initial;
        padding: 10px;
    }
    .welcomeBox {
        padding: 20px;
    }

    .welcomebtn a {
        height: 46px;
    }

    .welcomeLeft h2 {
        font-size: 28px;
        line-height: 40px;
    }
    .shortcuticon img {
        max-width: 30px;
    }
    .connectconetCon h3 {
        font-size: 20px !important;
    }
    .wraper {
        overflow: hidden;
    }
    .wraper {
        overflow: hidden;
    }

    .popupHeader ul {
        flex-wrap: wrap;
        align-items: start;
    }

    .popupHeader ul li {
        margin-bottom: 12px;
    }

    .popupHeader ul li a {
        font-size: 12px;
    }

    .popupHeader ul li {
        font-size: 12px;
    }

    .popupInner {
        /* width: 94%; */
    }

    .popupHeader ul li + li {
        margin-left: 6px;
    }
}

.upcomingEventsCol {
    height: 63vh;
    border-radius: 15px;
    /* background-color: #171717; */
    background-color: var(--container-bg);
    padding-block: 10px;
    overflow-y: scroll;
}

.upcomingEventsCol::-webkit-scrollbar {
    width: 0.5em !important;
    display: none;
}

.giving {
    /* height: 50vh; */
    min-height: 30vh;
    border-radius: 15px;
    /* background-color: #171717; */
    background: linear-gradient(61deg, #f8acac 0, #fc4f4f 100%);
    /* padding-block: 10px; */
    /* padding: 15px; */
    /* overflow-y: scroll; */
}
.topPart {
    background: linear-gradient(61deg, #f8acac 0, #fc4f4f 100%);
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
}

.rs-progress-line-bg {
    background: linear-gradient(61deg, #f8acac 0, #fc4f4f 100%);
}

.givingInput {
    color: #ffffff;
    background-color: transparent;
    outline: unset;
    /* border-bottom-color: #ffffff;
    border-bottom-width: 1px; */
    font-size: 10px;
    width: 80%;
    padding-bottom: 4px;
}
.givingInput::placeholder {
    color: #ffffff;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Hide increment and decrement buttons in Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}

.inputCont {
    border-bottom-color: #ffffff;
    border-bottom-width: 1px;
}

/*  */
/* ToggleSwitch.css */
.toggle-switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;
}

.toggle-switch input {
    display: none;
}

.subscriptionCont {
    height: 50px;
    overflow-y: scroll;
    row-gap: 4px;
}
.subscriptionCont::-webkit-scrollbar {
    width: 0.5em !important;
    display: none;
}

/* .paymentMethods {
    height: 70px;
    overflow-y: scroll;
    gap: 4px;
    flex-wrap: wrap;
}
.paymentMethods::-webkit-scrollbar {
    width: 0.5em !important;
    display: none;
} */

.react-datepicker__input-container input {
    width: 98% !important;
    background-color: transparent;
    font-size: 12px;
    color: #fff;
    outline: unset;
}

.react-datepicker-popper .react-datepicker__triangle {
    display: none;
}
.react-datepicker {
    left: 30%;
}

/*  */

.postCol {
    height: 98vh;
    overflow-y: auto;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    /* padding: 0 !important; */
    /* padding-inline: calc(var(--bs-gutter-x) * 1) */
}

.postCol::-webkit-scrollbar {
    width: 0.5em !important;
    display: none;
}

.givingCont {
    background-color: white;
    border-radius: 15px;
    margin-bottom: calc(var(--bs-gutter-x) * 1);
}

.rightCol {
    height: 98vh;
    display: flex;
    flex-direction: column;
    /* row-gap: 20px; */
    overflow-y: scroll;
    /* padding: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important; */
    /* padding-right: calc(var(--bs-gutter-x) * 1) */
    padding-right: 0 !important;
    /* justify-content: space-between; */
}

.mainCont {
    padding-inline: calc(var(--bs-gutter-x) * 1);
}

.leftCol {
    /* padding: 0 !important; */
    padding-left: 0 !important;
    height: 98vh;
    /* overflow: scroll; */
    border-radius: 15px;
    /* justify-content: space-between; */
    display: flex;
}

.leftCol::-webkit-scrollbar {
    width: 0.5em !important;
    display: none;
}

.rightCol::-webkit-scrollbar {
    width: 0.5em !important;
    display: none;
}

.connectSuggestionContainer {
    background-color: var(--container-bg);
    /* background-color: #171717; */
    border-radius: 15px;
    padding: 16px 10px 10px 10px;
    margin-bottom: calc(var(--bs-gutter-x) * 1);
}

.scrollCont::-webkit-scrollbar {
    width: 0.5em !important;
    display: none;
}

.scrollCont {
    overflow-y: scroll;
    height: 20vh;
}

.connectSuggestionCard {
    background-color: var(--container2-bg);
    /* background-color: #202020; */
    border-radius: 15px;
    align-items: center;
    padding: 10px;
    justify-content: space-between;
}

.eventCard {
    display: flex;
    flex-direction: column;
    border-radius: 15px;
    /* background-color: #202020; */
    background-color: var(--container2-bg);
    padding: 15px;
    justify-content: center;
}

.eventCard img {
    width: 100%;
    height: 105px;
    object-fit: cover;
    object-position: center;
    border-radius: 12px;
    margin-bottom: 10px;
}

.viewBtn {
    border-radius: 5px;
    background-color: var(--viewBtn);
    /* background-color: #4b4b4b; */
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    /* padding-block: 6px; */
}
.viewBtn p {
    margin-bottom: 0;
}

.actionsCont {
    display: flex;
    justify-content: center;
    margin-top: 0px;
}

.actionsCont a {
    width: 50%;
    height: 35px;
    display: inline-block;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

@media (min-width: 1200px) and (max-width: 1750px) {
    .logo-main img {
        max-height: 40px;
    }
    /* .container {
        width: 100%;
        max-width: 100%;
        padding: 0 90px;
    } */
    header {
        padding: 10px 0;
        /* background-color: red !important; */
    }
}

/* .accptbtn:hover{
    color: white ;
}
.declinebtn:hover{
    color: white;
} */

.header-Icon {
    height: 30px;
    width: 25px;
    max-width: 25px;
}

.header-Logo {
    display: none;
}

@media (max-width: 768px) {
    .header-Logo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-block: 10px;
    }
    .mainHeader {
        display: none !important;
    }
    .leftCol {
        padding: 0 !important;
    }
    /* .header.newHeader .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
    } */
    .post-detail-wrapper {
        flex-direction: column !important;
    }
}

.replies-cont {
    max-height: 300px;
    overflow-y: auto;
}

.replies-cont::-webkit-scrollbar {
    width: 0.1em !important;
}

.replies-cont::-webkit-scrollbar-thumb {
    background-color: grey;
}

.even-row {
    background-color: #171717;
    color: #fff;
}
.odd-row {
    background-color: #202020;
    color: #fff;
}
.ant-table-cell {
    /* background-color: #000 !important; */
    color: #fff !important;
    border-bottom-color: #000 !important;
}

.ant-table-cell::before {
    background-color: #000 !important;
}
.ant-table-thead > tr > th {
    background-color: #000 !important;
    color: #fff !important;
}

.ant-table-cell-scrollbar {
    box-shadow: none !important;
}

.ant-pagination-item-link {
    color: #fff !important;
}

.ant-pagination-item:not(.ant-pagination-item-active):hover {
    background-color: grey !important;
}

.ant-pagination-item {
    background-color: transparent !important;
    color: #fff !important;
}

.ant-pagination-item-active {
    background-color: #007bff !important;
    color: #fff !important ;
}

.ant-table-tbody::-webkit-scrollbar {
    display: none !important;
}
.ant-picker-outlined {
    background-color: #202020 !important;
    color: #fff !important;
}

.ant-picker-input > input::-webkit-input-placeholder {
    color: #fff !important;
}

.ant-picker-separator {
    color: #fff !important;
}

.ant-picker-clear {
    color: #fff !important;
    opacity: 1 !important;
}

.ant-dropdown-menu {
    background-color: #202020 !important;
    /* border: 1px solid #d9d9d9; */
}
.ant-dropdown-menu-item {
    color: #fff !important;
}

.ant-dropdown-menu-item-selected {
    background-color: #007bff !important;
}

.ant-pagination-item-ellipsis {
    color: #fff !important;
}

.ant-picker-panel-container {
    background: #202020 !important;
}
.ant-picker-header {
    color: #fff !important;
}

.ant-picker-header button {
    color: #fff !important;
}

.ant-picker-content thead tr th {
    color: white !important;
}

.ant-picker-cell-inner {
    color: #fff !important;
}

.ant-picker-cell-in-range > div {
    color: #000 !important;
}

.ant-dropdown-menu-item:hover {
    background-color: rgb(255 255 255 / 6%) !important;
}

.excel-generate-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 40px;
    background-color: #007bff;
    border-radius: 4px;
    padding: 10px;
    cursor: pointer;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    border: none;
    outline: none;
}

/* Hover state */
.excel-generate-button:hover {
    background-color: #0056b3;
}

/* Active state */
.excel-generate-button:active {
    background-color: #004085;
}

/* Disabled state */
.excel-generate-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}

@media (max-width: 460px) {
    .ant-picker-panels {
        display: flex !important;
        flex-direction: column !important;
    }
}

.annual-budget-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    width: 100%;
    height: calc(90% - 60px);
    overflow: auto;
    border-radius: 4px;
}

@media (max-width: 768px) {
    .annual-budget-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 668px) {
    .annual-budget-grid {
        gap: 10px;
        height: calc(90% - 25px);
    }
}

.two-line-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 2; /* Limit to 2 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.three-line-ellipsis{
    display: -webkit-box;
    -webkit-line-clamp: 3; /* Limit to 2 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.reply-input::-webkit-input-placeholder {
    color: grey;
}
.noti-item:hover {
    background-color: var(--hover-noti-color) !important;
    cursor: pointer;
}

.convo-item:hover {
    background-color: var(--hover-convo) !important;
}

.about-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    background-color: var(--container-bg);
    border-radius: 20px;
    padding: 40px;
    cursor: pointer;
    box-shadow: var(--event-box-shadow);
}

.about-content img {
    height: 60px;
    width: 60px;
    filter: var(--img-brightness);
}

.about-content h3 {
    color:var(--userName);
    line-height: 1.2;
    font-weight: 600;
}

.our-belief {
    display: flex;
    flex-direction: column;
    width: 90%;
    padding-block: 30px;
    padding-inline: 20px;
    font-family: sans-serif;
}

.our-belief h1 {
    color: var(--userName);
    margin-bottom: 30px;
}
.our-belief div {
    margin-bottom: 40px;
    row-gap: 20px;
}

.our-belief div p {
    color:var(--ourbelief-p);
    font-size: 24px;
    line-height: 40px;
    text-align: justify;
}

.our-belief div h2 {
    color: var(--userName);
    font-size: 20px;
    line-height: 40px;
    margin-top: 10px;
}

.our-code {
    display: flex;
    flex-direction: column;
    width: 90%;
    padding-block: 30px;
    padding-inline: 20px;
    font-family: sans-serif;
}

.our-code div h4 {
    color: var(--userName);
    font-weight: 500;
    opacity: 0.5;
    line-height: 40px;
    font-size: 24px;
}

.our-code > div > h2 {
    font-size: 30px;
}

.chatBox {
    background-color: var(--widget-bg);
    border-radius: 20px;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: var(--box-shadow);

}

.chat-Input {
    color: var(--notes-textarea-color);
    background-color: transparent;
    outline: none;
    border: unset;
    font-size: 14px;
    resize: unset;
}
.chat-Input::placeholder {
    color: gray;
}`, "",{"version":3,"sources":["webpack://./src/globals.css"],"names":[],"mappings":"AAAA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB,gBAAgB;AAChB;IACI,uBAAuB,EAAE,yBAAyB;IAClD,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,2BAA2B;IAC3B,sBAAsB;IACtB,oCAAoC;IACpC,8BAA8B;IAC9B,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;IAC3B;AACJ;;AAEA,eAAe;AACf;IACI,uBAAuB,EAAE,6BAA6B;IACtD,wBAAwB;IACxB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,2BAA2B;IAC3B,sBAAsB;IACtB,wBAAwB;IACxB,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,qBAAqB,EAAE,iCAAiC;AAC5D;;AAEA,+BAA+B;AAC/B;IACI,qBAAqB,EAAE,sBAAsB;AACjD;;AAEA;IACI,qBAAqB,EAAE,iCAAiC;AAC5D;;AAEA,+BAA+B;AAC/B;IACI,qBAAqB,EAAE,sBAAsB;AACjD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;;IAEI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,0CAA0C;AAC9C;AACA;IACI,oCAAoC;IACpC,kCAAkC;IAClC,wCAAwC;IACxC,2BAA2B;IAC3B,qCAAqC;IACrC,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;;IAEI,yBAAyB;IACzB,2BAA2B;IAC3B,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,aAAa;IACb,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;AACA,SAAS;AACT;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,OAAO;IACP,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;;IAGI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,WAAW;IACX,cAAc;IACd,+CAA+C;IAC/C,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,eAAe;AACnB;;AAaA;;IAEI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,WAAW;AACf;AACA,YAAY;AACZ;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,wCAAwC;IACxC,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,WAAW;IACX,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;AAC5B;AACA;IACI,SAAS;AACb;AACA;IACI,+BAA+B;IAC/B,cAAc,EAAE,0BAA0B;AAC9C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,iCAAiC;IACjC,eAAe;IACf,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;IACjC,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;;IAEI,kCAAkC;IAClC,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,SAAS;AACb;AACA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;;AAEA,UAAU;AACV;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;AACA,WAAW;AACX;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,YAAY;AAChB;AACA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;AACA,YAAY;AACZ;IACI,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,sCAAsC;IACtC,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,SAAS;IACT,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,QAAQ;AACZ;AACA;IACI,cAAc;IACd,SAAS;AACb;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,oBAAoB;IACpB,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,eAAe;IACf,0BAA0B;AAC9B;AACA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;AACA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,4BAA4B;AAChC;AACA,eAAe;;AAEf,aAAa;AACb;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;AACnB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,MAAM;AACV;AACA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,MAAM;IACN,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,aAAa;AACjB;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,6BAA6B;IAC7B;;;;KAIC;AACL;AACA;IACI,4BAA4B;IAC5B;;;;KAIC;AACL;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA,UAAU;AACV;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;AACA,WAAW;AACX;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;AACpB;AACA,iBAAiB;AACjB,cAAc;AACd;IACI,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA,iBAAiB;;AAEjB,sBAAsB;AACtB;IACI,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,+CAA+C;IAC/C,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;AACA;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;AACA;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B;;;;KAIC;IACD,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,6BAA6B;IAC7B;;;;KAIC;IACD,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,8BAA8B;IAC9B,SAAS;AACb;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,4DAA4D;IAC5D,4BAA4B;IAC5B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;AACA;IACI,YAAY;IACZ,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,YAAY;IACZ,UAAU;IACV,qBAAqB;IACrB,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;AACA;AACA;IACI,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,4BAA4B;IAC5B;;;;KAIC;AACL;AACA;IACI,8BAA8B;IAC9B;;;;KAIC;AACL;AACA;IACI,8BAA8B;IAC9B;;;;KAIC;AACL;AACA;IACI,6BAA6B;IAC7B;;;;KAIC;AACL;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oCAAoC;IACpC,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,oCAAoC;AACxC;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,aAAa;IACb,0BAA0B;AAC9B;AACA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,SAAS;IACT,+BAA+B;IAC/B,WAAW;IACX,gBAAgB;IAChB,2BAA2B;AAC/B;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,oCAAoC;IACpC,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,oCAAoC;IACpC,eAAe;IACf,WAAW;IACX,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,+CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,+CAA+C;IAC/C,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,+CAA+C;IAC/C,WAAW;IACX,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,+CAA+C;IAC/C,iBAAiB;AACrB;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,iCAAiC;IACjC,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,SAAS;IACT,+BAA+B;IAC/B,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;;IAEI,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,6BAA6B;IAC7B,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;AACA;AACA;IACI,qBAAqB;IACrB,yCAAyC;IACzC,4CAA4C;AAChD;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,qBAAqB;AACzB;;AAEA;AACA;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;AACA;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;IACV,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;AACA,wBAAwB;AACxB;;IAEI,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,WAAW;AACf;AACA;IACI,oCAAoC;IACpC,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;AACA;AACA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;IAC7B,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,qCAAqC;IACrC,yCAAyC;AAC7C;AACA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA,2BAA2B;;AAE3B;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;AACjB;AACA;;;GAGG;AACH;IACI,aAAa;AACjB;AACA;AACA;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,oBAAoB;IACpB,UAAU;IACV,8BAA8B;AAClC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,0BAA0B;AAC9B;AACA;;GAEG;AACH;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,oCAAoC;IACpC,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,4BAA4B;IAC5B,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,iBAAiB;AACrB;AACA;;IAEI,aAAa;AACjB;AACA;IACI,OAAO;AACX;AACA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,oCAAoC;IACpC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,0BAA0B;IAC9B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,sBAAsB;QACtB,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,wBAAwB;QACxB,kBAAkB;IACtB;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,iBAAiB;QACjB,wBAAwB;QACxB,kBAAkB;QAClB,WAAW;QACX,mBAAmB;QACnB,SAAS;QACT,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;IACA;QACI,cAAc;QACd,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,UAAU;QACV,WAAW;IACf;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,6BAA6B;IACjC;IACA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,SAAS;QACT,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;IACA;QACI,sBAAsB;QACtB,0BAA0B;IAC9B;IACA;QACI,aAAa;IACjB;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,0CAA0C;AAC1C;IACI;QACI,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,yBAAyB;IACzB,4CAAgD;IAChD;;;;6DAI0E;IAC1E,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,oCAAoC;IACpC,4CAAmD;IACnD;;;;;yBAKqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA,eAAe;AACf;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;;IAEI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,uBAAuB;IACvB,0DAA0D;IAC1D,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,oCAAoC;IACpC,cAAc;IACd,UAAU;AACd;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,gBAAgB;AACpB;AAOA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,0BAA0B;IAC1B,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA,OAAO;AACP;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,4DAA4D;IAC5D,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,4BAA4B;AAChC;;AAEA,SAAS;AACT;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;IAEV,aAAa;IACb,cAAc;AAClB;AACA;IACI,eAAe;IACf,WAAW;IACX,oCAAoC;IACpC,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,eAAe;IACf,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA,OAAO;AACP;IACI,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,UAAU;IACV,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,SAAS;IACT,WAAW;IACX,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,oCAAoC;IACpC,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;AACA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,oCAAoC;IACpC,UAAU;IACV,WAAW;IACX,YAAY;AAChB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;AAChC;AACA;;IAEI,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,iBAAiB;AACrB;AACA;;IAEI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;AAChD;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,oCAAoC;AACxC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,4DAA4D;IAC5D,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AAOA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,+CAA+C;AACnD;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,4DAA4D;AAChE;AACA;IACI,cAAc;IACd,2BAA2B;AAC/B;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,gBAAgB;AACpB;AACA;;;IAGI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;AACA;;IAEI,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,wBAAwB;IACxB,sBAAsB;IACtB,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,0BAA0B;IAC1B,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,UAAU;AACd;;AAEA,UAAU;AACV;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA,WAAW;AACX;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;;;IAGI,eAAe;IACf,WAAW;IACX,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;AACf;;AAEA;;;IAGI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,oCAAoC;IACpC,gBAAgB;AACpB;AACA;IACI,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,oCAAoC;IACpC,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,kCAAkC;IAClC,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,iDAAiD;AACrD;;AAEA,kBAAkB;AAClB,uBAAuB;AACvB;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,2BAA2B;IAC3B,qCAAqC;IACrC,mCAAmC;IACnC,eAAe;AACnB;AACA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;AACA,iBAAiB;AACjB;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IAInB,aAAa;IACb,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,SAAS;IAGT,4BAA4B;AAChC;;AAEA;IACI,mDAAmD;IACnD,kBAAkB;AACtB;AACA,iBAAiB;AACjB;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;IACd,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,cAAc;AACd;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,uBAAuB;IACvB,aAAa;IACb,WAAW;AACf;AACA,QAAQ;AACR;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;AAC/B;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;AACA,QAAQ;AACR,oBAAoB;AACpB;IACI,WAAW;AACf;AACA;IACI,qBAAqB;AACzB;AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,QAAQ;IACR,UAAU;IACV,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;IACxB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,SAAS;IACT,SAAS;IACT,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;AAC3B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,4DAA4D;IAC5D,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;AACA;IACI,4DAA4D;IAC5D,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA,eAAe;AACf;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,WAAW;IACX,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,oBAAoB;IACpB,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,4CAA4C;IAC5C,iCAAiC;IACjC,WAAW;IACX,WAAW;IACX,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;;AAEA,gBAAgB;;AAEhB,eAAe;AACf;;GAEG;AACH;IACI,iBAAiB;AACrB;AACA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;AACA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,+BAA+B;IAC/B,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,oCAAoC;IACpC,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,oCAAoC;IACpC,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;AACA;IACI,8BAA8B;AAClC;AACA;;GAEG;;AAEH;IACI,oCAAoC;IACpC,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,4BAA4B;AAChC;AACA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,6BAA6B;IAC7B,wCAAwC;IACxC,+CAA+C;IAC/C,oBAAoB;AACxB;;AAEA;;IAEI,sBAAsB;AAC1B;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,qCAAqC;IACrC,yCAAyC;AAC7C;AACA;IACI,gBAAgB;AACpB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,oBAAoB;AACxB;AACA;;;;IAII,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,wBAAwB;IACxB,UAAU;AACd;AACA;;IAEI,6BAA6B;IAC7B,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;IACnB,WAAW;IACX,wBAAwB;IACxB,cAAc;AAClB;AACA;IACI,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;AAC9B;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;;;GAGG;;AAEH;;;;;;;GAOG;AACH;;IAEI,2BAA2B;AAC/B;AACA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA,eAAe;AACf;IACI,YAAY;IACZ,mBAAmB;IACnB,4DAA4D;IAC5D,4BAA4B;IAC5B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,oCAAoC;IACpC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;AACA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,oCAAoC;IACpC,2BAA2B;IAC3B,yBAAyB;IACzB,YAAY;AAChB;;AAEA;AACA;;AAEA;;IAEI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,SAAS;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAmDI,kCAAkC;AACtC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAoDI,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,cAAc;IACd,gCAAgC;IAChC,kBAAkB;IAIlB,uBAAuB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAwGI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,+BAA+B;AACnC;AACA;;;IAKI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,OAAO;IACP,MAAM;IACN,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IAInB,wBAAwB;IAIxB,yBAAyB;IAIzB,oCAAoC;IACpC,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;IACb,cAAc;IAId,wBAAwB;IAIxB,yBAAyB;IAIzB,mCAAmC;IACnC,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gCAAgC;AACpC;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,wBAAwB;AAC5B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,wBAAwB;AAC5B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,wBAAwB;AAC5B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,wBAAwB;AAC5B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,wBAAwB;AAC5B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,0BAA0B;AAC9B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,2BAA2B;AAC/B;AACA;IAII,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;AACA;;IAEI,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;;IAEI,gCAAgC;AACpC;AACA;IACI,cAAc;AAClB;AACA;;IAEI,gCAAgC;AACpC;AACA;IACI,cAAc;AAClB;AACA;;IAEI,gCAAgC;AACpC;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,oCAAoC;IACpC,2BAA2B;IAC3B,yBAAyB;IACzB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,SAAS;IACT,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;AACA;;AAEA;IACI,oCAAoC;IACpC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,SAAS;IACT,eAAe;IACf,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,SAAS;AACb;AACA;IACI,oBAAoB;AACxB;AACA,kBAAkB;AAClB;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,UAAU;IACV,+CAA+C;IAC/C,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,qCAAqC;IACrC,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,iBAAiB;IACvD,0BAA0B,EAAE,gBAAgB;IAC5C,mBAAmB;IACnB,gBAAgB;EAClB;;AAEF;IACI,SAAS;IACT,eAAe;IACf,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,mCAAmC;IACnC,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,+CAA+C;IAC/C,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mDAAmD;IACnD,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB;;;GAGD;IACC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,6CAA6C;IAC7C,kBAAkB;AACtB;AACA;;IAEI,wBAAwB;AAC5B;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA,qBAAqB;AACrB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,oCAAoC;IACpC,kCAAkC;IAClC,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oCAAoC;AACxC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kCAAkC;IAClC,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,4CAA4C;IAC5C,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,4DAA4D;IAC5D,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;IACf,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,8BAA8B;AAClC;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;AAChC;AACA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,4CAA4C;IAC5C,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,2CAA2C;AAC/C;AACA;IACI,cAAc;IACd,cAAc;IACd,YAAY;IACZ,WAAW;AACf;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;AACA;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,oCAAoC;IACpC,WAAW;IACX,UAAU;AACd;;AAEA;IACI,qBAAqB,EAAE,0DAA0D;IACjF,yBAAyB,EAAE,yCAAyC;IACpE,eAAe,EAAE,iEAAiE;AACtF;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,SAAS;QACT,oBAAoB;QACpB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,MAAM;QACN,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,WAAW;QACX,kBAAkB;IACtB;;IAEA;;OAEG;;IAEH;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qBAAqB;QACrB,uBAAuB;IAC3B;;IAEA;QACI,UAAU;QACV,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;IACA;QACI,4BAA4B;QAC5B,sBAAsB;QACtB,6BAA6B;IACjC;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,6BAA6B;QAC7B,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,SAAS;QACT,aAAa;IACjB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;IACA,aAAa;IACb;QACI,eAAe;QACf,MAAM;QACN,WAAW;QACX,OAAO;QACP,mBAAmB;QACnB,aAAa;QACb,aAAa;QACb,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,qBAAqB;QACrB,yBAAyB;QACzB,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,2BAA2B;QAC3B,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,6BAA6B;QAC7B,WAAW;QACX,iBAAiB;IACrB;IACA;;OAEG;IACH;;QAEI,yBAAyB;IAC7B;IACA;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,QAAQ;QACR,YAAY;QACZ,eAAe;IACnB;;IAEA;;;;;;OAMG;IACH;QACI,sBAAsB;QACtB,0BAA0B;IAC9B;IACA;QACI,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,aAAa;QACb,iBAAiB;QACjB,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,oCAAoC;QACpC,eAAe;QACf,eAAe;QACf,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,aAAa;IACjB;IACA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;IAC/B,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,+BAA+B;IAC/B,2DAA2D;IAC3D,yBAAyB;IACzB,mBAAmB;IACnB,wBAAwB;AAC5B;AACA;IACI,2DAA2D;IAC3D,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,cAAc;IACd;+BAC2B;IAC3B,eAAe;IACf,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA,oDAAoD;AACpD;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA,KAAK;AACL,qBAAqB;AACrB;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;;;;;;;;;GASG;;AAEH;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,SAAS;AACb;;AAEA,KAAK;;AAEL;IACI,YAAY;IACZ,gBAAgB;IAChB,+BAA+B;IAC/B,gCAAgC;IAChC,2BAA2B;IAC3B,iDAAiD;AACrD;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB;;kCAE8B;IAC9B,gDAAgD;IAChD,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;IAC/B,mBAAmB;IACnB,4BAA4B;IAC5B,2CAA2C;AAC/C;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,+BAA+B;IAC/B,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,+BAA+B;IAC/B,sCAAsC;IACtC,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;;;;OAIG;IACH;QACI,eAAe;QACf,sCAAsC;IAC1C;AACJ;;AAEA;;;;;GAKG;;AAEH;IACI,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,qBAAqB;IACzB;IACA;;;;OAIG;IACH;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;AACrC;AACA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wCAAwC;IACxC,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;AACnC;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,aAAa;AACjB;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI;QACI,wBAAwB;QACxB,iCAAiC;IACrC;AACJ;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,WAAW;IACX,wBAAwB;IACxB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,SAAS;QACT,wBAAwB;IAC5B;AACJ;;AAEA;IACI,oBAAoB;IACpB,qBAAqB,EAAE,qBAAqB;IAC5C,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB,EAAE,qBAAqB;IAC5C,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;AACA;IACI,oDAAoD;IACpD,eAAe;AACnB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,8BAA8B;IAC9B,6BAA6B;;AAEjC;;AAEA;IACI,kCAAkC;IAClC,6BAA6B;IAC7B,aAAa;IACb,aAAa;IACb,eAAe;IACf,aAAa;AACjB;AACA;IACI,WAAW;AACf","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Light Theme */\n.light-theme {\n    --container-bg: #ffffff; /* White for light mode */\n    --shotcusttext: #171717;\n    --grey-comment: grey;\n    --container2-bg: #fff;\n    --viewBtn: #afafaf;\n    --tag: #ababab;\n    --userName: #000;\n    --hover-noti-color: #9f9f9f;\n    --hover-convo: #a6a6a6;\n    --event-box-shadow:1px 1px 10px gray;\n    --img-brightness:brightness(0);\n    --ourbelief-p:#202020;\n    --widget-bg:#fff;\n    --notes-textarea-color:#000;\n    --box-shadow:1px 1px 10px gray\n}\n\n/* Dark Theme */\n.dark-theme {\n    --container-bg: #171717; /* Existing dark background */\n    --container2-bg: #202020;\n    --shotcusttext: #fff;\n    --viewBtn: #4b4b4b;\n    --tag: #2f2f2f;\n    --userName: #fff;\n    --hover-noti-color: #353535;\n    --hover-convo: #393737;\n    --event-box-shadow:unset;\n    --img-brightness:brightness(1);\n    --ourbelief-p:#b4b4b4;\n    --widget-bg:#151515;\n    --notes-textarea-color:#fff;\n    --box-shadow:unset\n}\n\n.light-theme .shortcuticon img {\n    filter: brightness(0); /* Darkens the image completely */\n}\n\n/* Dark Theme - Normal Images */\n.dark-theme .shortcuticon img {\n    filter: brightness(1); /* Normal brightness */\n}\n\n.light-theme .profileimgUploadIcon img {\n    filter: brightness(0); /* Darkens the image completely */\n}\n\n/* Dark Theme - Normal Images */\n.dark-theme .profileimgUploadIcon img {\n    filter: brightness(1); /* Normal brightness */\n}\n\n.light-theme .postaction ul li img {\n    filter: brightness(0);\n}\n\n.dark-theme .postaction ul li img {\n    filter: brightness(1);\n}\n\n.dashbaoad-main {\n    display: flex;\n    align-items: stretch;\n    justify-content: flex-start;\n}\n\n.admin-dashboard-right {\n    width: calc(100% - 330px);\n    padding: 0px 40px 90px;\n}\n\n.header-menu-main-left ul {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n}\n\n.header-menu-main-left ul li + li {\n    margin: 0;\n    margin-top: 12px;\n}\n\n.header-menu-main-left ul li a::before {\n    display: none;\n}\n\n.header-menu-main-left ul li a {\n    display: block;\n    width: 100%;\n    padding: 18px;\n    border-radius: 0;\n}\n\n.header-menu-main-left ul li {\n    width: 100%;\n}\nheader {\n    background: #0e0e0e;\n}\n.header-menu-main-left ul li.active a,\n.header-menu-main-left ul li:hover a {\n    background: #3478ff;\n    color: #fff;\n}\n.admin-screen h2 {\n    color: #3478ff;\n    font-size: 48px;\n    font-weight: 700;\n    line-height: 62px;\n    /* font-family: \"ITCAvantGardeStd-Bold\"; */\n}\n.cate-tabs.quote-tabs ul li a {\n    border: 2px solid #393737 !important;\n    background: transparent !important;\n    color: rgb(255 255 255 / 40%) !important;\n    transition: 0.3s !important;\n    text-transform: capitalize !important;\n    width: auto !important;\n    padding: 15px 40px !important;\n}\n\n.cate-tabs.quote-tabs ul li a.active,\n.cate-tabs.quote-tabs ul li:hover a {\n    color: #161414 !important;\n    background: #fff !important;\n    opacity: 1 !important;\n    border: 2px solid #ffffff !important;\n}\n\n.cate-tabs.quote-tabs ul#nav-tab {\n    display: flex;\n    justify-content: flex-start;\n}\n.quote-content-inner {\n    padding: 18px;\n    border-radius: 12px;\n    background: #1b1919;\n}\n\n.quote-content-inner h3 {\n    color: #fff;\n    font-size: 22px;\n    line-height: 34px;\n    margin: 0 0 10px;\n}\n\n.price-profit {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 20px 0 20px;\n}\n\n.price-profit span {\n    text-transform: uppercase;\n    color: rgb(255 255 255 / 50%);\n    font-size: 12px;\n    line-height: 24px;\n    display: block;\n}\n\n.price-profit h4 {\n    color: #fff;\n    font-size: 22px;\n    line-height: 30px;\n    margin: 5px 0 0;\n}\n\n.right-profit h4 {\n    color: #40cc57;\n}\n\n.quote-by {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.user-img {\n    margin-right: 20px;\n}\n\n.quote-by span {\n    text-transform: uppercase;\n    color: rgb(255 255 255 / 50%);\n    font-size: 15px;\n    line-height: 24px;\n    display: block;\n}\n\n.quote-by h4 {\n    color: #fff;\n    font-size: 18px;\n    line-height: 26px;\n    margin: 0px 0 0;\n}\n.quote-tab-content-main {\n    margin-top: 30px;\n}\n.quote-content-inner a {\n    text-decoration: none !important;\n}\n.item-title h3 {\n    color: #fff;\n    opacity: 0.5;\n    font-size: 24px;\n    text-transform: uppercase;\n}\n\n.item-title a {\n    background: #fff;\n    width: 175px;\n    height: 46px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50px;\n    color: #1f2020;\n    font-size: 16px;\n    font-weight: 600;\n    text-decoration: none;\n}\n\n.iten-cart-main {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.qupte-img {\n    width: 190px;\n    height: 140px;\n    background: rgb(255 255 255 / 4%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 12px;\n    padding: 4px;\n}\n\n.qupte-img img {\n    max-width: 100%;\n    height: auto;\n}\n\n.quote-content-details h3 {\n    font-size: 24px;\n    line-height: 30px;\n    margin: 0;\n    color: #fff;\n    margin-bottom: 12px;\n}\n\n.quote-content-details p {\n    font-size: 18px;\n    line-height: 24px;\n    margin: 0;\n    opacity: 0.6;\n}\n\n.quote-row-inner {\n    display: flex;\n    align-items: center;\n}\n\n.quote-content-details {\n    margin-left: 25px;\n    width: calc(100% - 215px);\n}\n\n.cont-price {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.cont-price input,\n.cont-price select {\n    width: 60px;\n    height: 30px;\n    background: transparent;\n    outline: none;\n    border: none;\n    border-bottom: 1px solid #333131;\n    color: #fff;\n}\n\n.cont-price span {\n    color: #fff;\n    opacity: 0.5;\n    font-size: 16px;\n    line-height: 20px;\n    margin-right: 20px;\n}\n\n.cont-price {\n    color: #fff;\n    font-size: 20px;\n    line-height: 24px;\n    width: 100%;\n    margin-top: 12px;\n}\n\n.item-cost.apply-dis {\n    display: flex;\n    align-items: center;\n    margin-left: 30px;\n    background: #1f1d1d;\n    padding: 6px 15px;\n    border-radius: 5px;\n}\n\n.item-cost.qnty {\n    margin-left: 30px;\n}\n\n.item-cost.apply-dis b {\n    color: #fff;\n    opacity: 0.5;\n    font-size: 16px;\n    line-height: 20px;\n    margin-right: 20px;\n    margin-left: 20px;\n    font-weight: 400;\n}\n\n.input-dis input {\n    border: none;\n    width: 50px;\n    padding: 0;\n    text-align: right;\n    padding-right: 12px;\n}\n\n.input-dis {\n    border-bottom: 1px solid #333131;\n}\n\n.input-dis span {\n    margin: 0;\n}\n.item-in-cart-main {\n    margin-bottom: 10px;\n    margin-top: 30px;\n}\n.cont-price-left {\n    width: 70%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n.cont-price select option {\n    color: #333;\n    font-size: 16px;\n}\n.pack-main .cont-price {\n    justify-content: flex-start;\n}\n.pack-main > h3 {\n    color: #fff;\n    font-size: 28px;\n    margin-bottom: 35px;\n}\n\n.pack-main {\n    background: #1d1b1b;\n    padding: 40px;\n    border-radius: 15px;\n}\n.packag-main {\n    margin-top: 40px;\n}\n.quote-row + .quote-row {\n    border-top: 1px solid #262424;\n    margin-top: 30px;\n    padding-top: 30px;\n}\n.add-cart-left {\n    width: 40%;\n    display: flex;\n}\n\n.add-cart-left .item-title + .item-title {\n    margin-left: 15px;\n}\n\n.add-cart-left .item-title a {\n    width: auto;\n    padding: 0 30px;\n}\n\n.add-to-cart-inner {\n    margin-top: 40px;\n    display: flex;\n    justify-content: space-between;\n}\n.add-cart-right ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.add-cart-right ul li {\n    color: #fff;\n    font-size: 30px;\n    line-height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.add-cart-right {\n    width: 26%;\n}\n\n.add-cart-right ul li span {\n    opacity: 0.5;\n}\n\n.add-cart-right ul li + li {\n    margin-top: 5px;\n}\n/*popup */\n.popup-inner {\n    background: #1f2020;\n    width: 1250px;\n    border-radius: 25px;\n    padding: 40px;\n    position: relative;\n}\n\n.popup-main {\n    background: rgb(18 17 17 / 88%);\n    position: absolute;\n    top: 5%;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    z-index: 10;\n}\n\n.admin-screen {\n    position: relative;\n}\n.popup-main {\n    background: rgb(18 17 17 / 90%);\n    position: absolute;\n    top: 5%;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n}\n\n.admin-screen {\n    position: relative;\n}\n\n.popup-inner {\n    background: #1f2020;\n    width: 1150px;\n    border-radius: 25px;\n    position: relative;\n    top: 3%;\n    padding: 40px;\n}\n\n.poppup-close-btn {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    cursor: pointer;\n    z-index: 999;\n}\n\n.popup-content h3 {\n    color: #fff;\n    font-size: 40px;\n    margin: 0 0 25px;\n}\n\n.popup-content {\n    background-color: transparent !important;\n    width: fit-content !important;\n}\n\n.popup-form label {\n    margin: 0;\n    color: #fff;\n    opacity: 0.5;\n    font-size: 14px;\n    line-height: 20px;\n    display: block;\n    margin-bottom: 8px;\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n}\n\n.popup-form input,\n.popup-form select,\n.popup-form textarea {\n    background: transparent;\n    border: none;\n    outline: none;\n    width: 100%;\n    color: #fff;\n    padding: 8px 0;\n    border-bottom: 1px solid rgb(255 255 255 / 10%);\n    border-radius: 0;\n    resize: none;\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 14px;\n}\n.popup-form input::-webkit-input-placeholder,\n.popup-form select::-webkit-input-placeholder {\n    /* Edge */\n    color: #fff;\n}\n\n.popup-form input:-ms-input-placeholder,\n.popup-form select:-ms-input-placeholder {\n    /* Internet Explorer 10-11 */\n    color: #fff;\n}\n\n.popup-form input::placeholder,\n.popup-form select::placeholder {\n    color: #fff;\n}\n.field-has {\n    margin-top: 35px;\n}\n\n.field-has.fullwidth {\n    width: 75%;\n}\n\n.field-has.halfwidth {\n    width: 45%;\n}\n\n.field-has.halfwidth-main {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 75%;\n}\n\n.field-has.halfwidth-main .field-has {\n    margin: 0;\n}\n.popup-btn-submit {\n    margin-top: 35px;\n}\n.popup-main {\n    display: none;\n}\n.popup-main.active {\n    display: flex !important;\n}\n.popup-form select option {\n    color: #333;\n}\n/*popup end*/\n.title-btn {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 40px;\n}\n\n.sales-inner-box {\n    padding: 30px;\n    border-radius: 12px;\n    background: #1b1919;\n    text-align: center;\n}\n\n.sales-inner-image img {\n    width: 110px;\n    height: 110px;\n    border-radius: 100%;\n    object-fit: cover;\n    object-position: top;\n}\n\n.sales-title {\n    color: #fff;\n    font-size: 30px;\n    line-height: 34px;\n    margin: 0;\n    position: relative;\n    display: inline-block;\n}\n\n.sales-inner-image {\n    margin-bottom: 12px;\n}\n\n.sales-title.online:after {\n    content: \"\";\n    background: #40cc57;\n    width: 14px;\n    height: 14px;\n    border-radius: 100%;\n    position: absolute;\n    top: 7px;\n    right: -25px;\n}\n\n.totl-revenue span {\n    text-transform: uppercase;\n    color: rgb(255 255 255 / 50%);\n    font-size: 12px;\n    line-height: 21px;\n    display: block;\n}\n\n.totl-revenue h5 {\n    color: #fff;\n    font-size: 22px;\n    line-height: 25px;\n    margin: 8px 0 0;\n}\n\n.totl-revenue {\n    margin-top: 20px;\n}\n\n.send-chat-btn a {\n    text-decoration: none;\n    display: inline-block;\n    background: #3478ff;\n    color: #fff;\n    font-size: 16px;\n    width: 170px;\n    height: 50px;\n    line-height: 50px;\n    border-radius: 45px;\n}\n\n.send-chat-btn {\n    margin-top: 20px;\n}\n.sale-main {\n    margin-bottom: 30px;\n}\n.field-has.add-photo-box {\n    display: flex;\n    align-items: center;\n}\n\n.field-has.add-photo-box .item-title {\n    margin-left: 35px;\n}\n.regis-product-main {\n    margin-top: 60px;\n}\n.reg-pro-title-btn {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.reg-pro-title-btn h3 {\n    margin: 0;\n}\n\n.reg-pro-title-btn {\n    margin-bottom: 12px;\n}\n\n.cont-price.regis-product-content span {\n    display: block;\n    margin-bottom: 8px;\n}\n\n.cont-price.regis-product-content {\n    justify-content: flex-start;\n}\n\n.cont-price.regis-product-content .item-cost {\n    min-width: 15%;\n}\n.reg-pro-title-btn h3 a {\n    color: #fff;\n    text-decoration: none;\n}\n.popup-content h5 {\n    /* background: rgb(255 255 255 / 25%); */\n    /* display: inline-block; */\n    width: 170px;\n    font-size: 15px;\n    color: #fff;\n    /* text-align: center; */\n    /* line-height: 45px; */\n    border-radius: 60px;\n    /* margin: 0 0 0 40px; */\n}\n.popup-content.pro-reg-pop h3 {\n    margin: 0;\n}\np[contentEditable=\"true\"]:empty:before {\n    content: attr(data-placeholder);\n    color: #b1a4a4; /* Set placeholder color */\n}\n.popup-content.pro-reg-pop {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n.quote-content-details-popup .cont-price.regis-product-content {\n    flex-wrap: wrap;\n}\n\n.quote-content-details-popup .cont-price.regis-product-content .item-cost {\n    width: 33.3%;\n    margin-top: 30px;\n}\n\n.quote-content-details-popup .reg-pro-title-p.cont-price p {\n    font-size: 16px;\n    line-height: 26px;\n    margin-top: 8px;\n}\n.main-thumb-left {\n    display: flex;\n    align-items: stretch;\n    margin-top: 40px;\n    margin-bottom: 30px;\n}\n.ads-thumnails {\n    width: 100%;\n    height: calc(33.3% - 9px);\n    border-radius: 15px;\n    cursor: pointer;\n    background: rgb(255 255 255 / 5%);\n    max-width: 100%;\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.ads-thumnails img {\n    max-width: 100%;\n    height: 100%;\n}\n.ads-main-img {\n    width: calc(100% - 255px);\n    border-radius: 15px;\n    overflow: hidden;\n    background: rgb(255 255 255 / 5%);\n    height: 350px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n}\n.ads-main-img img {\n    height: auto;\n    max-width: 100%;\n}\n.ads-thumnails-main {\n    width: 240px;\n    margin-left: 15px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    margin-top: 0;\n    justify-content: space-between;\n    height: 350px;\n}\n.sales-title h4 {\n    font-size: 20px;\n}\n.helllo-name h3 {\n    color: #fff;\n    font-size: 40px;\n    line-height: 58px;\n}\n\n.helllo-name h3 span {\n    display: block;\n    font-size: 30px;\n}\n\n.helllo-name {\n    margin-bottom: 50px;\n    display: block;\n}\n.pro-tab.cate-tabs ul#nav-tab li a {\n    display: flex;\n    flex-direction: column;\n    border-radius: 15px;\n    padding: 40px 0 !important;\n}\n\n.pro-tab.cate-tabs ul#nav-tab li {\n    width: 32%;\n}\n\n.pro-tab.cate-tabs ul#nav-tab li img {\n    max-width: 155px;\n    height: auto !important;\n    margin: 0 auto;\n}\n\n.pro-tab.cate-tabs ul li a.active,\n.pro-tab.cate-tabs ul li:hover a {\n    background: transparent !important;\n    color: #fff !important;\n}\n.pro-main .reg-pro-title-btn h3 {\n    display: flex;\n    align-items: center;\n}\n\n.pro-main .reg-pro-title-btn h3 .feature {\n    width: 140px;\n    margin-left: 30px;\n}\n\n.pro-main .reg-pro-title-btn h3 input {\n    width: 15px;\n    margin-right: 7px;\n}\n\n.pro-main .reg-pro-title-btn h3 label {\n    font-size: 16px;\n    margin: 0;\n}\n.pro-main .item-cost {\n    color: #40cc57;\n}\n\n.pro-main .item-cost.red {\n    color: red;\n}\n.pro-main .item-title.showing a {\n    background: #3478ff;\n    color: #fff;\n}\n.pro-main .item-title.showing a i.fa {\n    margin-right: 7px;\n}\n.item-title.hidden a {\n    background: rgb(255 255 255 / 10%);\n    color: #fff;\n}\n\n.item-title.hidden a i.fa {\n    margin-right: 7px;\n}\na.add-feat {\n    transition: 0.3s;\n    font-size: 20px;\n    line-height: 24px;\n    display: table;\n    padding: 11px 48px;\n    color: #fff !important;\n    border-radius: 60px;\n    text-decoration: none;\n    outline: none;\n    border: 2px solid #fff;\n    margin-left: 15px;\n}\n.popup-btn-submit.pro-btn-two {\n    display: flex;\n    align-items: center;\n}\n.detail-view-left {\n    width: 50%;\n    display: flex;\n    align-items: center;\n}\n\n.detail-con {\n    margin-left: 20px;\n}\n\n.detail-con h3 {\n    color: #fff;\n    font-size: 28px;\n    line-height: 34px;\n    margin: 0 0 9px;\n}\n\n.detail-con h5 {\n    color: #fff;\n    opacity: 0.5;\n    font-size: 15px;\n    margin: 0 0 10px;\n}\n\n.detail-con h4 {\n    color: #ffff;\n    opacity: 0.7;\n    font-size: 18px;\n}\n\n.detail-con h4 span {\n    opacity: 0.5;\n    font-size: 15px;\n}\n.detail-view-right {\n    width: 50%;\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: column;\n}\n\n.detail-view-right a {\n    text-align: center;\n}\n\n.detail-view {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n.detail-view-right .send-chat-btn {\n    margin-top: 5px;\n    display: flex;\n    justify-content: flex-end;\n}\n.chart-img {\n    margin-top: 50px;\n}\n.remove-dealer a {\n    color: red;\n    padding-left: 20px;\n}\n\n.remove-dealer {\n    margin-top: 20px;\n}\n.dealer-ass > h5 {\n    font-size: 30px;\n    color: #fff;\n    opacity: 0.6;\n    margin-bottom: 20px;\n}\n\n.dealer-ass {\n    margin-top: 50px;\n}\n.detail-view-right .send-chat-btn a + a {\n    margin-left: 12px;\n}\n\n.detail-view-right .send-chat-btn.client-more-detail a {\n    background: #272424;\n}\n\n.detail-view-right .send-chat-btn.client-more-detail {\n    margin-top: 18px;\n}\n.bix-det-view h3 {\n    color: #fff;\n    margin: 0;\n    font-size: 24px;\n}\n\n.bix-det-view {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.client-ass {\n    margin-top: 50px;\n}\n.order-list ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.order-list ul li {\n    background: #343232;\n    border-radius: 6px;\n    text-align: left;\n    padding: 25px 28px;\n    color: #fff;\n    font-size: 20px;\n}\n\n.order-list ul li + li {\n    margin-top: 12px;\n}\n\n.order-list {\n    margin-top: 30px;\n    height: 380px;\n    overflow-y: auto;\n    padding-right: 10px;\n}\n.scrol-bar::-webkit-scrollbar {\n    width: 4px;\n}\n\n/* Track */\n.scrol-bar::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 0px grey;\n    border-radius: 10px;\n}\n/* Handle */\n.scrol-bar::-webkit-scrollbar-thumb {\n    background: #6a6a6a;\n    border-radius: 10px;\n}\n\n/* Handle on hover */\n.scrol-bar::-webkit-scrollbar-thumb:hover {\n    background: #6a6a6a;\n}\n.reg-pro-list img {\n    max-width: 130px;\n}\n\n.reg-pro-list .qupte-img {\n    width: 140px;\n    height: 100px;\n}\n\n.reg-pro-list .quote-content-details {\n    text-align: left;\n}\n.reg-pro-list {\n    margin-top: 30px;\n    height: 380px;\n    overflow-y: auto;\n    padding-right: 10px;\n}\n.chart-img img {\n    max-width: 100%;\n}\n.ticket-box {\n    background: #1b1919;\n    border-radius: 25px;\n    display: flex;\n    align-items: stretch;\n    justify-content: space-between;\n}\n\n.ticket-box-left {\n    padding: 28px;\n    width: 70%;\n}\n\n.ticket-title h3,\n.ticket-title h3 a {\n    color: #fff;\n    font-size: 26px;\n    line-height: 34px;\n    margin: 0;\n    text-decoration: none;\n}\n\n.send-chat-btn.tick-btn a {\n    width: auto;\n    padding: 0 20px;\n}\n.send-chat-btn.tick-btn {\n    margin: 0;\n    margin-left: 40px;\n}\n\n.ticket-title {\n    display: flex;\n    align-items: center;\n}\n.tick-date h4,\n.tuckt-desc h4 {\n    color: #fff;\n    opacity: 0.5;\n    font-size: 14px;\n    text-transform: uppercase;\n}\n\n.tick-date p,\n.tuckt-desc p {\n    font-size: 14px;\n    line-height: 24px;\n}\n\n.tuckt-desc {\n    margin-top: 20px;\n}\n\n.ticket-title {\n    margin-bottom: 20px;\n}\n.ticket-box-right {\n    width: 30%;\n    background: #272525;\n    padding: 30px;\n    border-radius: 0 25px 25px 0;\n}\n\n.notes-main-sc .tick-date + .tick-date {\n    margin-top: 15px;\n    padding-top: 14px;\n    border-top: 1px solid #353333;\n}\n.notes-main-sc.scrol-bar {\n    height: 200px;\n    overflow-y: auto;\n    padding-right: 10px;\n}\n.ticket-row + .ticket-row {\n    margin-top: 30px;\n}\n.tick-green a {\n    background: #40cc57;\n}\n.tick-gray a {\n    background: #494747;\n}\n\n.tick-det .ticket-box {\n    background: transparent;\n    border-radius: 0;\n}\n\n.tick-det .ticket-box .ticket-box-left {\n    padding-left: 0;\n}\n\n.tick-det .ticket-box .ticket-box-left .tick-poin {\n    position: relative;\n    padding-left: 30px;\n}\n\n.tick-det .ticket-box .ticket-box-left .tick-poin:before {\n    content: \"\";\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    background: #ffffff;\n    position: absolute;\n    left: 0;\n    top: 8px;\n    opacity: 0.2;\n}\n\n.tick-det .ticket-box .ticket-box-left .tick-poin:after {\n    content: \"\";\n    width: 3px;\n    height: 70%;\n    border-radius: 0;\n    background: #ffffff;\n    position: absolute;\n    left: 6px;\n    top: 33px;\n    opacity: 0.2;\n}\n.tick-poin h3 {\n    font-size: 26px;\n    color: #fff;\n    margin-bottom: 15px;\n}\n\n.tick-poin p {\n    font-size: 15px;\n    line-height: 27px;\n}\n\n.tick-poin p span {\n    display: block;\n    margin-bottom: 2px;\n}\n\n.tick-det .ticket-box .ticket-box-left .tick-poin + .tick-poin {\n    margin-top: 40px;\n}\n.ticket-box-right.tick-det-not {\n    background: transparent;\n    padding: 0;\n    border-radius: 0;\n}\n\n.ticket-box-right.tick-det-not .notes-main-sc {\n    background: #272525;\n    padding: 30px;\n    border-radius: 20px;\n}\n\n.ticket-box-right.tick-det-not .notes-main-sc + .notes-main-sc {\n    margin-top: 30px;\n}\n/*chat box */\n.group-chat-left {\n    width: 70%;\n    background: #222020;\n    border-radius: 12px;\n    box-shadow: 0 0 10px #0e0e0e;\n    padding: 20px 30px;\n}\n.chat-box-right .group-chat-left {\n    width: 100%;\n    width: 340px;\n    padding: 12px;\n    border-radius: 12px 12px 0 0;\n}\n.group-chat-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-bottom: 22px;\n    border-bottom: 1px solid rgb(51 48 48);\n    margin-bottom: 30px;\n}\n.group-chat-bar-left {\n    display: flex;\n    align-items: center;\n}\n.comnam {\n    margin-left: 13px;\n}\n.comnam h3 {\n    color: #fff;\n    font-size: 22px;\n    line-height: 30px;\n    margin: 0px 0 2px;\n}\n.comnam h4 {\n    color: #fff;\n    font-size: 13px;\n    line-height: 13px;\n    margin: 4px 0px 0;\n    opacity: 0.4;\n}\n.member-chats ul {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n.chat-box-right .member-chats ul {\n    min-height: 260px;\n    padding: 0;\n}\n.member-chats li {\n    display: flex;\n    margin-bottom: 45px;\n    max-width: 100%;\n}\n.member-chats li.right {\n    width: 100%;\n    flex-direction: column;\n}\n.list-box {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n.member-chats .list-box {\n    align-items: flex-end;\n    position: relative;\n    width: auto;\n}\n.member-chats li.right .list-box {\n    flex-direction: row-reverse;\n}\n.member-chats li.right .list-box .mem-chat {\n    margin: 0;\n    margin-right: 12px;\n    border-radius: 12px 12px 0px 12px;\n    background: #3478ff;\n    margin: 0 !important;\n    padding: 12px;\n    position: relative;\n}\n.chat-box-right .group-chat-left .mem-chat p {\n    font-size: 14px;\n    line-height: 16px;\n    color: #fff;\n    opacity: 1;\n}\n.member-chats .list-box .date {\n    position: absolute;\n    color: #9999a5;\n    bottom: -28px;\n    right: 0;\n}\n.member-chats .right .list-box .date {\n    right: initial;\n    left: 3px;\n}\n.member-chats .list-box .date h6 {\n    font-size: 12px;\n}\n.chat-box-right .group-chat-left .left .mem-chat {\n    background: #2d2b2b;\n    border-radius: 12px 12px 12px 0px;\n    margin: 0 !important;\n    padding: 12px;\n}\n.chat-type-box {\n    display: flex;\n    align-items: center;\n    border-top: 1px solid rgb(52 51 75 / 8%);\n    margin-top: 20px;\n    padding-top: 20px;\n}\n.chat-box-right .chat-type-box {\n    padding: 12px 0 0;\n    display: none;\n}\n.chat-type-box textarea {\n    padding: 20px 0 0;\n    resize: none;\n    width: 100%;\n    border: none;\n    outline: none;\n}\n.chat-box-right .chat-type-box textarea {\n    height: 44px;\n    padding: 10px 0 0;\n    background: transparent;\n}\n.chat-box-right .chat-type-box button {\n    background: #f39721;\n    border: none;\n    color: #fff;\n    width: 40px !important;\n    height: 40px;\n    border-radius: 100%;\n    font-size: 16px;\n    font-family: \"gilroysemibold\";\n    margin-left: 20px;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    outline: none;\n    cursor: pointer;\n    padding: 0 14px;\n    -webkit-appearance: button;\n}\n.member-chats li a {\n    text-decoration: none;\n    pointer-events: none;\n}\n.chat-box-right {\n    display: flex !important;\n    align-items: center;\n    justify-content: flex-end;\n    width: 100%;\n    padding-right: 20px;\n    margin-top: 60px;\n}\n.no-pad-bottom {\n    padding-bottom: 0 !important;\n}\n/*chat box end*/\n\n/*client CRM*/\n.title-quote h3 {\n    margin-bottom: 8px;\n}\n\n.title-quote {\n    margin-bottom: 8px;\n}\nh4.def-heading {\n    color: #fff;\n    text-decoration: none;\n    font-size: 28px;\n    margin-bottom: 20px;\n}\n.cont-price.regis-product-content-quote-client-main {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 0;\n}\n\n.cont-price.regis-product-content-quote-client-left {\n    width: 40%;\n    justify-content: flex-start;\n}\n\n.cont-price.regis-product-content-quote-client-left .item-cost + .item-cost {\n    margin-left: 30px;\n}\n\n.cont-price.regis-product-content-quote-client-right {\n    width: 30%;\n    display: flex;\n    justify-content: flex-end;\n}\n.regis-product-content-quote-client-main .item-cost {\n    min-width: auto;\n}\n\n.regis-product-content-quote-client-main .item-cost span {\n    display: inline-block;\n}\n.regis-product-main-quo-inner {\n    background: #1d1b1b;\n    border-radius: 25px;\n    padding: 0;\n    display: flex;\n    align-items: stretch;\n    justify-content: space-between;\n}\n\nh4.def-heading span {\n    color: #fff;\n    opacity: 0.4;\n    font-size: 14px;\n    margin-left: 20px;\n}\n\nh4.def-heading span i {\n    font-style: normal;\n}\n\nh4.def-heading {\n    display: flex;\n    align-items: center;\n}\n\n.list-slider-inner {\n    background: #262424;\n    padding: 20px;\n    border-radius: 20px;\n    margin-right: 12px;\n}\n\n.list-slider-inner img {\n    display: table;\n    margin: 0 auto;\n    max-width: 100%;\n}\n.title-desc h3 {\n    color: #fff;\n    font-size: 18px;\n    line-height: 24px;\n    margin: 0;\n}\n\n.title-desc {\n    margin-top: 20px;\n}\n\n.title-desc h4 {\n    color: #fff;\n    font-size: 14px;\n    line-height: 24px;\n    opacity: 0.4;\n    margin: 5px 0 0;\n}\n\n.title-desc h2 {\n    font-size: 20px;\n    font-weight: 400 !important;\n    margin-top: 4px;\n    line-height: 30px;\n}\n.slick-next:before {\n    content: \"\" !important;\n    width: 11px !important;\n    height: 20px !important;\n    position: absolute;\n    left: -12px;\n    top: 0;\n}\n.slick-prev:before {\n    content: \"\" !important;\n    width: 11px !important;\n    height: 20px !important;\n    position: absolute;\n    left: 4px;\n    top: 0;\n    transform: rotate(180deg);\n}\n.quot-cl-left {\n    width: 78%;\n    padding: 30px;\n}\n.quote-cl-right {\n    width: 22%;\n    background: #262424;\n    border-radius: 25px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n}\n.status-box h5 {\n    background: #e6aa4f;\n    border-radius: 40px;\n    color: #fff;\n    text-align: center;\n    font-size: 16px;\n    padding: 9px 20px;\n}\n.status-box.green h5 {\n    background: #40cc57;\n}\n\n.status-box {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.quote-cl-right h4 {\n    color: #fff;\n    opacity: 0.4;\n    text-align: center;\n    font-size: 18px;\n}\n\n.item-view-all a {\n    color: #333;\n    background: #fff;\n    padding: 12px 30px;\n    border-radius: 50px;\n    text-decoration: none;\n}\n\n.item-view-all {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.total-cost-quote h3 {\n    color: #3478ff;\n    text-align: center;\n    font-weight: 600;\n}\n.regis-product-main-quo + .regis-product-main-quo {\n    margin-top: 30px;\n}\n.client-crm-account {\n    display: flex;\n    align-items: center;\n}\n\n.client-crm-account .sales-inner-image {\n    margin-right: 30px;\n}\n.account-left-det .popup-inner {\n    width: 100%;\n    box-sizing: border-box;\n    position: static;\n}\n\n.account-left-det .popup-inner .field-has.halfwidth-main {\n    width: 100%;\n}\n.sales-inner-image h4 {\n    font-size: 28px;\n    margin: 20px 0 5px;\n    color: #fff;\n}\n\n.sales-inner-image h5 {\n    color: #fff;\n    opacity: 0.4;\n    font-size: 16px;\n    margin-bottom: 30px;\n}\n\n.sales-inner-image {\n    text-align: center;\n}\n\n.sales-inner-image p {\n    opacity: 0.6;\n    font-size: 16px;\n    line-height: 35px;\n}\n.row.ac-row {\n    display: flex;\n    align-items: stretch;\n}\n\n.account-left-det.account-right-det .popup-inner {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n}\n.sales-inner-box.blue-gra {\n    background: rgb(52, 120, 255);\n    background: linear-gradient(\n        0deg,\n        rgba(52, 120, 255, 1) 0%,\n        rgba(160, 187, 241, 1) 100%\n    );\n}\n.sales-inner-box.green-gra {\n    background: rgb(63, 220, 94);\n    background: linear-gradient(\n        0deg,\n        rgba(63, 220, 94, 1) 0%,\n        rgba(138, 233, 157, 1) 100%\n    );\n}\n\n.account-det-gra .sales-inner-box li {\n    background: transparent;\n    padding: 20px 0 16px;\n}\n\n.account-det-gra .sales-inner-box li + li {\n    border-top: 1px solid;\n    border-radius: 0;\n}\n/* Track */\n.account-det-gra .scrol-bar::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 0px #fff;\n    border-radius: 10px;\n}\n/* Handle */\n.account-det-gra .scrol-bar::-webkit-scrollbar-thumb {\n    background: #fff;\n    border-radius: 10px;\n}\n\n/* Handle on hover */\n.account-det-gra .scrol-bar::-webkit-scrollbar-thumb:hover {\n    background: #fff;\n}\n/*client CRM END*/\n/*dealer crm */\n.admin-dashboard-right.dealer-accountpage {\n    padding: 0;\n}\n\n.admin-dashboard-right.dealer-accountpage .quote-main-right {\n    padding: 40px 40px 100px;\n}\n\n.banner-dealer {\n    position: relative;\n}\n\n.banner-dealer img {\n    width: 100%;\n    height: auto;\n}\n\n.banner-dealer .banner-text {\n    position: absolute;\n    bottom: 60px;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    width: 100%;\n    text-align: center;\n}\n\n.banner-dealer .banner-text h3 {\n    color: #fff;\n    font-weight: 700;\n    font-size: 50px;\n    line-height: 60px;\n    margin-bottom: 10px;\n}\n\n.banner-dealer .banner-text p {\n    font-size: 24px;\n    line-height: 30px;\n}\n/*dealer crm end*/\n\n/*redefinie-css start*/\n.admin-main-dashboard.redefine-crm {\n    padding-top: 120px;\n    padding-bottom: 90px;\n}\n.top-menu-inner ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    background: #0e0e0e;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.top-menu-inner ul li a {\n    color: #6a6a6a;\n    font-size: 21px;\n    text-decoration: none;\n    padding: 20px 0;\n    display: block;\n}\n\n.top-menu-inner ul li + li {\n    padding-left: 100px;\n}\n\n.top-dashboard-menu {\n    border-radius: 12px !important;\n    max-width: 80%;\n    margin: 0 auto 30px;\n    overflow: hidden;\n}\n.titbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.titbar h2 {\n    color: #fff;\n    font-family: \"Open Sans\", sans-serif !important;\n    font-size: 48px;\n}\n\n.titbar a {\n    background: #3478ff;\n    color: #fff;\n    display: block;\n    padding: 11px 20px;\n    margin-top: -4px;\n    border-radius: 20px;\n}\n\n.titbar {\n    margin-bottom: 30px;\n}\n.checkin-group {\n    background: #171717;\n    border-radius: 12px;\n    padding: 30px;\n}\n\n.checkin-group-title h3 {\n    color: #fff;\n    font-size: 30px;\n}\n\n.checkin-group-title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.checkin-group-title a {\n    text-decoration: underline;\n    color: #6a6a6a;\n    text-underline-position: under;\n    font-weight: 600;\n}\n.inner-box-grp {\n    background: #232323;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 230px;\n    border-radius: 12px;\n}\n\n.group-box .row {\n    display: flex;\n    align-items: stretch;\n}\n\n.group-box {\n    margin-top: 20px;\n}\n.checkin-group + .checkin-group {\n    margin-top: 40px;\n}\n.checkin-group .popup-form {\n    max-width: 50%;\n}\n\n.checkin-group .field-has.fullwidth {\n    width: 100%;\n}\n.checkin-group button.has-btn {\n    background: #fff;\n    color: #080808;\n    padding: 12px 30px;\n}\n.checkpbox label {\n    text-transform: capitalize !important;\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 18px;\n    /* color: #3478ff; */\n    opacity: 0.5;\n    font-weight: 600;\n}\n\nlabel {\n}\n\n.checkpbox {\n    display: flex;\n    align-items: center;\n}\n\n.checkpbox input {\n    width: 17px;\n    position: relative;\n    top: 0px;\n    height: 14px;\n}\n\n.checkpbox label + label {\n    margin-left: 21px;\n}\n.bannerfull-content h3 {\n    font-size: 60px !important;\n    margin: 0 0 10px;\n    color: #fff !important;\n}\n\n.full-banner-dash {\n    position: relative;\n}\n\n.bannerfull-content {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    background: rgb(0 0 0 / 45%);\n    padding: 20px 0;\n}\n\n.bannerfull-content p {\n    padding-left: 15px;\n}\n.full-input.dolr input:first-child {\n    width: 12px;\n}\n.full-input.dolr.do_one_time {\n    display: flex;\n}\n.full-input.dolr.do_one_time {\n    display: flex;\n}\n\ni.fa.fa-calendar {\n}\n\n.full-input.date-pic i.fa {\n    position: absolute;\n    right: 20px;\n    top: 13px;\n}\n\n.full-input.date-pic {\n    position: relative;\n}\n.white-con {\n    background: #fff;\n    padding: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    text-align: center;\n    border-radius: 20px;\n    height: 100%;\n}\n\n.white-con-inner {\n    width: 100%;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n.per-img img {\n    max-width: 92%;\n}\n\n.has-sec-2-group-.home-giv-form .row {\n    display: flex;\n    align-items: stretch;\n}\n\n.white-con-inner h2 {\n    color: #fc6060;\n    font-size: 80px;\n    line-height: 90px;\n}\n\n.white-con-inner h3 {\n    color: #fc5858;\n}\n\n.white-con-inner p {\n    color: #000;\n    max-width: 450px;\n    margin: 0 auto;\n    font-size: 20px;\n}\n.sec-2asd .white-con {\n    text-align: left;\n}\n\n.sec-2asd .white-con-inner-select {\n    display: flex;\n    align-items: flex-start;\n}\n.sec-2asd .white-con-inner-select {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: 100%;\n    margin-bottom: 110px;\n}\n.sec-2asd .col-md-6.white-content {\n    min-height: 450px;\n}\n.has-2statemnt .white-con-inner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.has-2statemnt {\n    position: relative;\n}\n.white-con-inner-select select {\n    height: 45px;\n    width: 150px;\n    padding: 0 4px;\n}\n.has-2statemnt h2 {\n    font-size: 180px;\n    position: absolute;\n    left: 0;\n    opacity: 0.2;\n}\n\n.has-2statemnt h4 {\n    font-weight: 700;\n    text-align: center;\n    line-height: 34px;\n}\n.budg-bo-iunner a {\n    text-decoration: none !important;\n}\n.has-white2 .box-1-giv {\n    height: 450px;\n    margin: 0;\n}\n.has-sec-12 .white-con-inner {\n    width: 100%;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n}\n.give-content3-inner-purple {\n    background: rgb(213, 175, 255);\n    background: linear-gradient(\n        90deg,\n        rgba(213, 175, 255, 1) 0%,\n        rgba(157, 83, 241, 1) 100%\n    );\n    border-radius: 20px;\n    padding: 20px;\n    min-height: 48%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.give-content3-inner-purple h3 {\n    color: #fff;\n    font-size: 44px;\n    line-height: 58px;\n}\n\n.titl-eg h3 {\n    font-size: 36px;\n}\n\n.boton-g-content p {\n    color: #000;\n    font-size: 20px;\n    line-height: 28px;\n}\n.caht-mem-main-inner {\n    background: #171717;\n    padding: 30px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    border-radius: 12px;\n    text-align: center;\n}\n\n.caht-mem-main-inner h3 {\n    color: #fff;\n    font-size: 20px;\n    margin: 10px 0 10px;\n}\n\n.mem-btn a {\n    background: #3478ff;\n    color: #fff;\n    width: 150px;\n    display: block;\n    margin: 0 10px;\n    padding: 8px 10px;\n    border-radius: 5px;\n    text-decoration: none;\n    transition: 0.3s;\n}\n\n.mem-btn {\n    display: flex;\n    align-items: center;\n    margin-top: 22px;\n}\n.caht-mem-main {\n    margin-top: 30px;\n}\n.mem-btn a:hover {\n    background: #204ba0;\n}\n.box-content-jhas-orange {\n    background: rgb(245, 123, 79);\n    background: linear-gradient(\n        90deg,\n        rgba(245, 123, 79, 1) 0%,\n        rgba(217, 77, 46, 1) 100%\n    );\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 48%;\n    margin-top: 17px;\n}\n\n.box-content-jhas-orange img {\n    max-width: 350px;\n    height: auto;\n    width: 100%;\n}\n\n.box-content-jhas {\n    height: 50%;\n}\n.box-content-jhas {\n    background: #fff;\n    border-radius: 20px;\n    padding: 20px;\n}\n\n.box-content-jhas h2 {\n    color: #000;\n    font-size: 35px;\n}\n\n.box-content-jhas ul {\n    list-style: none;\n    padding: 0;\n    margin: 20px 0 0;\n}\n\n.box-content-jhas ul li {\n    font-size: 20px;\n}\n\n.box-content-jhas ul li + li {\n    margin-top: 13px;\n    border-top: 1px solid #ccc;\n    padding-top: 12px;\n}\n.weljor h3.wel-back span {\n    display: block;\n    font-size: 60px;\n    margin-top: 20px;\n}\n.weljor .not-you-btn a {\n    background: #fff;\n    color: #4d88fd;\n    text-decoration: none;\n    text-align: center;\n    padding: 12px 10px;\n    margin: 5px 0;\n    border-radius: 5px;\n}\n\n.weljor .not-you-btn {\n    width: 250px;\n    display: flex;\n    flex-direction: column;\n}\n\n.weljor .home-about-form {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\nh3.wel-back span {\n    display: block;\n}\n.full-input.fwidth textarea {\n    resize: none;\n    height: 60px;\n    margin-top: 20px;\n}\n.give-form textarea {\n    background: 0 0;\n    border: none;\n    outline: 0;\n    border-bottom: 1px solid #fff;\n    border-radius: 0;\n    padding: 12px 0;\n    width: 100%;\n    color: #fff;\n    color: #fff;\n    margin-bottom: 15px;\n    font-size: 15px;\n    font-family: \"Open Sans\", sans-serif;\n}\n.watch-main .white-con-inner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n.wahtc-3 .give-content3-inner-purple {\n    height: 412px;\n}\n.give-content3-inner-purple.box-content-jhas-orange {\n    display: flex;\n    align-items: stretch;\n    justify-content: space-between;\n    margin: 0;\n}\n.col-md-6.white-content.orange-bg {\n    position: relative;\n}\n\nimg.ab-img {\n    position: absolute;\n    width: 310px;\n    right: 40px;\n    top: 20px;\n}\n.col-md-12.title-co h3 {\n    text-align: center;\n    color: #fff;\n    font-size: 36px;\n}\n\n.sec.dont-forget {\n    margin-top: 50px;\n}\n\n.for-box-innner {\n    background: #171717;\n    border-radius: 20px;\n    padding: 30px;\n    color: #fff;\n}\n\n.for-box-innner h4 {\n    font-size: 22px;\n    font-weight: 600;\n}\n\n.for-box-innner h5 {\n    opacity: 0.7;\n    font-size: 16px;\n    margin: 15px 0 20px;\n    font-family: \"Open Sans\", sans-serif;\n}\n\n.btn-accpt-dec {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 40px;\n}\n\n.btn-accpt-dec a {\n    color: #fff;\n    background: #28a830;\n    margin: 0 10px;\n    width: 190px;\n    height: 55px;\n    line-height: 55px;\n    border-radius: 5px;\n    text-align: center;\n}\n.btn-accpt-dec a + a {\n    background: #ff3434;\n}\n.col-md-12.title-co {\n    margin-bottom: 30px;\n}\n.sec.celife-code {\n    margin-top: 50px;\n    margin-bottom: 40px;\n}\n\n.sec.celife-code h2 {\n    color: #fff;\n    font-size: 36px;\n    margin-bottom: 20px;\n}\n\n.sec.celife-code .for-box-innner + .for-box-innner {\n    margin-top: 30px;\n}\n\n.sec.celife-code .for-box-innner {\n    height: 50%;\n}\n\n.mainlead {\n    display: flex;\n}\n\n.lead-img {\n    margin-right: 20px;\n}\n\n.sec.celife-code p {\n    font-size: 18px;\n    line-height: 30px;\n}\n.ful-cob-sec .for-box-innner {\n    height: calc(100% + 30px) !important;\n}\n\n.ful-cob-sec .for-box-innner ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.ful-cob-sec .for-box-innner ul li + li {\n    margin-top: 20px;\n    font-family: \"Open Sans\", sans-serif;\n}\n\n.ful-cob-sec .for-box-innner ul li {\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 20px;\n    line-height: 36px;\n}\n.titbar.search-field input {\n    background: transparent;\n    border: 1px solid #3b3939;\n    width: 82%;\n    height: 60px;\n    border-radius: 7px;\n    color: #fff;\n}\n.titbar.search-field input:focus {\n    outline: none;\n}\n.limit-chars-with-dots {\n    width: auto;\n    overflow: hidden;\n    display: inline-block;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.cht-box-inner {\n    background: #232323;\n    border-radius: 8px;\n}\n\n.cht-box-inner img {\n    width: 100%;\n    height: 250px;\n}\n\n.peo-con {\n    background-color: black;\n    padding: 20px 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n}\n\n.peo-con a {\n    color: #fff;\n}\n\n.cat-main {\n    margin-bottom: 30px;\n}\n.detail-people {\n    height: 100%;\n    background: #b5cbf6;\n    background: linear-gradient(149deg, #b5cbf6 0, #3478ff 100%);\n    border-radius: 20px 20px 0 0;\n    padding: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.fam-left {\n    /*width: 75%;*/\n    display: flex;\n    align-items: self-start;\n}\n\n.fam-right {\n    width: 25%;\n}\n\n.det0pro {\n    margin-left: 30px;\n}\n\n.det0pro h3 {\n    color: #fff;\n    font-size: 34px;\n    line-height: 48px;\n}\n\n.det0pro h5 {\n    color: #fff;\n}\n\n.det0pro h6 {\n    color: #fff;\n    margin-top: 60px;\n}\n\n.det0pro ul {\n    display: flex;\n    align-items: center;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    margin-top: 15px;\n}\n\n.det0pro ul li img {\n    max-width: 45px;\n}\n\n.det0pro ul li + li {\n    margin-left: 10px;\n}\n\n.phot-btn {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.phot-btn a {\n    color: #fff;\n    background: #377aff;\n    padding: 12px;\n    border-radius: 6px;\n    margin-top: 20px;\n}\n.fam-right ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.fam-right ul li {\n    text-align: center;\n    background: rgb(255 255 255 / 22%);\n    padding: 12px 20px;\n    height: 80px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n}\n\n.fam-right ul li + li {\n    margin-top: 12px;\n}\n\n.fam-right ul li p {\n    font-size: 18px;\n    line-height: 26px;\n}\n.white-det {\n    background: #fff;\n    border-radius: 0 0 20px 20px;\n}\n\n.white-det ul {\n    display: flex;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    align-items: center;\n    justify-content: space-around;\n}\n\n.white-det ul li a {\n    color: #000;\n    font-size: 18px;\n    font-weight: 700;\n    padding: 16px 0;\n    display: block;\n}\n.col2-info-fam .ful-cob-sec .for-box-innner ul li span {\n    opacity: 0.5;\n    width: 39%;\n    display: inline-block;\n}\n\n.col2-info-fam .ful-cob-sec .for-box-innner ul li {\n    font-family: \"Open Sans\", sans-serif !important;\n    font-size: 16px;\n    line-height: 32px;\n}\n.check-boxin input {\n    width: 15px;\n    margin-right: 10px;\n}\n\n.check-boxin label {\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 19px;\n    margin-bottom: 11px;\n}\n\n.check-boxin {\n    display: flex;\n    flex-direction: column;\n    margin-top: 17px;\n}\n\n.form-edit-pro h4 {\n    opacity: 0.6;\n}\n.for-box-innner h4 {\n    opacity: 0.6;\n}\n\n.form-edit-pro {\n    margin-bottom: 30px;\n}\n.rest-pas input {\n    border: none;\n    background: transparent;\n    outline: none;\n    border-bottom: 1px solid #3c3c3c;\n    padding: 10px 0;\n    border-radius: 0;\n}\n\n.rest-pas input[type=\"submit\"] {\n    color: #fff;\n    color: #fff;\n    background: #377aff;\n    padding: 12px 30px;\n    border-radius: 6px;\n    margin-top: 20px;\n    margin-left: 20px;\n    width: auto;\n}\n.col2-info-fam .ful-cob-sec .for-box-innner ul li span {\n    opacity: 0.5;\n    width: 27%;\n    display: inline-block;\n    font-family: \"Open Sans\", sans-serif;\n}\n.bel-asign-team a {\n    color: #fff;\n    background: #377aff;\n    padding: 12px;\n    border-radius: 6px;\n    margin-top: 20px;\n    margin-right: 20px;\n}\n\n.tik-bell {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 40px;\n}\n\n.tik-bell h2 {\n    margin: 0 !important;\n}\n\n.tik-bell {\n}\n.new-h .ful-cob-sec {\n    margin-bottom: 60px;\n}\n.has-tim .for-box-innner {\n    height: auto !important;\n}\n\n.has-tim .col-md-12.for-box.ful-cob-sec {\n    margin-bottom: 30px;\n}\n\n.new-h .ful-cob-sec h4 {\n    font-family: \"Open Sans\", sans-serif;\n}\n\n.new-h .ful-cob-sec h4 span {\n    display: block;\n    margin-bottom: 12px;\n    opacity: 0.6;\n}\n\n.new-h .ful-cob-sec h4 {\n    opacity: 1;\n}\n.sec.celife-code h2 span {\n    font-size: 14px;\n    line-height: 18px;\n    position: relative;\n    top: -7px;\n    left: 20px;\n    opacity: 0.6;\n}\n\n.bel-asign-team {\n    display: flex;\n}\n\n.bel-asign-team p {\n    margin-right: 20px;\n}\n.sec.celife-code p {\n    font-size: 18px;\n    line-height: 30px;\n    opacity: 0.6;\n}\n.che-ans a {\n    background: #28a830;\n    color: #fff;\n    display: inline-block;\n    padding: 15px 30px;\n    border-radius: 5px;\n    margin-top: 40px;\n}\n\n.che-ans .tik-bell {\n    margin-bottom: 20px;\n}\n.sch-list + .sch-list {\n    margin-top: 30px;\n}\n.gra-1 {\n    background: rgb(252, 57, 95);\n    background: linear-gradient(\n        90deg,\n        rgba(252, 57, 95, 1) 0%,\n        rgba(50, 157, 204, 1) 100%\n    );\n}\n.gra-2 {\n    background: rgb(177, 101, 176);\n    background: linear-gradient(\n        90deg,\n        rgba(177, 101, 176, 1) 0%,\n        rgba(86, 201, 228, 1) 100%\n    );\n}\n.gra-3 {\n    background: rgb(242, 124, 133);\n    background: linear-gradient(\n        90deg,\n        rgba(242, 124, 133, 1) 0%,\n        rgba(224, 164, 255, 1) 100%\n    );\n}\n.gra-4 {\n    background: rgb(21, 158, 142);\n    background: linear-gradient(\n        90deg,\n        rgba(21, 158, 142, 1) 0%,\n        rgba(56, 236, 127, 1) 100%\n    );\n}\n.sch-list h3 {\n    color: #fff;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.sch-list h3 span {\n    font-size: 14px;\n    font-weight: 400;\n    font-family: \"Open Sans\", sans-serif;\n    /*margin-right: 40px;*/\n    /*padding-left: 40px;*/\n    text-align: right;\n}\n\n.sch-list2 {\n    padding: 30px;\n    border-radius: 20px;\n}\n.ad-songinner {\n    background: #0e0e0e;\n    padding: 30px;\n    border-radius: 20px;\n    display: flex;\n}\n\n.song-img {\n    margin-right: 20px;\n}\n\n.son-con h3 {\n    color: #fff;\n    font-size: 16px;\n    opacity: 0.6;\n    font-family: \"Open Sans\", sans-serif;\n}\n.son-con h3 + h3 {\n    margin-top: 20px;\n}\n\n.son-con h2 {\n    color: #fff;\n    font-size: 34px;\n    margin-bottom: 20px;\n}\n.ad-song-btn a {\n    color: #000;\n    background: #fff;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 65px;\n    border-radius: 12px;\n    font-size: 22px;\n    font-weight: 700;\n    text-decoration: none;\n}\n.extrabtn .ad-song-btn {\n    display: flex;\n    align-items: center;\n    margin-top: 30px;\n}\n\n.extrabtn .ad-song-btn a {\n    width: 280px;\n}\n.extrabtn .ad-song-btn a + a {\n    margin-left: 15px;\n}\n.popup-btn-submit button {\n    background: #3478ff;\n    color: #fff;\n    display: block;\n    padding: 18px 40px;\n    border-radius: 5px;\n    outline: none;\n}\n.cht-box-inner .gra-box {\n    height: 220px;\n    border-radius: 8px 8px 0 0;\n}\n.cht-box-inner .peo-con {\n    padding: 15px;\n}\n\n.cht-box-inner .peo-con h3 {\n    color: #fff;\n}\n.cht-box-inner .tag-name {\n    position: relative;\n    top: 10px;\n    left: 10px;\n    border-radius: 15px !important;\n}\n.check-half input[type=\"checkbox\"] {\n    width: 15px;\n    margin-right: 8px;\n    position: relative;\n    top: 1px;\n}\n.gra-box.team-img-box {\n    height: auto;\n}\n.team-box-main .cht-box-inner {\n    border-radius: 12px;\n    position: relative;\n    overflow: hidden;\n}\n.team-box-main .cht-box-inner .peo-con {\n    font-family: \"Open Sans\", sans-serif;\n    position: absolute;\n    bottom: 0;\n    background: rgb(24 25 26 / 90%);\n    width: 100%;\n    text-align: left;\n    justify-content: flex-start;\n}\n.team-box-main .cht-box-inner .peo-con h3 {\n    font-size: 22px;\n    line-height: 28px;\n}\n.team-bar-inner {\n    background: #18191a;\n    padding: 25px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-radius: 7px;\n}\n\n.team-bar-inner h3 {\n    margin: 0;\n    color: #fff;\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 28px;\n    line-height: 38px;\n}\n.team-bar + .team-bar {\n    margin-top: 15px;\n}\n.popup-form .popup-content {\n    margin-top: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.add-person h4 {\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 18px;\n    color: #fff;\n    margin: 0;\n    margin-left: 15px;\n}\n.field-has.fullwidth .add-person {\n    margin-top: 30px;\n}\n.add-person {\n    display: flex;\n    align-items: center;\n}\nul.list-per {\n    padding: 0;\n    margin: 0;\n}\n\nul.list-per img {\n    max-width: 50px !important;\n    margin-right: 12px;\n}\n\nul.list-per li {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    font-family: \"Open Sans\", sans-serif;\n}\n\nul.list-per {\n    display: flex;\n}\n\nul.list-per li + li {\n    margin-left: 20px;\n}\n.main-song-box {\n    background: #0e0e0e;\n    padding: 20px;\n    border-radius: 20px;\n}\n\n.main-song.box-inner {\n    display: flex;\n    align-items: flex-start;\n}\n\n.song-content h3 {\n    color: #fff;\n}\n\n.song-content h4 {\n    color: #fff;\n    opacity: 0.6;\n}\n\n.date-son p {\n    font-size: 14px;\n    opacity: 0.4;\n    margin-left: 10px;\n    margin-top: 20px;\n}\n.titbar.search-field h2 {\n    font-family: \"Open Sans\", sans-serif !important;\n    font-weight: 500;\n}\n\n.song-title {\n    margin-top: 40px;\n}\n.ver-inner {\n    background: #0e0e0e;\n    border-radius: 10px;\n    padding: 20px;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n\n.ver-inner h4 {\n    color: #fff;\n    font-size: 20px;\n    line-height: 30px;\n    margin: 0 0 15px;\n}\n\n.ver-inner ul li {\n    color: #fff;\n    font-size: 14px;\n}\n\n.ver-inner ul {\n    margin: 10px 0 0;\n    padding: 0;\n    list-style: none;\n}\n\n.ver-inner ul li + li {\n    margin-top: 12px;\n}\n.radio-left.ver-inner {\n    background: transparent;\n    padding: 0;\n}\n\n.radio-left.ver-inner ul {\n    display: flex;\n    align-items: center;\n}\n\n.radio-left.ver-inner ul li + li {\n    margin: 0 0 0 30px;\n}\n\n.radio-left.ver-inner ul li span {\n    min-width: 60px;\n}\n.ver-inner ul li span {\n    opacity: 0.5;\n    min-width: 70px;\n    display: inline-block;\n}\n.radio-version-inner {\n    background: #171717;\n    padding: 20px;\n    border-radius: 20px;\n    margin-top: 20px;\n}\n\n.radio-version-inner .song-title {\n    margin: 0px;\n}\n.ver-de h3 {\n    color: #fff;\n    font-family: \"Open Sans\", sans-serif !important;\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 28px;\n    margin: 0 0 12px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.col-md-3.seq-left a {\n    background: #3478ff;\n    color: #fff;\n    display: table;\n    padding: 12px 12px;\n    border-radius: 5px;\n    margin-top: 30px;\n    margin: 30px auto 0;\n}\n.ver-de .row {\n    display: flex;\n    align-items: stretch;\n    justify-content: flex-start;\n}\n.ver-de .row {\n    display: flex;\n    align-items: stretch;\n    justify-content: flex-start;\n}\n\n.seq-left-inner {\n    height: 100%;\n    background: #0e0e0e;\n    border-radius: 15px;\n    padding: 20px;\n}\n.ver-de .row {\n    display: flex;\n    align-items: stretch;\n    justify-content: flex-start;\n}\n\n.seq-left-inner {\n    height: 100%;\n    background: #0e0e0e;\n    border-radius: 15px;\n    padding: 20px;\n}\n\n.int-box {\n    background: #0e0e0e;\n    border-radius: 15px;\n    padding: 20px;\n    height: 100%;\n    min-height: 210px;\n}\n\n.int-box ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.int-box ul li {\n    font-size: 12px;\n    font-family: \"Open Sans\", sans-serif !important;\n    color: #fff;\n    opacity: 0.5;\n}\n.seq-right .col-md-4 {\n    margin-bottom: 30px;\n}\n.int-box ul li + li {\n    margin-top: 12px;\n}\n.seq-left-inner ul {\n    margin: 20px 0 0;\n    padding: 0;\n    list-style: none;\n}\n\n.seq-left-inner ul li {\n    color: #fff;\n    font-size: 16px;\n    font-family: \"Open Sans\", sans-serif !important;\n    line-height: 24px;\n}\n.titleaboutLInk a {\n    color: #fff;\n}\n.seq-left-inner ul li + li {\n    margin-top: 12px;\n}\n.ver-de h3 i.fa {\n    opacity: 0.5;\n}\n.seq-main {\n    background: rgb(255 255 255 / 5%);\n    border-radius: 15px;\n    min-height: 450px;\n    padding: 20px;\n    position: relative;\n}\n.newpromainwrap {\n    /* padding-bottom: 60px; */\n}\n.seq-main ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n}\n\n.seq-main ul li {\n    color: #fff;\n    background: transparent;\n    width: auto;\n    display: flex;\n}\n.seq-main ul li span {\n    background: #3478ff;\n    padding: 8px;\n    font-size: 13px;\n    border-radius: 4px;\n}\n.seq-right .seq-main ul li span {\n    background: #fff;\n    color: #000;\n}\n\n.seq-main ul li + li {\n    margin-top: 10px;\n}\n.ad-label {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: absolute;\n    width: 100%;\n    left: 0;\n    bottom: 0;\n    background: rgb(20 21 21 / 32%);\n    padding: 10px 18px;\n    border-radius: 0 0 15px 15px;\n}\n.ad-label input {\n    outline: none;\n    border: none;\n}\n.ad-label button {\n    background: transparent;\n    border: none;\n}\n\n.ad-label button i.fa {\n    color: #3478ff;\n    font-size: 24px;\n}\n.song-list-table {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n}\n\n.song-list-table th,\n.song-list-table td {\n    border: none !important;\n    color: #fff;\n    font-size: 13px;\n    font-weight: 400;\n}\n\n.song-list-table thead {\n    background: rgb(255 255 255 / 9%);\n    border-radius: 5px !important;\n    overflow: hidden;\n    margin-bottom: 10px !important;\n}\n\n.song-list-table th {\n    opacity: 0.5;\n    font-size: 13px;\n    font-weight: 400;\n}\n\n.song-list-table tbody tr {\n    background: #18191a !important;\n}\n\n.song-list-table tbody {\n}\n.song-list-table tbody tr td {\n    padding: 15px 0.75rem;\n    border-top: 10px solid #080808 !important;\n    border-bottom: 10px solid #080808 !important;\n}\n.song-list-table tbody tr td a {\n    color: #fff;\n}\n.exp-box {\n    background: #18191a;\n    width: 48%;\n    padding: 4%;\n    border-radius: 12px;\n}\n\n.sch-list {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.exp-box h3 {\n    margin: 0;\n    text-align: center;\n}\n\n.exp-box.active {\n    background: #fff;\n}\n\n.exp-box.active h3 {\n    color: #18191a;\n}\n.get-box {\n    background: #3478ff;\n    color: #fff;\n    border-radius: 5px;\n    padding: 12px;\n    width: 49%;\n}\n\n.get-box h4 {\n    margin: 0;\n    text-align: center;\n    font-size: 20px;\n    font-family: \"Open Sans\", sans-serif;\n    line-height: 28px;\n}\n\n.get-list {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 30px;\n}\n.sch-main-box {\n    font-family: \"Open Sans\", sans-serif;\n    margin-top: 30px;\n}\n\n.col-sch-title {\n    background: rgb(255 255 255 / 80%);\n    padding: 12px 0px;\n    text-align: center;\n    border-radius: 10px;\n}\n\n.sch-col {\n    width: 160px;\n    height: auto;\n}\n\n.col-sch-title h4 {\n    line-height: 24px;\n    font-size: 16px;\n    text-transform: uppercase;\n    font-weight: 700;\n    padding: 0 10px;\n}\n\n.col-sch-title h5 {\n    font-size: 14px;\n    text-transform: uppercase;\n    font-weight: 600;\n    margin: 0;\n}\nul.dec-sch {\n    padding: 0;\n    margin: 0;\n    background: #18191a;\n    list-style: none;\n    border-radius: 10px;\n    margin-top: 15px;\n    overflow: hidden;\n}\n\nli.titlesch {\n    text-align: center;\n    color: rgb(255 255 255 / 60%);\n    font-size: 12px;\n    background: #131414;\n    justify-content: center;\n}\n\nul.dec-sch li {\n    padding: 13px 10px;\n    color: #fff;\n    opacity: 0.8;\n    font-size: 12px;\n    line-height: 19px;\n    display: flex;\n    align-items: flex-start;\n}\n\nul.dec-sch li span {\n    font-weight: 700;\n    opacity: 0.2;\n    margin-right: 7px;\n    min-width: 36px;\n    display: inline-block;\n}\n\ninput[type=\"radio\"] {\n}\n\n.radio-btn input[type=\"radio\"] {\n    background: #fff;\n    width: 12px;\n    height: 12px;\n    padding: 0;\n    margin: 0;\n    -webkit-appearance: radio;\n}\n\n.radio-btn i {\n    font-size: 10px;\n    line-height: 12px;\n    font-style: normal;\n    text-align: center;\n    margin-top: 10px;\n}\n\n.radio-btn {\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n.sch-col + .sch-col {\n    margin-left: 15px;\n}\n\n.sch-main-box {\n    display: flex;\n    align-items: flex-start;\n}\n.send-sch-title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 12px;\n}\nli.titlesch.Deptitle {\n    background: #0e0e0f;\n}\n.sch-main-box.center-li {\n}\n\n.sch-main-box.center-li ul.dec-sch li {\n    justify-content: center;\n}\nli.circle {\n    position: relative;\n}\n\nli.circle:before {\n    content: \"\";\n    width: 12px;\n    height: 12px;\n    background: red;\n    border-radius: 100%;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 15px;\n}\nli.green.circle:before {\n    background: #00ff30;\n}\nli.orange.circle:before {\n    background: #ff7a00;\n}\nli.red.circle:before {\n    background: #ff0000;\n}\n.radio-btn input[type=\"radio\"]:checked::before {\n    display: none;\n}\n.error {\n    color: red;\n    font-size: 15px;\n}\n.select2-container--default.select2-container--open {\n    width: 100% !important;\n    z-index: 9999999;\n}\nspan.select2.select2-container {\n    width: 100% !important;\n}\n.ui-timepicker-container {\n    z-index: 99999 !important;\n}\n.timer {\n    display: none;\n}\n.active {\n    display: block;\n}\n.add-more-time {\n    height: 20px;\n    width: 20px;\n    position: absolute;\n    display: inherit;\n}\n\n.menu_icon {\n    display: none;\n}\n/*peoplenew page style */\n.row.hasnewpeoplesearch input,\n.row.hasnewpeoplesearch select {\n    background: transparent;\n    border: 1px solid #3b3939;\n    width: 100%;\n    height: 60px !important;\n    border-radius: 7px;\n    color: #fff;\n    display: block;\n    box-shadow: none;\n    --ck-color-input-background: none;\n}\n\n.hasnewpeoplesearch .titbar.search-field a.btn-blue {\n    padding: 18px 20px !important;\n    border-radius: 8px !important;\n    width: 100%;\n    position: relative;\n    top: 2px;\n    text-align: center;\n    font-family: \"Open Sans\", sans-serif;\n}\n.row.hasnewpeoplesearch select option {\n    color: #000;\n}\n.card-headerhas {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n    font-size: 32px;\n    line-height: 40px;\n    font-weight: 500;\n    margin: 0 0 20px;\n}\n.titbar.search-field {\n}\n.cht-box-inner-has-new img {\n    width: 100%;\n    height: 260px;\n    object-fit: cover;\n    object-position: center;\n}\n\n.hasnewpeoplewrap {\n    border-radius: 12px;\n    overflow: hidden;\n    position: relative !important;\n    font-family: \"Open Sans\", sans-serif;\n}\n.haseopledeelteBtn {\n    position: absolute;\n    right: 30px;\n    top: 10px;\n    margin: 0 !important;\n    background: #fff;\n    width: 30px;\n    height: 30px;\n    border-radius: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n}\n\n.peo-con-has {\n    background: #171717;\n    padding: 15px;\n}\n\n.peopplename {\n    color: #fff;\n    font-size: 18px;\n    line-height: 34px;\n}\n\n.cht-box-inner-has-new {\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n.actionpeoplebtns a {\n    color: #fff;\n    opacity: 0.7;\n    width: 25%;\n    text-align: center;\n    text-decoration: underline !important;\n    text-underline-position: under !important;\n}\n.actionpeoplebtns a.sendmes {\n    width: 50%;\n    text-align: left;\n}\n\n.actionpeoplebtns {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 5px;\n}\n\n/*peoplenew page style end*/\n\n.actionpeoplebtns a + a {\n    border-left: 1px solid #343434;\n}\n\n.admin-dashboard-right {\n    width: calc(100% - 280px);\n    padding: 0px 40px 90px;\n    margin-top: 0;\n}\n/* .admin-dashboard-left {\n    margin-left: 0px;\n    border-radius: 0;\n} */\n.dashbaoad-main {\n    margin-top: 0;\n}\n.admin-dashboard-right {\n}\n\n.top-menu {\n    width: calc(100% + 80px);\n    margin-left: -40px;\n    margin-bottom: 50px;\n}\n\n.top-menu-inner ul {\n    border-radius: 0 !important;\n}\n.admin-main-dashboard.redefine-crm {\n    padding-top: 0px;\n}\n.admin-main-dashboard.redefine-crm .container.mb-3 {\n    width: 100%;\n    margin: 0 !important;\n    padding: 0;\n    background: #18191a !important;\n}\n.detpinnercol > ul > li {\n    padding: 12px 30px !important;\n}\n.detpinnercol > ul {\n    padding: 0 15px !important;\n}\n/* .header-menu.newmenuDesign {\n    padding-top: 44px;\n} */\n.hasscheduleNewDesign .detpinnercol > ul {\n    padding: 0 !important;\n}\n.kidboxinner {\n    background: #121212;\n    padding: 30px 30px;\n    border-radius: 20px;\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n    text-align: center;\n    position: relative;\n    margin-top: 30px;\n}\n\n.kidsbtnAction ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n}\n\n.kidsbtnAction ul li {\n    width: 20%;\n}\n\n.kidsbtnAction ul li img,\n.kidsbtnAction ul li a {\n    width: 100%;\n    height: auto;\n    display: inline-block;\n}\n\n.kidsbtnAction {\n    margin-top: 20px;\n}\n\n.col-md-3.mainkidsbox {\n    position: a;\n}\n\n.deleeIConkids {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    cursor: pointer;\n}\n\n.kidsContent h3 {\n    font-size: 26px;\n    line-height: 34px;\n    margin-bottom: 8px;\n}\n\n.kidsContent h5 {\n    color: #fff;\n    opacity: 0.5;\n    font-size: 18px;\n    line-height: 24px;\n}\n\n.checkedWrap h4 {\n    font-size: 18px;\n    line-height: 24px;\n    font-weight: 600;\n    position: relative;\n    display: inline-block;\n    padding-left: 14px;\n}\n\n.checkedWrap.in h4 {\n    color: #28a830;\n}\n.checkedWrap.out h4 {\n    color: #ff3434;\n}\n.checkedWrap {\n    position: relative;\n    margin-bottom: 8px;\n}\n\n.checkedWrap.in h4:before {\n    content: \"\";\n    background: #28a830;\n    width: 8px;\n    height: 8px;\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    border-radius: 100%;\n}\n.mainDetailsInnerpage {\n    margin-top: 30px;\n}\n.checkedWrap.out h4:before {\n    content: \"\";\n    background: #ff3434;\n    width: 8px;\n    height: 8px;\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    border-radius: 100%;\n}\n\n.locationKid span {\n    background: #414141;\n    padding: 10px 15px;\n    display: inline-block;\n    font-size: 14px;\n}\n\n.kidsImage img {\n    border-radius: 100%;\n    width: 100px;\n    height: 100px;\n    object-fit: cover;\n    object-position: top;\n}\n\n.kidsImage {\n    margin-bottom: 18px;\n}\n\n.locationKid {\n    margin-bottom: 25px;\n}\n.kidsNameCheck .checkedWrap h4 {\n    color: #28a830;\n    margin: 0 !important;\n}\n.kidsNameCheck .checkedWrap {\n    margin-left: 70px;\n}\n.kidsNameCheck h3 {\n    display: flex;\n    contain: content;\n    justify-content: flex-start;\n}\n.kidsDaata ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.kidsDaata ul li {\n    color: #fff;\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 22px;\n    line-height: 34px;\n    font-weight: 600;\n}\n\n.kidsDaata ul li span {\n    opacity: 0.8;\n}\n.familyDaata ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: start;\n}\n\n.familyDaata ul li img {\n    width: 35px;\n    height: 35px;\n    object-fit: cover;\n    object-position: top;\n    border-radius: 100%;\n}\n\n.familyDaata ul li + li {\n    margin-left: 10px;\n}\n\n.familyDaata {\n    margin-top: 30px;\n}\n.yellowbarInner {\n    background: #c49c2c;\n    padding: 30px;\n    border-radius: 20px;\n    margin: 30px 0 0;\n}\n\n.yellotitleedit {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.editbtn {\n    font-size: 26px;\n}\n.tagllgmain {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n    display: flex;\n    align-items: start;\n}\n\n.allegmainleft {\n    margin-right: 100px;\n}\n\n.allegmainleft ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: start;\n}\n\n.allegmainleft ul li + li {\n    margin-left: 15px;\n}\n\n.allegmainleft ul li {\n    padding: 8px 12px;\n    background: #fff;\n    color: #c49c2c;\n    font-weight: 600;\n    border-radius: 4px;\n}\n\n.allegmainleft h3 {\n    font-size: 21px;\n    margin: 0 0 11px;\n}\n\n.allegmainleft.redTags ul li {\n    background: #ff3434;\n    color: #fff;\n}\n.profilekidsboxes .sec.celife-code {\n    margin-top: 30px;\n}\n.familydetkids {\n    width: 60%;\n    display: flex;\n    align-items: center;\n}\n\n.kidsFamilyList .kidsbtnAction {\n    width: 40%;\n}\n\n.kidsFamilyList {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.kidsFamilyList .kidsbtnAction li img {\n    max-width: 50px;\n    height: auto;\n}\n\n.kidsFamilyList .kidsbtnAction ul {\n    justify-content: flex-end;\n}\n\n.kidsFamilyList .kidsbtnAction ul li + li {\n    margin-left: 8px !important;\n    margin-top: 0 !important;\n}\n\n.familydetkids h3 {\n    margin: 0;\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    width: 100%;\n    margin-left: 20px;\n}\n\n.familydetkids h3 span {\n    opacity: 0.4;\n    font-size: 16px;\n    margin-left: 12px;\n}\n\n.familydetkids img {\n    width: 60px !important;\n    height: 60px !important;\n}\n.haskidsbox {\n    margin-bottom: 30px;\n}\n\n.haskidsbox .for-box-innner {\n    height: 100% !important;\n}\n.kidsFamilyList .kidsbtnAction ul li {\n    line-height: 16px;\n}\n.imageeader img {\n    width: 100%;\n    height: auto;\n    border-radius: 15px;\n}\n\n.imageleaderText {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    background: rgb(0 0 0 / 68%);\n    width: 100%;\n    border-radius: 0 0 15px 15px;\n}\n\n.leaderimagebox {\n    border-radius: 15px;\n    overflow: hidden;\n}\n\n.leaderimagebox a {\n    position: relative;\n    border-radius: 15px;\n    overflow: hidden;\n}\n\n.imageleaderText h2 {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n    font-size: 24px;\n    font-weight: 500;\n    padding: 20px;\n    line-height: 24px;\n}\n.addleaderpop.active,\n.addcirculam.active {\n    display: flex;\n}\n.mainPopuphsaNew {\n    left: 0;\n}\n.leaderimagebox.leaderdetailBnnaer img {\n    width: 100%;\n    height: 350px;\n    object-fit: cover;\n    object-position: center;\n}\n.mainTitle h3 {\n    color: #fff;\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 34px;\n    line-height: 44px;\n    margin-bottom: 0;\n    margin-top: 20px;\n}\n.leaderimagebox.leaderdetailBnnaer {\n    margin-bottom: 30px;\n}\n.leaderDetailamin .kidsbtnAction ul {\n    justify-content: center;\n}\n\n.leaderDetailamin .kidsbtnAction ul li + li {\n    margin-left: 15px;\n}\n.editRoombtn a {\n    padding: 12px 20px !important;\n    border-radius: 5px !important;\n    width: 150px;\n    position: relative;\n    top: 2px;\n    text-align: center;\n    font-family: \"Open Sans\", sans-serif;\n    background: #fff;\n    color: #000;\n    font-weight: 600;\n    display: inline-block;\n    position: absolute;\n    right: 30px;\n    top: 30px;\n}\n.leaderimagebox {\n    margin-bottom: 30px;\n}\n.leaderdetailBnnaer {\n    position: relative;\n}\n.checkindetailsmainInner {\n    background: #121212;\n    padding: 30px 30px;\n    border-radius: 15px;\n}\n.contentDetiails p {\n    margin: 0;\n    font-size: 18px;\n    line-height: 30px;\n}\n.editbtn i.fa.fa-plus {\n    -webkit-text-stroke: 3px #121212;\n    font-size: 30px;\n    position: relative;\n    top: 3px;\n    margin-left: 12px;\n}\n.checkindetailsmainInner.TeamDetailsInner {\n    display: block;\n}\n.checkindetailsmain {\n    margin-bottom: 30px;\n}\n.checkindetailsmainInner .kidboxinner {\n    background: #1e1e1e;\n}\n.yellotitleedit.kidsTitleDetails {\n    margin: 0;\n}\n.kidboxinner.psdMainbox {\n    margin: 0;\n    text-align: left;\n}\n\n.mainkidsbox.psdMainboxwrap:nth-child(n + 5) {\n    margin-top: 30px;\n}\n\n.kidboxinner.psdMainbox h3 {\n    font-size: 24px;\n    margin-bottom: 12px;\n}\n\n.kidboxinner.psdMainbox h4 {\n    font-size: 22px;\n}\n\n.kidboxinner.psdMainbox ul {\n    list-style: none;\n    padding: 0;\n    margin: 25px 0 0;\n}\n\n.kidboxinner.psdMainbox ul li {\n    margin-top: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: start;\n}\n.formFiled textarea {\n    height: 90px;\n}\n.opencirrForm {\n    cursor: pointer;\n}\n.kidboxinner.psdMainbox ul li span {\n    margin-left: 11px;\n}\n@media (max-width: 850px) {\n    .dashbaoad-main {\n        flex-direction: column;\n    }\n\n    .admin-dashboard-right {\n        width: 100% !important;\n        padding: 0 15px !important;\n    }\n\n    .titbar.search-field input {\n        width: 66% !important;\n    }\n\n    .titbar a {\n        width: 32%;\n    }\n\n    .eventBoxmain .has-box-inner img {\n        height: 200px !important;\n    }\n\n    .hasnewBoxDetails h3 {\n        font-size: 18px;\n        line-height: 24px;\n    }\n\n    .hasnewBoxDetails {\n        padding: 12px 15px;\n    }\n\n    .cht-box-inner img {\n        height: 200px;\n        object-fit: cover;\n        object-position: center;\n        border-radius: 12px;\n    }\n    .eventInnerbarImage .has-box-inner img {\n        height: 200px !important;\n    }\n\n    .sec.celife-code {\n        margin: 0 0 30px !important;\n    }\n\n    .for-box-innner {\n        padding: 20px 20px !important;\n    }\n\n    .newtitleHas {\n        font-size: 24px;\n        line-height: 30px;\n    }\n\n    .sch-list.sch-listMain h3 {\n        font-size: 18px;\n        flex-direction: column;\n        align-items: start;\n        line-height: 28px;\n    }\n\n    .sch-list.sch-listMain p {\n        margin: 0;\n    }\n\n    .rightnewtimes ul li {\n        width: calc(100% + 40px);\n        margin-left: -20px;\n    }\n    .hasboxinnerlist.gra-1 {\n        flex-direction: column;\n        align-items: flex-start;\n        padding: 20px;\n    }\n\n    .listhasleft {\n        margin-bottom: 12px;\n    }\n\n    .detail-people {\n        padding: 20px;\n        margin-top: 12px;\n        height: auto !important;\n    }\n\n    .for-box-innner.ttol.Song .quote-main-right {\n        padding: 0 20px;\n    }\n\n    .header-main .header-menu ul {\n        display: flex;\n        flex-direction: column;\n        align-items: self-start;\n        padding: 21px 0px;\n        width: calc(100% + 30px);\n        position: absolute;\n        left: -30px;\n        background: #18191a;\n        top: 45px;\n        padding: 22px 10px;\n        display: none;\n    }\n\n    .header-main .header-menu ul li {\n        margin: 0;\n    }\n\n    .header-main .header-menu ul li + li {\n        margin-top: 12px;\n    }\n    .menu_icon {\n        display: block;\n        position: absolute;\n        right: 20px;\n        font-size: 24px;\n        top: -16px;\n        color: #fff;\n    }\n    ul.headerMenuhas.showMenu {\n        display: block !important;\n    }\n    .top-menu-inner ul li + li {\n        padding-left: 40px !important;\n    }\n    .fam-left {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .detail-people {\n        flex-direction: column;\n        align-items: center;\n        border-radius: 12px;\n        margin-bottom: 25px;\n    }\n\n    .phot-btn {\n        margin-bottom: 20px;\n    }\n\n    .det0pro {\n        margin: 0;\n        text-align: center;\n        margin-bottom: 30px;\n    }\n\n    .det0pro h3 {\n        font-size: 22px;\n        margin-top: 20px;\n    }\n\n    .fam-right {\n        width: 100%;\n    }\n\n    .fam-right ul li p {\n        margin: 0;\n    }\n\n    .fam-left a.btn.btn-sm.btn-primary {\n        padding: 15px;\n        background: #18191a;\n        border: 1px solid #18191a;\n    }\n\n    .sec.celife-code h2 {\n        font-size: 24px;\n        line-height: 30px;\n    }\n\n    .notify-icon-btn {\n        margin-right: 20px;\n    }\n\n    .for-box-innner ul li img.add-people-img {\n        max-width: 150px;\n        height: auto;\n        margin-top: 10px;\n    }\n\n    .col2-info-fam .ful-cob-sec .for-box-innner ul li span {\n        width: 40%;\n    }\n\n    .ful-cob-sec .for-box-innner ul li + li {\n        margin-top: 12px;\n    }\n\n    .ful-cob-sec .for-box-innner ul li {\n        font-size: 14px !important;\n    }\n    .admin-dashboard-right {\n        width: 100% !important;\n        padding: 0 15px !important;\n    }\n    .admin-dashboard-right .top-menu {\n        display: none;\n    }\n    .header-Icon {\n        max-width: 100% !important;\n    }\n}\n\n/* font-family: 'Open Sans', sans-serif; */\n@media (min-width: 767px) {\n    .padding-full {\n        padding-right: 15px;\n        padding-left: 15px;\n    }\n    .no-padding {\n        padding-left: 0;\n        padding-right: 0;\n    }\n    .no-padding-left {\n        padding-left: 0;\n    }\n    .no-padding-right {\n        padding-right: 0;\n    }\n}\n@font-face {\n    font-family: frontagebold;\n    src: url(assets/fonts/frontage-bold-webfont.eot);\n    src: url(assets/fonts/frontage-bold-webfont.eot?#iefix)\n            format(\"embedded-opentype\"),\n        url(assets/fonts/frontage-bold-webfont.woff2) format(\"woff2\"),\n        url(assets/fonts/frontage-bold-webfont.woff) format(\"woff\"),\n        url(assets/fonts/frontage-bold-webfont.svg#frontagebold) format(\"svg\");\n    font-weight: 400;\n    font-style: normal;\n}\n@font-face {\n    font-family: \"Open Sans\", sans-serif;\n    src: url(assets/fonts/frontage-regular-webfont.eot);\n    src: url(assets/fonts/frontage-regular-webfont.eot?#iefix)\n            format(\"embedded-opentype\"),\n        url(assets/fonts/frontage-regular-webfont.woff2) format(\"woff2\"),\n        url(assets/fonts/frontage-regular-webfont.woff) format(\"woff\"),\n        url(assets/fonts/frontage-regular-webfont.svg#\"Open Sans\", sans-serif)\n            format(\"svg\");\n    font-weight: 400;\n    font-style: normal;\n}\np + p {\n    margin-top: 15px;\n}\n.header-menu ul li + li {\n    margin-left: 50px;\n}\n\n/*landing page*/\n.slider-banner-content h1 {\n    color: #fff;\n    font-size: 70px;\n    line-height: initial;\n    text-transform: capitalize;\n}\n.slider-banner-content h1 span {\n    font-size: 45px;\n    display: block;\n}\nheader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 999;\n    padding: 5px 0;\n}\n.fp-section {\n    height: 100vh;\n}\n.has-title h2 {\n    color: #fff;\n    font-size: 56px;\n    line-height: 74px;\n    text-align: center;\n}\n.has-btn-main a {\n    border: 2px solid #fff;\n    border-radius: 5px;\n    color: #fa7373;\n    font-size: 30px;\n    line-height: 3;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n    margin: 0 40px;\n    transition: 0.3s;\n    padding: 0 50px;\n}\n.has-btn-main {\n    display: flex;\n    align-items: center;\n    margin-top: 220px;\n    justify-content: center;\n}\n.has-btn-main a:hover,\n.submit-btn input:hover {\n    border: 2px solid #fa7373;\n    color: #fff;\n    background: #fa7373;\n}\n.fomr-login-has {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    margin-top: 100px;\n}\n.has-field input {\n    background: 0 0;\n    border: none !important;\n    border-bottom: 1px solid rgb(112 112 112 / 22%) !important;\n    width: 710px;\n    padding: 12px 0;\n    margin-bottom: 12px;\n    font-family: \"Open Sans\", sans-serif;\n    color: #fa7373;\n    outline: 0;\n}\n.submit-btn input {\n    border: 2px solid #fff;\n    border-radius: 5px;\n    color: #fa7373;\n    font-size: 18px;\n    line-height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: auto;\n    text-decoration: none;\n    margin: 0 40px;\n    transition: 0.3s;\n    background: 0 0;\n    width: auto;\n    padding: 5px 20px;\n    margin: 0;\n    transition: 0.3s;\n}\n.has-field input::-webkit-input-placeholder {\n    color: #fa7373;\n}\n.has-field input:-ms-input-placeholder {\n    color: #fa7373;\n}\n.has-field input::placeholder {\n    color: #fa7373;\n}\n.submit-btn {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-top: 12px;\n}\n.continue-as-guest a {\n    color: #fff;\n    text-decoration: underline;\n    text-underline-position: under;\n    font-size: 36px;\n    line-height: 48px;\n}\n.continue-as-guest {\n    margin-top: 70px;\n}\n/*menu*/\n.header-menu ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.header-menu ul li {\n    margin: 0 0;\n}\nheader.no-landing {\n    background: #171717;\n    padding: 15px 0;\n}\nheader.no-landing .row {\n    display: flex;\n    align-items: center;\n}\n.inner-sec-has1 h1 {\n    font-size: 60px !important;\n    text-align: center;\n    margin: 0 0 30px;\n}\n.slider-banner-content {\n    width: 100%;\n}\n.has-sec-1-group .fp-tableCell {\n    vertical-align: bottom;\n}\n.group-content1-inner {\n    background: #b694e0;\n    background: linear-gradient(167deg, #b694e0 0, #8e53df 100%);\n    padding: 50px;\n    border-radius: 15px;\n}\n.group-content h3 {\n    font-size: 60px;\n    line-height: 80px;\n    margin: 0 0 5px;\n    color: #fff;\n}\n.group-content p {\n    padding-left: 12px;\n}\n.ptop .fp-tableCell {\n    padding-top: 85px !important;\n}\n\n/*footer*/\ndiv#footer-sec {\n    background: #171717;\n}\n.footer-col {\n    width: 20%;\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%;\n}\n.footer-col h4 {\n    font-size: 24px;\n    color: #fff;\n    font-family: \"Open Sans\", sans-serif;\n    line-height: 52px;\n}\n.footer-col ul li a {\n    color: #fff;\n    opacity: 0.4;\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 20px;\n    font-weight: 400;\n    transition: 0.3s;\n    text-decoration: none;\n}\n.footer-col ul li a:hover {\n    color: #3478ff;\n    opacity: 1;\n}\n.footer-col ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.footer-col ul li + li {\n    margin-top: 12px;\n}\n.has-footer-bottom {\n    border-top: 1px solid rgb(255 255 255 / 5%);\n}\n.footer-b-right ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n.footer-b-right ul li a i {\n    color: #fff;\n    font-size: 24px;\n    opacity: 0.4;\n}\n.footer-b-right ul li + li {\n    margin-left: 10px;\n}\n.footer-b-left p {\n    color: #fff;\n    opacity: 0.4;\n    font-size: 18px;\n    line-height: 26px;\n}\n.footer-bottom .row {\n    display: flex;\n    align-items: center;\n}\n.footer-bottom {\n    padding: 25px 0;\n}\n.has-footer-top {\n    padding: 70px 0;\n}\n\n/*home*/\n.video-banner-bg {\n    /* height: 450px; */\n    border-radius: 20px;\n}\n.banner-title h2 {\n    color: #fff;\n    font-size: 52px;\n    line-height: 70px;\n}\n.video-banner-bg {\n    display: flex;\n    align-items: flex-end;\n    padding: 0;\n    overflow: hidden;\n    height: 606px;\n}\n.tag-name {\n    display: table;\n    position: relative;\n}\n.tag-name h4 {\n    margin: 0;\n    color: #fff;\n    font-family: \"Open Sans\", sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    padding: 8px 16px;\n    position: relative;\n    z-index: 10;\n}\n.blur-bg {\n    background: rgb(150 150 150 / 40%);\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 9;\n    filter: blur(0.8px);\n    border-radius: 3px;\n}\n.banner-title {\n    margin-top: 10px;\n}\n.play-btn {\n    position: absolute;\n    z-index: 12;\n    top: 46%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n.msg-inner-box {\n    background: #171717;\n    height: 100%;\n    border-radius: 20px;\n}\n.play-btn i {\n    color: #fff;\n    font-size: 100px;\n}\n.messages-list {\n    height: 88%;\n    overflow: hidden;\n}\n.messages-list {\n    height: 88%;\n    overflow: hidden;\n    padding: 20px;\n}\n.messages-list ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.messages-list li span {\n    color: #3478ff;\n    opacity: 0.5;\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"Open Sans\", sans-serif;\n    font-weight: 600;\n    display: block;\n}\n.messages-list li {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n    opacity: 0.6;\n    font-size: 15px;\n    line-height: 22px;\n}\n.messages-list li + li {\n    margin-top: 15px;\n}\n.typing-msg {\n    border-top: 1px solid rgb(255 255 255 / 10%);\n    display: flex;\n    align-items: center;\n    /* justify-content: space-between; */\n    height: 12%;\n    padding: 0 20px;\n}\n.typing-msg form {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n.typbox input {\n    background: 0 0;\n    border: none;\n    outline: 0;\n    font-family: \"Open Sans\", sans-serif;\n    padding: 0;\n    color: #fff;\n    opacity: 0.6;\n}\n.typbox {\n    width: 70%;\n}\n.btn-submit {\n    width: 30%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n.btn-submit input {\n    width: auto;\n    background: #3478ff;\n    border: none;\n    color: #fff;\n    padding: 6px 20px;\n    outline: 0;\n    display: flex;\n}\n\n.take-note-field textarea {\n    background: 0 0;\n    width: 100%;\n    height: 100%;\n    outline: 0;\n    border: none;\n    padding: 25px;\n    resize: none;\n    color: #fff;\n    font-family: \"Open Sans\", sans-serif;\n    height: 100%;\n}\n.take-note-field {\n    height: 100%;\n}\n.take-notes-inner {\n    height: 100%;\n    background: #171717;\n    border-radius: 20px 0 0 20px;\n}\n.sermon-left,\n.sermon-right {\n    background: #131313;\n    height: 100%;\n    padding: 20px;\n}\n.sermon-left h4,\n.sermon-right h4 {\n    color: #fff;\n    opacity: 0.2;\n    font-size: 20px;\n    margin-bottom: 20px;\n}\n.sermon-left ul li {\n    color: #fff;\n    opacity: 0.6;\n    font-family: \"Open Sans\", sans-serif;\n    padding-left: 5px;\n}\n.sermon-left ul,\n.sermon-right ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n.sermon-left ul li + li {\n    margin-top: 18px;\n    padding-top: 18px;\n    border-top: 1px solid rgb(255 255 255 / 18%);\n}\n.sermon-right {\n    background: #101010;\n    height: 100%;\n    border-radius: 0 20px 20px 0;\n}\n.sermon-right ul li {\n    color: #fff;\n    opacity: 0.6;\n    padding-left: 5px;\n    font-family: \"Open Sans\", sans-serif;\n}\n.sermon-right ul li + li {\n    margin-top: 12px;\n}\n.take-notes-main-right .row {\n    height: 100%;\n}\n.home-img-4 img {\n    max-width: 100%;\n    display: table;\n    margin: 0 auto;\n}\n.has-sec-5-home .group-content1-inner {\n    text-align: center;\n    padding: 8% 0;\n}\n.has-sec-5-home .group-content1-inner h3 {\n    color: #fff;\n    font-size: 52px;\n    line-height: 68px;\n}\n.home-form-main img {\n    max-width: 100%;\n}\n.homebox-inner h3 {\n    color: #fff;\n    font-size: 48px;\n    line-height: 54px;\n}\n.homebox-inner p {\n    opacity: 0.6;\n    font-weight: 400;\n    padding-left: 12px;\n    font-size: 22px;\n    line-height: 32px;\n    max-width: 1050px;\n}\n.homebox-inner {\n    margin-top: 15%;\n}\n.has-sec-1-btm .fp-tableCell {\n    vertical-align: bottom;\n}\n.has-give-sec-2 .group-content1-inner {\n    background: #fff;\n}\n.has-give-sec-2 .group-content1-inner p {\n    color: #fa7373;\n}\n.give-content3-inner {\n    background: #f8acac;\n    background: linear-gradient(149deg, #f8acac 0, #fc4f4f 100%);\n    padding: 50px;\n    border-radius: 20px;\n}\n.give-content3-inner h3 {\n    color: #fff;\n    text-align: center;\n    font-size: 44px;\n    line-height: 50px;\n    margin: 0;\n}\n.annual-bo-iunner h4 {\n    text-align: center;\n    color: #fff;\n    margin: 0 0 15px;\n}\n.annual-bo-iunner {\n    border: 2px solid #fff;\n    border-radius: 5px;\n    padding: 20px 0;\n}\n.give-con-inner {\n    margin-bottom: 60px;\n}\n.has-sec-5-group .give-content3-inner h3 {\n    text-align: left;\n}\n.has-sec-3-group .give-content3-inner h3 {\n    text-align: left;\n}\n.budg-bo-iunner {\n    background: #fff;\n    padding: 40px;\n    border-radius: 8px;\n}\n.budg-bo-iunner h4 {\n    color: #fa7373;\n    font-size: 34px;\n    line-height: 45px;\n    margin-bottom: 20px;\n}\n.budg-box {\n    margin: 15px 0;\n}\n.radio-form input {\n    width: auto;\n    position: relative;\n    top: 0;\n    margin-right: 6px;\n}\n.radio-form label {\n    width: 100%;\n    color: #fff;\n}\n.radio-form {\n    margin: 25px 0 0;\n}\n.give-form input::-webkit-input-placeholder {\n    color: #fff;\n}\n.give-form input:-ms-input-placeholder {\n    color: #fff;\n}\n.give-form input::placeholder {\n    color: #fff;\n}\n.has-sec-3-group .give-con-inner {\n    margin-bottom: 20px;\n}\n.has-sec-3-group .give-content3-inner {\n    padding: 35px;\n}\n.half-input .full-input {\n    width: 46%;\n}\n.half-input {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n.form-checkbox ul li {\n    background: #fff;\n    color: #fb5656;\n    font-size: 14px;\n    padding: 6px 10px;\n    border-radius: 2px;\n    letter-spacing: -2px;\n}\n.form-checkbox ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n}\n.form-checkbox ul li + li {\n    margin-left: 12px;\n}\n.form-checkbox {\n    margin: 20px 0;\n}\n\n.box-1-giv {\n    width: 100%;\n    height: calc(50% - 15px);\n    background: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 30px;\n    border-radius: 20px;\n}\n.box-giv-con h5 {\n    color: #1d1f20;\n    font-size: 40px;\n}\n.box-giv-con {\n    margin-left: 20px;\n}\n.box-giv-con p {\n    color: #fa7b7b;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n.box-2-giv {\n    margin-top: 30px;\n}\n.home-giv-form .give-content3-inner {\n    padding: 35px;\n}\n.home-giv-form .give-content3-inner h3 {\n    text-align: left;\n}\n.home-giv-form .give-content3-inner .give-con-inner {\n    margin-bottom: 20px;\n}\n.give-content3-inner.home-about-form {\n    height: 100%;\n    background: #b5cbf6;\n    background: linear-gradient(149deg, #b5cbf6 0, #3478ff 100%);\n}\n.give-content3-inner.home-about-form .submit-btn-give input {\n    color: #397bfe;\n    margin-bottom: 0 !important;\n}\n.give-content3-inner.home-about-form .give-form input {\n    padding: 15px 0;\n    margin-bottom: 18px;\n}\n.has-bannew {\n    height: 75vh;\n}\n\n.has-bannew .has-sec1 {\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.has-ptb {\n    padding: 30px 0 0 !important;\n}\n.btp-no-footer {\n    padding-bottom: 90px !important;\n}\n.fullpage-nav {\n    padding: 85px 0 0 !important;\n}\n.fullpage-nav div#footer-sec {\n    margin-top: 30px;\n}\n.has-sec1-group,\n.has-sec1-group .container,\n.has-sec1-group .row {\n    height: 100%;\n}\n\n.has-sec1-group .slider-banner-content {\n    height: 100%;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n}\n.landing-sec-3 {\n    display: none;\n    height: 100vh;\n    align-items: center;\n}\n.landing-sec-3.show {\n    display: flex;\n}\n.landing-sec-2 {\n    height: 90vh;\n    padding: 50px 0 !important;\n}\n\n.landing-sec-2 .row {\n    display: flex;\n    justify-content: center;\n    height: 100%;\n}\n\n.landing-sec-2 .has-sec-2 {\n    height: 100%;\n}\n\n.landing-sec-2 .container {\n    height: 100%;\n}\n.has-sec-1-home,\n.typnote {\n    padding: 30px 0 0 !important;\n}\ninput[type=\"radio\"] {\n    width: 18px;\n    height: 18px;\n    margin: 0;\n    -webkit-appearance: none;\n    border: 1px solid #fff;\n    border-radius: 100%;\n    outline: none !important;\n    margin-right: 6px;\n    position: relative;\n    font-size: 16px;\n    color: #fff !important;\n    padding: 6px 6px;\n    position: relative;\n    top: 3px;\n}\ninput[type=\"radio\"]:checked::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    display: flex;\n    background: #fff;\n    width: 10px;\n    border-radius: 100%;\n    height: 10px;\n}\n.has-bannew-full {\n    height: calc(100vh - 86px);\n}\n.pas-btn a {\n    color: #fff;\n    text-decoration: underline;\n    text-underline-position: under;\n    margin-top: 15px;\n    display: block;\n}\n.reg-step-2 {\n    display: none;\n}\n\ndiv#resi-video-player {\n    width: 100%;\n    height: auto;\n}\n.messages-list {\n    height: 88%;\n    overflow: hidden;\n    padding: 20px;\n    max-height: 525px;\n    overflow-y: scroll;\n}\n.messages-list ul {\n    padding-bottom: 25px;\n}\n.scrol-bar::-webkit-scrollbar {\n    width: 8px;\n}\n\n/* Track */\n.scrol-bar::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 0px grey;\n    border-radius: 10px;\n}\n.msg-inner-box {\n    border-radius: 20px;\n    overflow: hidden;\n}\n/* Handle */\n.scrol-bar::-webkit-scrollbar-thumb {\n    background: #6a6a6a;\n    border-radius: 10px;\n}\n\n/* Handle on hover */\n.scrol-bar::-webkit-scrollbar-thumb:hover {\n    background: #6a6a6a;\n}\n\n::-webkit-calendar-picker-indicator {\n    filter: invert(1);\n}\n.no-reg {\n    pointer-events: none;\n}\ndiv#ifYes {\n    display: none;\n}\n.construction-content {\n    text-align: center;\n    padding: 100px 0;\n}\n\n.construction-content h1 {\n    color: #fff;\n    padding-top: 30px;\n}\n.about-content1-inner {\n    background: #171717;\n    border-radius: 20px;\n}\n\n.about-content1-inner a {\n    color: #fff;\n    text-decoration: none;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    padding: 40px;\n}\n\n.about-content1-inner a h3 {\n    font-size: 40px;\n    line-height: 48px;\n    margin: 25px 0 0;\n}\n.has-about-sec-2 {\n    padding: 60px 0;\n}\n.beliefs-content h2,\n.leader-content h2,\n.code-content h2 {\n    font-size: 40px;\n    color: #fff;\n    margin: 0;\n    font-weight: 600;\n}\n\n.beliefs-content h4 {\n    color: #fff;\n    font-size: 30px;\n    font-weight: 600;\n    line-height: 40px;\n    margin: 50px 0 10px;\n}\n\n.beliefs-content p {\n    opacity: 1;\n    color: #b4b4b4;\n}\n\n.beliefs-content p b {\n    font-size: 20px;\n    opacity: 1;\n    color: #fff;\n}\n\n.beliefs-content,\n.leader-content,\n.code-content {\n    padding: 30px 15px;\n}\n.code-content h4 {\n    color: #fff;\n    opacity: 0.5;\n    font-size: 30px;\n    line-height: 38px;\n    margin: 0 0 10px;\n    text-transform: initial;\n}\n\n.code-content h3 {\n    color: #fff;\n    font-size: 40px;\n    line-height: 48px;\n    font-family: \"Open Sans\", sans-serif;\n    margin: 0 0 50px;\n}\n.code-points {\n    background: rgb(23 23 23 / 30%);\n    padding: 15px;\n    border-radius: 15px;\n}\n.code-points i {\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 22px;\n    color: #fff;\n    opacity: 0.6;\n}\n\n.code-points p {\n    opacity: 1;\n}\n\n.code-points + .code-points {\n    margin-top: 15px;\n}\n\n.code-content h2 {\n    margin-bottom: 30px;\n}\n.leader-content h3 {\n    font-size: 34px;\n    color: #fff;\n    margin: 20px 0 16px;\n    font-weight: 600;\n}\n\n.leader-content p {\n    font-size: 20px;\n}\n\n.leader-content h2 {\n    margin-bottom: 40px;\n}\n.leader-img img {\n    width: 100%;\n    height: auto;\n}\n\n.leader-content .row + .row {\n    margin-top: 70px;\n}\n#page-header-bg h1:after {\n    content: \"About\";\n    -webkit-text-stroke-width: 1px;\n    -webkit-text-stroke-color: #3fb6ab;\n    color: transparent;\n    opacity: 0.3;\n    text-transform: uppercase;\n    font-size: 150px;\n    position: absolute;\n    left: -190px;\n    bottom: -135px;\n}\n.normal_form {\n    top: -60px !important;\n    width: 100% !important;\n}\n.swal-overlay {\n    z-index: 999999 !important;\n}\n.map {\n    height: 100vh;\n    filter: grayscale(100%) invert(92%) contrast(83%);\n}\n\n/*anup css start */\n/* AN css giving page */\n.innerContet {\n    background-color: #5f5f5bf2;\n    padding: 20px 0px;\n}\n.innerContet h3 {\n    font-size: 20px;\n    color: #fff;\n}\n.innerContet p {\n    font-size: 14px;\n    color: #fff;\n    line-height: 25px;\n    font-weight: 500;\n}\n.givingContentCls .amount input {\n    width: 100% !important;\n}\n.givingContentCls .radio-form label {\n    font-weight: 500 !important;\n    text-transform: capitalize !important;\n    font-family: \"Open Sans\" !important;\n    font-size: 14px;\n}\n.givingContentCls .giveNow {\n    font-size: 13px !important;\n    font-weight: 600;\n    padding: 10px 30px !important;\n    border-radius: 6px;\n    margin-bottom: 0px;\n}\n.givingContentCls .payment-check li {\n    border-radius: 5px !important;\n}\n.givingContentCls .payment-check .frequency {\n    font-weight: 600;\n    font-size: 10px;\n    letter-spacing: -1.9px;\n}\n/* progress bar */\n.give-progressCls .progress {\n    border-radius: 8px;\n}\n.give-progressCls .progress-bar-vertical {\n    width: 45px;\n    min-height: 100%;\n    background: #ececec;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: flex-end;\n    -webkit-align-items: flex-end;\n}\n\n.give-progressCls .progress-bar-vertical .progress-bar {\n    width: 100%;\n    height: 0;\n    -webkit-transition: height 0.6s ease;\n    -o-transition: height 0.6s ease;\n    transition: height 0.6s ease;\n}\n\n.give-progressCls .progress-striped {\n    background-image: linear-gradient(#f8a8a8, #fb5151);\n    border-radius: 5px;\n}\n/* progress bar */\n.give-progressCls .box-1-giv {\n    height: 100%;\n}\n.right-progressCon {\n    height: 100%;\n    text-align: center;\n}\n.right-progressCon h2 {\n    font-size: 75px;\n    color: #fb6d6d;\n}\n.right-progressCon span {\n    font-size: 38px;\n    color: #fb6d6d;\n    font-weight: 200 !important;\n    padding: 0px 20px;\n    position: relative;\n}\n.right-progressCon span:nth-child(1)::after {\n    content: \"\";\n    position: absolute;\n    top: 13px;\n    right: -5px;\n    width: 3px;\n    height: 62%;\n    background-color: #fb6d6d;\n}\n.right-progressCon p {\n    color: #202020;\n    font-size: 15px;\n    text-transform: uppercase;\n    font-weight: 600;\n    line-height: 25px;\n    max-width: 70%;\n    margin: 0px auto;\n    margin-top: 30px;\n}\n.priceBudgetCls {\n    height: 100%;\n    width: 100%;\n    background: #fff;\n    padding: 50px 30px;\n    border-radius: 20px;\n}\n.priceBudgetCls select.recurring_amount {\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    color: #8b8b8b;\n    font-size: 13px;\n    font-weight: 500;\n    padding: 10px 5px !important;\n}\n.pricCls h5 {\n    color: #202020;\n    font-size: 22px;\n    font-weight: 600;\n}\n.pricCls h2 {\n    font-size: 40px;\n    color: #fb6d6d;\n    font-weight: 600;\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n.pricNwCls h2 {\n    font-size: 100px;\n    color: #fff0f0;\n    font-weight: 900;\n    margin-bottom: 0px;\n}\n.pricNwCls h5 {\n    font-size: 22px;\n    color: #202020;\n    font-weight: 700;\n    margin-bottom: 0px;\n    line-height: 29px;\n}\n\n/* bar chart */\n.charCotCls select.recurring_amount {\n    border: 1px solid #fff;\n    border-radius: 8px;\n    color: #2b2a2a;\n    font-size: 13px;\n    font-weight: 500;\n    padding: 10px 5px !important;\n    background: transparent;\n    outline: none;\n    width: 100%;\n}\n/* end */\n.iconCls img {\n    width: 75px;\n    height: 75px;\n}\n.conteCls h3 {\n    font-size: 22px !important;\n    color: #202020 !important;\n    font-weight: 800 !important;\n    margin-bottom: 0px;\n    line-height: 29px;\n    text-align: left !important;\n}\n.conteCls p {\n    color: #fa7373;\n    font-size: 14px;\n    line-height: 25px;\n    margin-top: 10px;\n    letter-spacing: 3.1px !important;\n}\n.vidStCls {\n    height: max-content;\n}\n.tobMiddleHeader {\n    background-color: #232323;\n    padding: 10px 0px;\n    margin: 20px 0px;\n}\na.setGoal {\n    background: linear-gradient(149deg, #f8acac 0, #fc4f4f 100%);\n    padding: 6px 10px;\n    border-radius: 5px;\n    color: #fff !important;\n    font-size: 14px;\n}\n/* End */\n/* Giving page css */\n.category-cat-list ul {\n    margin: 0px;\n}\n.category-cat-list ul li {\n    display: inline-block;\n}\n.checkAddress input[type=\"radio\"] {\n    width: 30px !important;\n    height: 30px !important;\n    border-radius: 50px !important;\n    margin-right: 0px;\n}\n.catgry_chose input[type=\"radio\"]:before {\n    opacity: 1;\n}\n.catgry_chose input[type=\"radio\"]:before {\n    position: absolute;\n    content: \"\";\n    display: block;\n    top: 6px;\n    left: 11px;\n    width: 8px;\n    height: 14px;\n    border-color: #fff;\n    border-style: solid;\n    border-width: 0 3px 3px 0;\n    transform: rotate(45deg);\n    opacity: 0;\n}\n.catgry_chose input[type=\"radio\"]:checked::before {\n    position: absolute;\n    content: \"\";\n    display: block;\n    top: -3px;\n    left: 1px;\n    width: 8px;\n    height: 14px;\n    border-color: #3679ff;\n    border-style: solid;\n    border-width: 0 3px 3px 0;\n    transform: rotate(45deg);\n    opacity: 1 !important;\n    border-radius: unset;\n    background-color: unset;\n}\n.clrGrid input[type=\"radio\"]:checked {\n    background-color: #fff;\n}\n.accList {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.accList h3 {\n    margin: 0px;\n    font-size: 14px;\n    font-family: sans-serif;\n    text-transform: capitalize;\n    font-weight: 600;\n}\n.createAcc-contents {\n    background-color: #202020;\n    padding: 7px 13px;\n    border-radius: 10px;\n}\n.checkAddress {\n    width: 30px;\n    min-width: 30px;\n    height: 30px;\n    display: inline-table;\n}\n.clrGrid {\n    background-color: #3478ff;\n}\n.givingBudget1 {\n    background: linear-gradient(149deg, #96e599 0, #50b954 100%);\n    text-align: center;\n}\n.givingBudget1 .pricCls h5 {\n    color: #fff;\n    line-height: 40px;\n    font-weight: 500;\n    font-size: 27px;\n    margin: 0px;\n}\n.givingBudget2 {\n    background: linear-gradient(149deg, #a9c3f6 0, #4583fd 100%);\n    text-align: center;\n}\n.givingBudget2 .pricCls h5 {\n    color: #fff;\n    line-height: 40px;\n    font-weight: 500;\n    font-size: 27px;\n    margin: 0px;\n}\n\n/* budget css */\n.budgetMiddle-header {\n    background-color: #c8c8c8;\n}\n.budgetFrm {\n    border-radius: 10px;\n    padding: 15px;\n    background-color: #171717;\n    color: #fff;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.budgetFrm .give-con-inner h3 {\n    font-size: 24px;\n    margin: 0px;\n}\n.budgetFrm .give-con-inner h5 {\n    font-size: 18px;\n    margin: 0px;\n}\n.balNc p {\n    margin: 0px;\n    color: #2d703e;\n    text-transform: uppercase;\n    font-size: 20px;\n    text-align: center;\n}\n.budgetFrm_inner {\n    border-radius: 10px;\n    padding: 10px;\n    padding-left: 55px;\n    color: #fff;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 5px;\n}\n.budgetFrm_inner .give-con-inner h5 {\n    margin: 0px;\n    font-size: 16px;\n    color: #c6c5c5;\n}\n.budgetFrm_inner .balNc p {\n    margin: 0px;\n    color: #c6c5c5;\n    text-transform: uppercase;\n    font-size: 16px;\n    text-align: center;\n}\n.grenClr p {\n    color: #2b5474;\n}\n.buttonAdd a {\n    background-color: #393838;\n    display: block;\n    width: 30px;\n    height: 30px;\n    border-radius: 25px;\n    color: #ffffff !important;\n    text-align: center;\n    line-height: 32px;\n    font-size: 13px;\n    cursor: pointer;\n}\n\n/* tooltip css */\n.tooltip {\n    display: inline;\n    position: relative;\n}\n\n.tooltip:hover {\n    color: #c00;\n    text-decoration: none;\n}\n\n.tooltip:hover:after {\n    background: #111;\n    background: rgba(0, 0, 0, 0.8);\n    border-radius: 0.5em;\n    bottom: 1.35em;\n    color: #fff;\n    content: attr(title);\n    display: block;\n    left: 1em;\n    padding: 0.3em 1em;\n    position: absolute;\n    text-shadow: 0 1px 0 #000;\n    white-space: nowrap;\n    z-index: 98;\n}\n\n.tooltip:hover:before {\n    border: solid;\n    border-color: #111 transparent;\n    border-color: rgba(0, 0, 0, 0.8) transparent;\n    border-width: 0.4em 0.4em 0 0.4em;\n    bottom: 1em;\n    content: \"\";\n    display: block;\n    left: 2em;\n    position: absolute;\n    z-index: 99;\n}\n\n/*anup css end */\n\n/*schedule css*/\n/* .header-menu ul li a {\n    font-size: 18px !important;\n} */\n.header-menu ul li + li {\n    margin-left: 30px;\n}\n.titbar.search-field input {\n    font-family: \"Open Sans\", sans-serif;\n    padding: 12px 20px;\n}\n.hasbtnstyle {\n    padding: 18px 20px !important;\n    border-radius: 8px !important;\n    width: 16%;\n    position: relative;\n    top: 2px;\n    text-align: center;\n    font-family: \"Open Sans\", sans-serif;\n}\na.nav-link p {\n    margin: 0;\n}\n.has-box-inner img {\n    width: 100%;\n    height: auto;\n}\n\n.cat-main {\n    position: relative;\n}\n\n.removebtnHas {\n    position: absolute;\n    right: 30px;\n    top: 10px;\n    color: #fff;\n    background: #1d1f20;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 100%;\n    display: none;\n}\n\n.removebtnHas i {\n    font-size: 12px;\n    position: relative;\n    top: -2px;\n    left: 0px;\n}\n\n.cat-main:hover .removebtnHas {\n    display: flex;\n}\n\n.Has-box-inner {\n    position: relative;\n    overflow: hidden;\n    border-radius: 12px;\n}\n\n.hasnewBoxDetails {\n    position: absolute;\n    bottom: 0;\n    background: rgb(23 23 23 / 80%);\n    padding: 18px 25px;\n    width: 100%;\n}\n\n.hasnewBoxDetails h3 {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n    font-size: 24px;\n    line-height: 30px;\n    font-weight: 600;\n    margin: 0 0 8px;\n}\n\n.hasDateBox h4 {\n    font-family: \"Open Sans\", sans-serif;\n    color: rgb(255 255 255 / 50%);\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 400;\n    margin: 0 0 4px;\n}\n.eventInnerbarImage {\n    position: relative;\n    border-radius: 12px;\n    overflow: hidden;\n}\n.eventDetailsDetailMain {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.eventDetailsDetailRight a {\n    background: #fff;\n    color: #171717 !important;\n    border: none;\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n}\n.newtitleHas {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n    font-size: 32px;\n    line-height: 40px;\n    font-weight: 500;\n    margin: 0 0 20px;\n}\n.sch-listMain > a {\n    width: 100%;\n}\n.sch-list.sch-listMain h3 {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n    font-size: 26px;\n    line-height: 40px;\n    font-weight: 600;\n    margin: 0 0 0px;\n}\n.sch-list.sch-listMain .sch-list2 {\n    padding: 20px;\n}\n\n.sch-list.sch-listMain p {\n    font-size: 16px;\n}\n.rightnewtimes ul li b {\n    font-weight: 600;\n}\n\n.rightnewtimes ul li {\n    background: rgb(255 255 255 / 4%);\n    padding: 10px 30px;\n    width: 100%;\n    margin-left: -30px;\n    padding: 5px 12px !important;\n}\n\n.rightnewtimes ul li + li {\n    margin-top: 8px !important;\n}\n.rightnewtimes ul li a.righttimebtn {\n    padding: 5px 10px !important;\n    border-radius: 4px !important;\n    width: 150px;\n    position: relative;\n    top: 0;\n    text-align: center;\n    font-family: \"Open Sans\", sans-serif;\n    background: #3478ff;\n    color: #fff;\n    display: block;\n}\n.rightnewtimes h5 {\n    margin: 25px 0 12px !important;\n}\n/* body {\n    background: #080808 !important;\n} */\n\n.listhasleft h4 {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n    font-size: 24px;\n    line-height: 30px;\n    font-weight: 600;\n    margin: 0 0 8px;\n    opacity: 1 !important;\n}\n.titledate {\n    font-family: \"Open Sans\", sans-serif;\n}\n.hasboxinnerlist.gra-1 {\n    padding: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-radius: 12px 12px 0 0;\n}\n.tab button.tablinks {\n    width: 32.3%;\n    height: 45px;\n    padding: 0px;\n    background: rgb(255 255 255 / 20%);\n    border-radius: 6px !important;\n    color: rgb(255 255 255 / 60%) !important;\n    font-family: \"Open Sans\", sans-serif !important;\n    margin: 0 !important;\n}\n\n.tab button.tablinks.active,\n.tab button.tablinks:hover {\n    color: #000 !important;\n}\n.songListsMain {\n    padding: 10px 20px !important;\n}\n\nul#sortableList li.sortable-item {\n    margin: 0 0 10px !important;\n}\n.titleSchedule {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.deptBox {\n    background: rgb(255 255 255 / 4%);\n    border-radius: 8px;\n    padding-bottom: 12px;\n}\n\n.for-box-innner h4.deptTitle {\n    font-family: \"Open Sans\", sans-serif;\n    opacity: 1;\n    font-size: 20px;\n    line-height: 24px;\n    padding: 12px 15px;\n    border-bottom: 1px solid rgb(255 255 255 / 5%);\n    margin-bottom: 12px;\n}\n\n.for-box-innner .detpinnercol h6 {\n    font-family: \"Open Sans\", sans-serif;\n    opacity: 1;\n    font-size: 16px;\n    line-height: 14px;\n    padding: 0px 15px;\n    opacity: 0.6;\n    font-weight: 600;\n    margin: 25px 0 12px;\n}\n\n.detpinnercol ul li {\n    background: rgb(255 255 255 / 4%);\n    padding: 10px 15px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.rightList img {\n    max-width: 35px;\n    border-radius: 0px !important;\n    width: auto !important;\n    height: auto !important;\n    cursor: pointer;\n}\n\n.for-box-innner .leftList h5 {\n    margin: 0;\n    opacity: 1;\n    font-weight: 600;\n    font-size: 16px;\n    position: relative;\n}\n\n.status {\n    width: 10px;\n    height: 10px;\n    border-radius: 100%;\n    background: #fff;\n    position: absolute;\n    right: -20px;\n    top: 4.5px;\n}\n\n.green {\n    background: #28a830;\n}\n.red {\n    background: #ff3434;\n}\n.orange {\n    background: #ff7a00;\n}\n.detpinnercol ul li + li {\n    margin: 8px 0 0 !important;\n}\n.personNeeded a {\n    font-weight: 600;\n    color: #3478ff;\n    text-decoration: underline !important;\n    text-underline-position: under !important;\n}\n.deptBox + .deptBox {\n    margin-top: 15px;\n}\n.tab button.tablinks + button.tablinks {\n    margin-left: 1.5% !important;\n}\n.admin-main-dashboard.redefine-crm {\n    overflow: hidden !important;\n}\n.quote-main-right {\n    padding-bottom: 50px;\n}\n.top-menu-inner ul,\n/* .admin-dashboard-left, */\n.songsList,\n.for-box-innner {\n    background: #18191a !important;\n}\n.sendAddbtn {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 30px;\n}\n\na.hasaddbtnnew {\n    background: transparent !important;\n    border: none !important;\n    outline: none !important;\n    padding: 0;\n}\nbutton.hasbtnSend,\na.hasbtnnewblue {\n    padding: 12px 20px !important;\n    border-radius: 8px !important;\n    width: auto;\n    position: relative;\n    top: 2px;\n    text-align: center;\n    font-family: \"Open Sans\", sans-serif;\n    background: #3478ff;\n    color: #fff;\n    outline: none !important;\n    display: block;\n}\na.hasbtnnewblue {\n    display: table;\n    padding: 7px 25px !important;\n    border-radius: 5px !important;\n    font-size: 16px !important;\n}\nimg.smallAddbtn {\n    max-width: 18px;\n}\n.for-box-innner h5 a img {\n    margin-left: 6px;\n}\n\n.eventBoxmain .has-box-inner img {\n    width: 100%;\n    height: 270px !important;\n    object-fit: cover !important;\n    object-position: center !important;\n}\n\n.eventInnerbarImage .has-box-inner img {\n    width: 100% !important;\n    height: 350px;\n    object-fit: cover;\n    object-position: center;\n}\n\n/* .header-menu.newmenuDesign ul li a {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n} */\n\n/* .header-menu.newmenuDesign ul li a img {\n    margin-right: 12px;\n}\n\n.header-menu.newmenuDesign ul li a span {\n    position: relative;\n    top: 1px;\n} */\n.btn-primary.focus,\n.btn-primary:focus {\n    box-shadow: none !important;\n}\n.hasaddbtnnew {\n    cursor: pointer;\n}\n\n.menuSlideup {\n    position: absolute;\n    bottom: 130%;\n    background: #080808;\n    width: 180px;\n    right: 0;\n    border-radius: 12px;\n    padding: 12px 0;\n    display: none;\n}\n\n.rightbtn {\n    position: relative;\n}\n\n.menuSlideup ul li a {\n    padding: 0px 15px;\n    display: block;\n    color: #fff !important;\n    opacity: 0.9;\n    animation-duration: 0.3s;\n}\n\n.ful-cob-sec .for-box-innner ul li {\n    margin: 0 !important;\n    padding: 5px 0;\n}\n\n.ful-cob-sec .for-box-innner ul li + li {\n    margin-top: 10px !important;\n}\n\n.menuSlideup ul li:hover a {\n    color: #3478ff;\n}\n\n.menuSlideup:after {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 8px solid #080808;\n    position: absolute;\n    right: 17px;\n    bottom: -7px;\n}\n\n.menuSlideup.show {\n    display: block;\n}\n.hasaddbtnnew img {\n    transition: 0.3s;\n}\n\n.menuPlusbtn.hasaddbtnnew.activeMenuHas img {\n    transform: rotate(45deg);\n}\n\n.top-menu-inner.hasdashmenu img {\n    opacity: 0.7;\n}\n\n/*profile page*/\n.profileBluebox {\n    height: 100%;\n    background: #b5cbf6;\n    background: linear-gradient(149deg, #b5cbf6 0, #3478ff 100%);\n    border-radius: 20px 20px 0 0;\n    padding: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.profileBlueboxtop {\n    width: 100%;\n    display: flex;\n    align-items: start;\n}\n\n.profilePicture {\n    width: 25%;\n    text-align: center;\n}\n\n.prfileDetailsandFamily {\n    width: 50%;\n}\n\n.prfileDetailsandFamily h3 {\n    color: #fff;\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 34px;\n    line-height: 44px;\n    margin-bottom: 20px;\n}\n.prfileDetailsandFamily h4 {\n    color: #fff;\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 24px;\n    line-height: 24px;\n    margin-bottom: 40px;\n    text-transform: uppercase;\n}\n\n.prfileDetailsandFamily h6 {\n    color: #fff;\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 20px;\n    line-height: 24px;\n    margin-bottom: 10px;\n    text-transform: uppercase;\n}\n\na.hasbtnstylepro {\n    padding: 10px 10px !important;\n    border-radius: 4px !important;\n    width: 150px;\n    position: relative;\n    top: 0;\n    text-align: center;\n    font-family: \"Open Sans\", sans-serif;\n    background: #3478ff;\n    color: #fff;\n    display: table;\n    margin: 40px auto 0;\n}\n.condetails {\n    width: 25%;\n}\n\n.condetails .fam-right {\n    width: 100%;\n}\n\n.condetails .fam-right li p {\n    margin: 0;\n}\n.col2-info-fam h2 {\n    font-family: \"Open Sans\", sans-serif;\n    font-weight: 400 !important;\n}\n.newprofileInner .for-box-innner ul li img.add-people-img {\n    width: auto;\n    height: auto;\n    margin-right: 12px;\n}\n\n.profileBluebox {\n    flex-direction: column;\n    padding: 0;\n    overflow: hidden;\n    border-radius: 20px;\n}\n\n.profileBlueboxbottom {\n    width: 100%;\n}\n\n.profileBlueboxtop {\n    padding: 30px;\n}\n\n.custom-tab-list ul {\n    list-style: none;\n    margin: 0;\n    padding: 0 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.custom-tab-list ul li {\n    width: 33%;\n    text-align: center;\n}\n\n.custom-tab-list {\n    padding: 20px;\n    background: #fff;\n    border-radius: 0 0 20px 20px;\n}\n\n.custom-tab-list ul li a {\n    color: #000;\n    font-family: \"Open Sans\", sans-serif;\n    text-transform: uppercase;\n    font-weight: 600 !important;\n    transition: 0.3s;\n}\n\n.custom-tab-list ul li + li {\n    border-left: 1px solid #ccc;\n}\n\n.custom-tab-list ul li.active a,\n.custom-tab-list ul li:hover a {\n    color: #3478ff;\n}\n\n[class^=\"box-\"] {\n    display: none;\n}\n\n[class^=\"box-\"].showfirst {\n    display: block;\n}\n\n.hasnweboxInner {\n    border-radius: 20px;\n    padding: 30px;\n    color: #fff;\n    background: #18191a !important;\n    margin-top: 60px;\n}\n\n.titlenewDrop {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.dropdown select {\n    padding: 15px 15px;\n    width: 160px;\n    background: #2d2f30;\n    border: none;\n    outline: none;\n    border-radius: 10px;\n    color: #fff;\n    font-size: 16px;\n}\n\n.checkboxesadmin h4 {\n    color: #fff;\n    font-size: 16px;\n    margin-bottom: 20px;\n    font-family: \"Open Sans\", sans-serif;\n    font-weight: 400 !important;\n    text-transform: uppercase;\n    opacity: 0.6;\n}\n\nh4 {\n}\n\n.checkboxesadmin ul li,\n.checkboxesadmin ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.checkboxesadmin ul li input {\n    width: 15px;\n    margin-right: 10px;\n}\n\n.checkboxesadmin ul li label {\n    font-family: \"Open Sans\", sans-serif;\n    font-weight: 400 !important;\n}\n\n.confrmpasschanges input {\n    background: transparent;\n    border: none;\n    border-bottom: 1px solid #ccc;\n    padding: 9px 0;\n    width: 100%;\n    border-radius: 0;\n    font-family: \"Open Sans\", sans-serif;\n}\n\n.checkboxesadmin ul {\n    margin-bottom: 30px;\n}\n\n.confirmpassinner {\n    width: 25%;\n}\n\n.confrmpasschanges {\n    display: flex;\n    align-items: center;\n}\n\n.confirmpassinner + .confirmpassinner {\n    margin-left: 20px;\n}\n\n.confirmpassinner.submitconfirmbtn input {\n    padding: 10px 10px !important;\n    border-radius: 4px !important;\n    width: 150px;\n    position: relative;\n    top: 0;\n    text-align: center;\n    font-family: \"Open Sans\", sans-serif;\n    background: #3478ff;\n    color: #fff;\n    display: table;\n    margin: 0;\n    border: sienna;\n}\n\n.involmentBoxmain {\n    border-radius: 20px;\n    padding: 30px;\n    color: #fff;\n    background: #18191a !important;\n    margin-top: 30px;\n}\n\n.titlewithbtnnotification {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 30px;\n}\n\n.nnotco {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    position: relative;\n    margin-left: 20px;\n}\n\n.assgnbtnnot {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.assgnbtnnot a {\n    padding: 10px 10px !important;\n    border-radius: 4px !important;\n    width: 150px;\n    position: relative;\n    top: 0;\n    text-align: center;\n    font-family: \"Open Sans\", sans-serif;\n    background: #3478ff;\n    color: #fff;\n    display: table;\n}\n\n.notcount {\n    background: #3bab43;\n    font-family: \"Open Sans\", sans-serif;\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    font-weight: 700;\n    position: absolute;\n    top: -2px;\n    right: -9px;\n}\n\n.titlewithbtnnotification h3 {\n    font-family: \"Open Sans\", sans-serif;\n    margin: 0;\n}\n\n.rect-auto,\n.c100.p51 .slice,\n.c100.p52 .slice,\n.c100.p53 .slice,\n.c100.p54 .slice,\n.c100.p55 .slice,\n.c100.p56 .slice,\n.c100.p57 .slice,\n.c100.p58 .slice,\n.c100.p59 .slice,\n.c100.p60 .slice,\n.c100.p61 .slice,\n.c100.p62 .slice,\n.c100.p63 .slice,\n.c100.p64 .slice,\n.c100.p65 .slice,\n.c100.p66 .slice,\n.c100.p67 .slice,\n.c100.p68 .slice,\n.c100.p69 .slice,\n.c100.p70 .slice,\n.c100.p71 .slice,\n.c100.p72 .slice,\n.c100.p73 .slice,\n.c100.p74 .slice,\n.c100.p75 .slice,\n.c100.p76 .slice,\n.c100.p77 .slice,\n.c100.p78 .slice,\n.c100.p79 .slice,\n.c100.p80 .slice,\n.c100.p81 .slice,\n.c100.p82 .slice,\n.c100.p83 .slice,\n.c100.p84 .slice,\n.c100.p85 .slice,\n.c100.p86 .slice,\n.c100.p87 .slice,\n.c100.p88 .slice,\n.c100.p89 .slice,\n.c100.p90 .slice,\n.c100.p91 .slice,\n.c100.p92 .slice,\n.c100.p93 .slice,\n.c100.p94 .slice,\n.c100.p95 .slice,\n.c100.p96 .slice,\n.c100.p97 .slice,\n.c100.p98 .slice,\n.c100.p99 .slice,\n.c100.p100 .slice {\n    clip: rect(auto, auto, auto, auto);\n}\n\n.pie,\n.c100 .bar,\n.c100.p51 .fill,\n.c100.p52 .fill,\n.c100.p53 .fill,\n.c100.p54 .fill,\n.c100.p55 .fill,\n.c100.p56 .fill,\n.c100.p57 .fill,\n.c100.p58 .fill,\n.c100.p59 .fill,\n.c100.p60 .fill,\n.c100.p61 .fill,\n.c100.p62 .fill,\n.c100.p63 .fill,\n.c100.p64 .fill,\n.c100.p65 .fill,\n.c100.p66 .fill,\n.c100.p67 .fill,\n.c100.p68 .fill,\n.c100.p69 .fill,\n.c100.p70 .fill,\n.c100.p71 .fill,\n.c100.p72 .fill,\n.c100.p73 .fill,\n.c100.p74 .fill,\n.c100.p75 .fill,\n.c100.p76 .fill,\n.c100.p77 .fill,\n.c100.p78 .fill,\n.c100.p79 .fill,\n.c100.p80 .fill,\n.c100.p81 .fill,\n.c100.p82 .fill,\n.c100.p83 .fill,\n.c100.p84 .fill,\n.c100.p85 .fill,\n.c100.p86 .fill,\n.c100.p87 .fill,\n.c100.p88 .fill,\n.c100.p89 .fill,\n.c100.p90 .fill,\n.c100.p91 .fill,\n.c100.p92 .fill,\n.c100.p93 .fill,\n.c100.p94 .fill,\n.c100.p95 .fill,\n.c100.p96 .fill,\n.c100.p97 .fill,\n.c100.p98 .fill,\n.c100.p99 .fill,\n.c100.p100 .fill {\n    position: absolute;\n    border: 0.09em solid #000000;\n    width: 0.82em;\n    height: 0.82em;\n    clip: rect(0em, 0.5em, 1em, 0em);\n    border-radius: 50%;\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n\n.pie-fill,\n.c100.p51 .bar:after,\n.c100.p51 .fill,\n.c100.p52 .bar:after,\n.c100.p52 .fill,\n.c100.p53 .bar:after,\n.c100.p53 .fill,\n.c100.p54 .bar:after,\n.c100.p54 .fill,\n.c100.p55 .bar:after,\n.c100.p55 .fill,\n.c100.p56 .bar:after,\n.c100.p56 .fill,\n.c100.p57 .bar:after,\n.c100.p57 .fill,\n.c100.p58 .bar:after,\n.c100.p58 .fill,\n.c100.p59 .bar:after,\n.c100.p59 .fill,\n.c100.p60 .bar:after,\n.c100.p60 .fill,\n.c100.p61 .bar:after,\n.c100.p61 .fill,\n.c100.p62 .bar:after,\n.c100.p62 .fill,\n.c100.p63 .bar:after,\n.c100.p63 .fill,\n.c100.p64 .bar:after,\n.c100.p64 .fill,\n.c100.p65 .bar:after,\n.c100.p65 .fill,\n.c100.p66 .bar:after,\n.c100.p66 .fill,\n.c100.p67 .bar:after,\n.c100.p67 .fill,\n.c100.p68 .bar:after,\n.c100.p68 .fill,\n.c100.p69 .bar:after,\n.c100.p69 .fill,\n.c100.p70 .bar:after,\n.c100.p70 .fill,\n.c100.p71 .bar:after,\n.c100.p71 .fill,\n.c100.p72 .bar:after,\n.c100.p72 .fill,\n.c100.p73 .bar:after,\n.c100.p73 .fill,\n.c100.p74 .bar:after,\n.c100.p74 .fill,\n.c100.p75 .bar:after,\n.c100.p75 .fill,\n.c100.p76 .bar:after,\n.c100.p76 .fill,\n.c100.p77 .bar:after,\n.c100.p77 .fill,\n.c100.p78 .bar:after,\n.c100.p78 .fill,\n.c100.p79 .bar:after,\n.c100.p79 .fill,\n.c100.p80 .bar:after,\n.c100.p80 .fill,\n.c100.p81 .bar:after,\n.c100.p81 .fill,\n.c100.p82 .bar:after,\n.c100.p82 .fill,\n.c100.p83 .bar:after,\n.c100.p83 .fill,\n.c100.p84 .bar:after,\n.c100.p84 .fill,\n.c100.p85 .bar:after,\n.c100.p85 .fill,\n.c100.p86 .bar:after,\n.c100.p86 .fill,\n.c100.p87 .bar:after,\n.c100.p87 .fill,\n.c100.p88 .bar:after,\n.c100.p88 .fill,\n.c100.p89 .bar:after,\n.c100.p89 .fill,\n.c100.p90 .bar:after,\n.c100.p90 .fill,\n.c100.p91 .bar:after,\n.c100.p91 .fill,\n.c100.p92 .bar:after,\n.c100.p92 .fill,\n.c100.p93 .bar:after,\n.c100.p93 .fill,\n.c100.p94 .bar:after,\n.c100.p94 .fill,\n.c100.p95 .bar:after,\n.c100.p95 .fill,\n.c100.p96 .bar:after,\n.c100.p96 .fill,\n.c100.p97 .bar:after,\n.c100.p97 .fill,\n.c100.p98 .bar:after,\n.c100.p98 .fill,\n.c100.p99 .bar:after,\n.c100.p99 .fill,\n.c100.p100 .bar:after,\n.c100.p100 .fill {\n    -moz-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n\n.c100 {\n    position: relative;\n    font-size: 160px;\n    width: 1em;\n    height: 1em;\n    border-radius: 50%;\n    float: left;\n    margin: 0;\n    /* background-color: #dfe8ed; */\n}\n.c100 *,\n.c100 *:before,\n.c100 *:after {\n    -moz-box-sizing: content-box;\n    -webkit-box-sizing: content-box;\n    box-sizing: content-box;\n}\n.c100 > span {\n    position: absolute;\n    width: 100%;\n    z-index: 1;\n    left: 0;\n    top: 0;\n    width: 5em;\n    line-height: 5em;\n    font-size: 0.2em;\n    color: #fff;\n    display: block;\n    font-weight: 400 !important;\n    text-align: center;\n    white-space: nowrap;\n    -moz-transition-property: all;\n    -o-transition-property: all;\n    -webkit-transition-property: all;\n    transition-property: all;\n    -moz-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    -webkit-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -moz-transition-timing-function: ease-out;\n    -o-transition-timing-function: ease-out;\n    -webkit-transition-timing-function: ease-out;\n    transition-timing-function: ease-out;\n    font-weight: 400 !important;\n}\n.c100:after {\n    position: absolute;\n    top: 0.09em;\n    left: 0.09em;\n    display: block;\n    content: \" \";\n    border-radius: 50%;\n    /* background-color: #ffffff; */\n    width: 0.82em;\n    height: 0.82em;\n    -moz-transition-property: all;\n    -o-transition-property: all;\n    -webkit-transition-property: all;\n    transition-property: all;\n    -moz-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    -webkit-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -moz-transition-timing-function: ease-in;\n    -o-transition-timing-function: ease-in;\n    -webkit-transition-timing-function: ease-in;\n    transition-timing-function: ease-in;\n    font-family: \"Open Sans\", sans-serif;\n}\n.c100 .slice {\n    position: absolute;\n    width: 1em;\n    height: 1em;\n    clip: rect(0em, 1em, 1em, 0.5em);\n}\n.c100.p1 .bar {\n    -moz-transform: rotate(3.6deg);\n    -ms-transform: rotate(3.6deg);\n    -webkit-transform: rotate(3.6deg);\n    transform: rotate(3.6deg);\n}\n.c100.p2 .bar {\n    -moz-transform: rotate(7.2deg);\n    -ms-transform: rotate(7.2deg);\n    -webkit-transform: rotate(7.2deg);\n    transform: rotate(7.2deg);\n}\n.c100.p3 .bar {\n    -moz-transform: rotate(10.8deg);\n    -ms-transform: rotate(10.8deg);\n    -webkit-transform: rotate(10.8deg);\n    transform: rotate(10.8deg);\n}\n.c100.p4 .bar {\n    -moz-transform: rotate(14.4deg);\n    -ms-transform: rotate(14.4deg);\n    -webkit-transform: rotate(14.4deg);\n    transform: rotate(14.4deg);\n}\n.c100.p5 .bar {\n    -moz-transform: rotate(18deg);\n    -ms-transform: rotate(18deg);\n    -webkit-transform: rotate(18deg);\n    transform: rotate(18deg);\n}\n.c100.p6 .bar {\n    -moz-transform: rotate(21.6deg);\n    -ms-transform: rotate(21.6deg);\n    -webkit-transform: rotate(21.6deg);\n    transform: rotate(21.6deg);\n}\n.c100.p7 .bar {\n    -moz-transform: rotate(25.2deg);\n    -ms-transform: rotate(25.2deg);\n    -webkit-transform: rotate(25.2deg);\n    transform: rotate(25.2deg);\n}\n.c100.p8 .bar {\n    -moz-transform: rotate(28.8deg);\n    -ms-transform: rotate(28.8deg);\n    -webkit-transform: rotate(28.8deg);\n    transform: rotate(28.8deg);\n}\n.c100.p9 .bar {\n    -moz-transform: rotate(32.4deg);\n    -ms-transform: rotate(32.4deg);\n    -webkit-transform: rotate(32.4deg);\n    transform: rotate(32.4deg);\n}\n.c100.p10 .bar {\n    -moz-transform: rotate(36deg);\n    -ms-transform: rotate(36deg);\n    -webkit-transform: rotate(36deg);\n    transform: rotate(36deg);\n}\n.c100.p11 .bar {\n    -moz-transform: rotate(39.6deg);\n    -ms-transform: rotate(39.6deg);\n    -webkit-transform: rotate(39.6deg);\n    transform: rotate(39.6deg);\n}\n.c100.p12 .bar {\n    -moz-transform: rotate(43.2deg);\n    -ms-transform: rotate(43.2deg);\n    -webkit-transform: rotate(43.2deg);\n    transform: rotate(43.2deg);\n}\n.c100.p13 .bar {\n    -moz-transform: rotate(46.8deg);\n    -ms-transform: rotate(46.8deg);\n    -webkit-transform: rotate(46.8deg);\n    transform: rotate(46.8deg);\n}\n.c100.p14 .bar {\n    -moz-transform: rotate(50.4deg);\n    -ms-transform: rotate(50.4deg);\n    -webkit-transform: rotate(50.4deg);\n    transform: rotate(50.4deg);\n}\n.c100.p15 .bar {\n    -moz-transform: rotate(54deg);\n    -ms-transform: rotate(54deg);\n    -webkit-transform: rotate(54deg);\n    transform: rotate(54deg);\n}\n.c100.p16 .bar {\n    -moz-transform: rotate(57.6deg);\n    -ms-transform: rotate(57.6deg);\n    -webkit-transform: rotate(57.6deg);\n    transform: rotate(57.6deg);\n}\n.c100.p17 .bar {\n    -moz-transform: rotate(61.2deg);\n    -ms-transform: rotate(61.2deg);\n    -webkit-transform: rotate(61.2deg);\n    transform: rotate(61.2deg);\n}\n.c100.p18 .bar {\n    -moz-transform: rotate(64.8deg);\n    -ms-transform: rotate(64.8deg);\n    -webkit-transform: rotate(64.8deg);\n    transform: rotate(64.8deg);\n}\n.c100.p19 .bar {\n    -moz-transform: rotate(68.4deg);\n    -ms-transform: rotate(68.4deg);\n    -webkit-transform: rotate(68.4deg);\n    transform: rotate(68.4deg);\n}\n.c100.p20 .bar {\n    -moz-transform: rotate(72deg);\n    -ms-transform: rotate(72deg);\n    -webkit-transform: rotate(72deg);\n    transform: rotate(72deg);\n}\n.c100.p21 .bar {\n    -moz-transform: rotate(75.6deg);\n    -ms-transform: rotate(75.6deg);\n    -webkit-transform: rotate(75.6deg);\n    transform: rotate(75.6deg);\n}\n.c100.p22 .bar {\n    -moz-transform: rotate(79.2deg);\n    -ms-transform: rotate(79.2deg);\n    -webkit-transform: rotate(79.2deg);\n    transform: rotate(79.2deg);\n}\n.c100.p23 .bar {\n    -moz-transform: rotate(82.8deg);\n    -ms-transform: rotate(82.8deg);\n    -webkit-transform: rotate(82.8deg);\n    transform: rotate(82.8deg);\n}\n.c100.p24 .bar {\n    -moz-transform: rotate(86.4deg);\n    -ms-transform: rotate(86.4deg);\n    -webkit-transform: rotate(86.4deg);\n    transform: rotate(86.4deg);\n}\n.c100.p25 .bar {\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n.c100.p26 .bar {\n    -moz-transform: rotate(93.6deg);\n    -ms-transform: rotate(93.6deg);\n    -webkit-transform: rotate(93.6deg);\n    transform: rotate(93.6deg);\n}\n.c100.p27 .bar {\n    -moz-transform: rotate(97.2deg);\n    -ms-transform: rotate(97.2deg);\n    -webkit-transform: rotate(97.2deg);\n    transform: rotate(97.2deg);\n}\n.c100.p28 .bar {\n    -moz-transform: rotate(100.8deg);\n    -ms-transform: rotate(100.8deg);\n    -webkit-transform: rotate(100.8deg);\n    transform: rotate(100.8deg);\n}\n.c100.p29 .bar {\n    -moz-transform: rotate(104.4deg);\n    -ms-transform: rotate(104.4deg);\n    -webkit-transform: rotate(104.4deg);\n    transform: rotate(104.4deg);\n}\n.c100.p30 .bar {\n    -moz-transform: rotate(108deg);\n    -ms-transform: rotate(108deg);\n    -webkit-transform: rotate(108deg);\n    transform: rotate(108deg);\n}\n.c100.p31 .bar {\n    -moz-transform: rotate(111.6deg);\n    -ms-transform: rotate(111.6deg);\n    -webkit-transform: rotate(111.6deg);\n    transform: rotate(111.6deg);\n}\n.c100.p32 .bar {\n    -moz-transform: rotate(115.2deg);\n    -ms-transform: rotate(115.2deg);\n    -webkit-transform: rotate(115.2deg);\n    transform: rotate(115.2deg);\n}\n.c100.p33 .bar {\n    -moz-transform: rotate(118.8deg);\n    -ms-transform: rotate(118.8deg);\n    -webkit-transform: rotate(118.8deg);\n    transform: rotate(118.8deg);\n}\n.c100.p34 .bar {\n    -moz-transform: rotate(122.4deg);\n    -ms-transform: rotate(122.4deg);\n    -webkit-transform: rotate(122.4deg);\n    transform: rotate(122.4deg);\n}\n.c100.p35 .bar {\n    -moz-transform: rotate(126deg);\n    -ms-transform: rotate(126deg);\n    -webkit-transform: rotate(126deg);\n    transform: rotate(126deg);\n}\n.c100.p36 .bar {\n    -moz-transform: rotate(129.6deg);\n    -ms-transform: rotate(129.6deg);\n    -webkit-transform: rotate(129.6deg);\n    transform: rotate(129.6deg);\n}\n.c100.p37 .bar {\n    -moz-transform: rotate(133.2deg);\n    -ms-transform: rotate(133.2deg);\n    -webkit-transform: rotate(133.2deg);\n    transform: rotate(133.2deg);\n}\n.c100.p38 .bar {\n    -moz-transform: rotate(136.8deg);\n    -ms-transform: rotate(136.8deg);\n    -webkit-transform: rotate(136.8deg);\n    transform: rotate(136.8deg);\n}\n.c100.p39 .bar {\n    -moz-transform: rotate(140.4deg);\n    -ms-transform: rotate(140.4deg);\n    -webkit-transform: rotate(140.4deg);\n    transform: rotate(140.4deg);\n}\n.c100.p40 .bar {\n    -moz-transform: rotate(144deg);\n    -ms-transform: rotate(144deg);\n    -webkit-transform: rotate(144deg);\n    transform: rotate(144deg);\n}\n.c100.p41 .bar {\n    -moz-transform: rotate(147.6deg);\n    -ms-transform: rotate(147.6deg);\n    -webkit-transform: rotate(147.6deg);\n    transform: rotate(147.6deg);\n}\n.c100.p42 .bar {\n    -moz-transform: rotate(151.2deg);\n    -ms-transform: rotate(151.2deg);\n    -webkit-transform: rotate(151.2deg);\n    transform: rotate(151.2deg);\n}\n.c100.p43 .bar {\n    -moz-transform: rotate(154.8deg);\n    -ms-transform: rotate(154.8deg);\n    -webkit-transform: rotate(154.8deg);\n    transform: rotate(154.8deg);\n}\n.c100.p44 .bar {\n    -moz-transform: rotate(158.4deg);\n    -ms-transform: rotate(158.4deg);\n    -webkit-transform: rotate(158.4deg);\n    transform: rotate(158.4deg);\n}\n.c100.p45 .bar {\n    -moz-transform: rotate(162deg);\n    -ms-transform: rotate(162deg);\n    -webkit-transform: rotate(162deg);\n    transform: rotate(162deg);\n}\n.c100.p46 .bar {\n    -moz-transform: rotate(165.6deg);\n    -ms-transform: rotate(165.6deg);\n    -webkit-transform: rotate(165.6deg);\n    transform: rotate(165.6deg);\n}\n.c100.p47 .bar {\n    -moz-transform: rotate(169.2deg);\n    -ms-transform: rotate(169.2deg);\n    -webkit-transform: rotate(169.2deg);\n    transform: rotate(169.2deg);\n}\n.c100.p48 .bar {\n    -moz-transform: rotate(172.8deg);\n    -ms-transform: rotate(172.8deg);\n    -webkit-transform: rotate(172.8deg);\n    transform: rotate(172.8deg);\n}\n.c100.p49 .bar {\n    -moz-transform: rotate(176.4deg);\n    -ms-transform: rotate(176.4deg);\n    -webkit-transform: rotate(176.4deg);\n    transform: rotate(176.4deg);\n}\n.c100.p50 .bar {\n    -moz-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n.c100.p51 .bar {\n    -moz-transform: rotate(183.6deg);\n    -ms-transform: rotate(183.6deg);\n    -webkit-transform: rotate(183.6deg);\n    transform: rotate(183.6deg);\n}\n.c100.p52 .bar {\n    -moz-transform: rotate(187.2deg);\n    -ms-transform: rotate(187.2deg);\n    -webkit-transform: rotate(187.2deg);\n    transform: rotate(187.2deg);\n}\n.c100.p53 .bar {\n    -moz-transform: rotate(190.8deg);\n    -ms-transform: rotate(190.8deg);\n    -webkit-transform: rotate(190.8deg);\n    transform: rotate(190.8deg);\n}\n.c100.p54 .bar {\n    -moz-transform: rotate(194.4deg);\n    -ms-transform: rotate(194.4deg);\n    -webkit-transform: rotate(194.4deg);\n    transform: rotate(194.4deg);\n}\n.c100.p55 .bar {\n    -moz-transform: rotate(198deg);\n    -ms-transform: rotate(198deg);\n    -webkit-transform: rotate(198deg);\n    transform: rotate(198deg);\n}\n.c100.p56 .bar {\n    -moz-transform: rotate(201.6deg);\n    -ms-transform: rotate(201.6deg);\n    -webkit-transform: rotate(201.6deg);\n    transform: rotate(201.6deg);\n}\n.c100.p57 .bar {\n    -moz-transform: rotate(205.2deg);\n    -ms-transform: rotate(205.2deg);\n    -webkit-transform: rotate(205.2deg);\n    transform: rotate(205.2deg);\n}\n.c100.p58 .bar {\n    -moz-transform: rotate(208.8deg);\n    -ms-transform: rotate(208.8deg);\n    -webkit-transform: rotate(208.8deg);\n    transform: rotate(208.8deg);\n}\n.c100.p59 .bar {\n    -moz-transform: rotate(212.4deg);\n    -ms-transform: rotate(212.4deg);\n    -webkit-transform: rotate(212.4deg);\n    transform: rotate(212.4deg);\n}\n.c100.p60 .bar {\n    -moz-transform: rotate(216deg);\n    -ms-transform: rotate(216deg);\n    -webkit-transform: rotate(216deg);\n    transform: rotate(216deg);\n}\n.c100.p61 .bar {\n    -moz-transform: rotate(219.6deg);\n    -ms-transform: rotate(219.6deg);\n    -webkit-transform: rotate(219.6deg);\n    transform: rotate(219.6deg);\n}\n.c100.p62 .bar {\n    -moz-transform: rotate(223.2deg);\n    -ms-transform: rotate(223.2deg);\n    -webkit-transform: rotate(223.2deg);\n    transform: rotate(223.2deg);\n}\n.c100.p63 .bar {\n    -moz-transform: rotate(226.8deg);\n    -ms-transform: rotate(226.8deg);\n    -webkit-transform: rotate(226.8deg);\n    transform: rotate(226.8deg);\n}\n.c100.p64 .bar {\n    -moz-transform: rotate(230.4deg);\n    -ms-transform: rotate(230.4deg);\n    -webkit-transform: rotate(230.4deg);\n    transform: rotate(230.4deg);\n}\n.c100.p65 .bar {\n    -moz-transform: rotate(234deg);\n    -ms-transform: rotate(234deg);\n    -webkit-transform: rotate(234deg);\n    transform: rotate(234deg);\n}\n.c100.p66 .bar {\n    -moz-transform: rotate(237.6deg);\n    -ms-transform: rotate(237.6deg);\n    -webkit-transform: rotate(237.6deg);\n    transform: rotate(237.6deg);\n}\n.c100.p67 .bar {\n    -moz-transform: rotate(241.2deg);\n    -ms-transform: rotate(241.2deg);\n    -webkit-transform: rotate(241.2deg);\n    transform: rotate(241.2deg);\n}\n.c100.p68 .bar {\n    -moz-transform: rotate(244.8deg);\n    -ms-transform: rotate(244.8deg);\n    -webkit-transform: rotate(244.8deg);\n    transform: rotate(244.8deg);\n}\n.c100.p69 .bar {\n    -moz-transform: rotate(248.4deg);\n    -ms-transform: rotate(248.4deg);\n    -webkit-transform: rotate(248.4deg);\n    transform: rotate(248.4deg);\n}\n.c100.p70 .bar {\n    -moz-transform: rotate(252deg);\n    -ms-transform: rotate(252deg);\n    -webkit-transform: rotate(252deg);\n    transform: rotate(252deg);\n}\n.c100.p71 .bar {\n    -moz-transform: rotate(255.6deg);\n    -ms-transform: rotate(255.6deg);\n    -webkit-transform: rotate(255.6deg);\n    transform: rotate(255.6deg);\n}\n.c100.p72 .bar {\n    -moz-transform: rotate(259.2deg);\n    -ms-transform: rotate(259.2deg);\n    -webkit-transform: rotate(259.2deg);\n    transform: rotate(259.2deg);\n}\n.c100.p73 .bar {\n    -moz-transform: rotate(262.8deg);\n    -ms-transform: rotate(262.8deg);\n    -webkit-transform: rotate(262.8deg);\n    transform: rotate(262.8deg);\n}\n.c100.p74 .bar {\n    -moz-transform: rotate(266.4deg);\n    -ms-transform: rotate(266.4deg);\n    -webkit-transform: rotate(266.4deg);\n    transform: rotate(266.4deg);\n}\n.c100.p75 .bar {\n    -moz-transform: rotate(270deg);\n    -ms-transform: rotate(270deg);\n    -webkit-transform: rotate(270deg);\n    transform: rotate(270deg);\n}\n.c100.p76 .bar {\n    -moz-transform: rotate(273.6deg);\n    -ms-transform: rotate(273.6deg);\n    -webkit-transform: rotate(273.6deg);\n    transform: rotate(273.6deg);\n}\n.c100.p77 .bar {\n    -moz-transform: rotate(277.2deg);\n    -ms-transform: rotate(277.2deg);\n    -webkit-transform: rotate(277.2deg);\n    transform: rotate(277.2deg);\n}\n.c100.p78 .bar {\n    -moz-transform: rotate(280.8deg);\n    -ms-transform: rotate(280.8deg);\n    -webkit-transform: rotate(280.8deg);\n    transform: rotate(280.8deg);\n}\n.c100.p79 .bar {\n    -moz-transform: rotate(284.4deg);\n    -ms-transform: rotate(284.4deg);\n    -webkit-transform: rotate(284.4deg);\n    transform: rotate(284.4deg);\n}\n.c100.p80 .bar {\n    -moz-transform: rotate(288deg);\n    -ms-transform: rotate(288deg);\n    -webkit-transform: rotate(288deg);\n    transform: rotate(288deg);\n}\n.c100.p81 .bar {\n    -moz-transform: rotate(291.6deg);\n    -ms-transform: rotate(291.6deg);\n    -webkit-transform: rotate(291.6deg);\n    transform: rotate(291.6deg);\n}\n.c100.p82 .bar {\n    -moz-transform: rotate(295.2deg);\n    -ms-transform: rotate(295.2deg);\n    -webkit-transform: rotate(295.2deg);\n    transform: rotate(295.2deg);\n}\n.c100.p83 .bar {\n    -moz-transform: rotate(298.8deg);\n    -ms-transform: rotate(298.8deg);\n    -webkit-transform: rotate(298.8deg);\n    transform: rotate(298.8deg);\n}\n.c100.p84 .bar {\n    -moz-transform: rotate(302.4deg);\n    -ms-transform: rotate(302.4deg);\n    -webkit-transform: rotate(302.4deg);\n    transform: rotate(302.4deg);\n}\n.c100.p85 .bar {\n    -moz-transform: rotate(306deg);\n    -ms-transform: rotate(306deg);\n    -webkit-transform: rotate(306deg);\n    transform: rotate(306deg);\n}\n.c100.p86 .bar {\n    -moz-transform: rotate(309.6deg);\n    -ms-transform: rotate(309.6deg);\n    -webkit-transform: rotate(309.6deg);\n    transform: rotate(309.6deg);\n}\n.c100.p87 .bar {\n    -moz-transform: rotate(313.2deg);\n    -ms-transform: rotate(313.2deg);\n    -webkit-transform: rotate(313.2deg);\n    transform: rotate(313.2deg);\n}\n.c100.p88 .bar {\n    -moz-transform: rotate(316.8deg);\n    -ms-transform: rotate(316.8deg);\n    -webkit-transform: rotate(316.8deg);\n    transform: rotate(316.8deg);\n}\n.c100.p89 .bar {\n    -moz-transform: rotate(320.4deg);\n    -ms-transform: rotate(320.4deg);\n    -webkit-transform: rotate(320.4deg);\n    transform: rotate(320.4deg);\n}\n.c100.p90 .bar {\n    -moz-transform: rotate(324deg);\n    -ms-transform: rotate(324deg);\n    -webkit-transform: rotate(324deg);\n    transform: rotate(324deg);\n}\n.c100.p91 .bar {\n    -moz-transform: rotate(327.6deg);\n    -ms-transform: rotate(327.6deg);\n    -webkit-transform: rotate(327.6deg);\n    transform: rotate(327.6deg);\n}\n.c100.p92 .bar {\n    -moz-transform: rotate(331.2deg);\n    -ms-transform: rotate(331.2deg);\n    -webkit-transform: rotate(331.2deg);\n    transform: rotate(331.2deg);\n}\n.c100.p93 .bar {\n    -moz-transform: rotate(334.8deg);\n    -ms-transform: rotate(334.8deg);\n    -webkit-transform: rotate(334.8deg);\n    transform: rotate(334.8deg);\n}\n.c100.p94 .bar {\n    -moz-transform: rotate(338.4deg);\n    -ms-transform: rotate(338.4deg);\n    -webkit-transform: rotate(338.4deg);\n    transform: rotate(338.4deg);\n}\n.c100.p95 .bar {\n    -moz-transform: rotate(342deg);\n    -ms-transform: rotate(342deg);\n    -webkit-transform: rotate(342deg);\n    transform: rotate(342deg);\n}\n.c100.p96 .bar {\n    -moz-transform: rotate(345.6deg);\n    -ms-transform: rotate(345.6deg);\n    -webkit-transform: rotate(345.6deg);\n    transform: rotate(345.6deg);\n}\n.c100.p97 .bar {\n    -moz-transform: rotate(349.2deg);\n    -ms-transform: rotate(349.2deg);\n    -webkit-transform: rotate(349.2deg);\n    transform: rotate(349.2deg);\n}\n.c100.p98 .bar {\n    -moz-transform: rotate(352.8deg);\n    -ms-transform: rotate(352.8deg);\n    -webkit-transform: rotate(352.8deg);\n    transform: rotate(352.8deg);\n}\n.c100.p99 .bar {\n    -moz-transform: rotate(356.4deg);\n    -ms-transform: rotate(356.4deg);\n    -webkit-transform: rotate(356.4deg);\n    transform: rotate(356.4deg);\n}\n.c100.p100 .bar {\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n.c100:hover {\n    cursor: default;\n}\n.c100:hover > span {\n    /* width: 3.33em; */\n    /* line-height: 3.33em; */\n    /* font-size: 0.3em; */\n    color: #3c4761;\n}\n.c100:hover:after {\n    top: 0.07em;\n    left: 0.07em;\n    width: 0.86em;\n    height: 0.86em;\n}\n.c100.blue .bar,\n.c100.blue .fill {\n    border-color: #30bae7 !important;\n}\n.c100.blue:hover > span {\n    color: #fff;\n}\n.c100.pink .bar,\n.c100.pink .fill {\n    border-color: #d74680 !important;\n}\n.c100.pink:hover > span {\n    color: #3c4761;\n}\n.c100.green .bar,\n.c100.green .fill {\n    border-color: #15c7a8 !important;\n}\n.c100.green:hover > span {\n    color: #3c4761;\n}\n.c100.orange .bar,\n.c100.orange .fill {\n    border-color: #eb7d4b !important;\n}\n.c100.orange:hover > span {\n    color: #3c4761;\n}\n.rateTitle h4 {\n    color: #fff;\n    font-size: 16px;\n    margin-bottom: 20px;\n    font-family: \"Open Sans\", sans-serif;\n    font-weight: 400 !important;\n    text-transform: uppercase;\n    opacity: 0.6;\n    margin: 0;\n}\n\n.rateTitle {\n    width: 180px;\n}\n\n.ratesMain {\n    display: flex;\n    align-items: center;\n}\n\n.involmentDetails ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.serv.col2-info-fam .for-box-innner {\n    padding: 0;\n    margin-top: 20px;\n}\n\n.involRight ul li {\n    border-radius: 20px;\n    padding: 20px;\n    color: #fff;\n    background: #18191a !important;\n    margin-top: 30px;\n    font-family: \"Open Sans\", sans-serif;\n}\n\n.involRight ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n.dateinvol {\n    font-family: \"Open Sans\", sans-serif;\n    opacity: 0.6;\n    margin-bottom: 12px;\n}\n\n.titlewithbtnnotification h3 span {\n    font-family: \"Open Sans\", sans-serif;\n    margin: 0;\n    font-size: 19px;\n    opacity: 0.3;\n}\n\n.messgtnotemain .titlewithbtnnotification h3 {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 200px;\n}\n\n.messgtnotemain .titlewithbtnnotification {\n}\n\n.notedate {\n    font-family: \"Open Sans\", sans-serif;\n    margin: 0;\n    margin-right: 30px;\n}\n\n.noteDetails p {\n    font-size: 16px;\n    line-height: 26px;\n    opacity: 0.6;\n}\n\n.notetypebox {\n    border-radius: 20px;\n    padding: 30px;\n    color: #fff;\n    background: #18191a !important;\n    margin-top: 30px;\n}\n\n.notetextarea textarea {\n    width: 100%;\n    resize: none;\n    background: none;\n    outline: none;\n    border: none;\n    border-bottom: 1px solid #3c3c3c;\n    margin-bottom: 20px;\n}\n\n.notetypebox .confrmpasschanges {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    margin-right: 0;\n}\n\n.notetextarea h5 {\n    font-family: \"Open Sans\", sans-serif;\n    margin: 0;\n    font-size: 19px;\n    opacity: 0.3;\n}\n.notetypebox .confirmpassinner {\n    width: auto;\n}\n.btngreen a {\n    padding: 10px 10px !important;\n    border-radius: 4px !important;\n    width: 150px;\n    position: relative;\n    top: 0;\n    text-align: center;\n    font-family: \"Open Sans\", sans-serif;\n    background: #28a830;\n    color: #fff;\n    display: table;\n    margin: 0;\n}\n.titlenewDrop h2 {\n    margin: 0 !important;\n}\n/*new profilepage*/\n.bannerProfilephoto img {\n    width: 100%;\n    border-radius: 15px;\n    height: 250px;\n    object-fit: cover;\n    object-position: center;\n}\n\n.profilePic {\n    border-radius: 100%;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n}\n\n.profileimage {\n    width: 150px;\n    height: 150px;\n    border-radius: 100%;\n    /* overflow: hidden; */\n    margin-left: 35px;\n    border: 4px solid #080808;\n}\n\n.nameconnection {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n    margin-left: 30px;\n    margin-top: 50px;\n}\n\n.nameconnection h5 {\n    opacity: 0.5;\n    color: var(--userName);\n}\n\n.nameconnection h3 {\n    margin-bottom: 15px;\n    color: var(--userName);\n}\n\n.prfileimageconnection {\n    width: 60%;\n}\n\n.profileeditmain {\n    width: 40%;\n    margin-top: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.profileimageEditprofilemain {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: relative;\n    top: -50px;\n    border-bottom: 1px solid rgb(255 255 255 / 10%);\n    padding-bottom: 50px;\n}\n\n.prfileimageconnection {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.newpromainwrap {\n    font-family: \"Open Sans\", sans-serif;\n    /* margin-top: 50px; */\n}\n\np.hasnewbtn {\n    background: #3478ff;\n    color: #fff;\n    padding: 6px 25px;\n    border-radius: 8px;\n    outline: none;\n    border: none;\n    transition: 0.3s;\n    cursor: pointer;\n}\np.hasnewbtn:hover {\n    background: #3456ff;\n    color: #fff;\n}\n.hasboxbg {\n    background-color: var(--container-bg);\n    /* background: #171717; */\n    border-radius: 15px;\n    padding: 20px;\n    /* margin-bottom: 15px; */\n    margin-bottom: calc(var(--bs-gutter-x) * 1);\n    /* word-break: break-all; */\n}\n\n.hasboxbg-no-bottom-margin {\n    margin-bottom: 0px !important;\n}\n\n.prosecleft {\n    /* width: 35%; */\n}\n\n.prosecright {\n    /* width: calc(65% - 30px); */\n}\n\n.profilesecionmainwrwap {\n    display: flex;\n    align-items: start;\n    justify-content: space-between;\n}\n\n.titleaboutLInk {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 15px;\n}\n\n.titleaboutLInk h5 {\n    color: var(--userName);\n    /* color: #fff; */\n    margin: 0;\n    font-size: 24px;\n    font-weight: 500;\n}\n\n.titleaboutLInk a {\n    text-decoration: underline !important;\n    font-size: 14px;\n}\n\n.aboutifo {\n    margin-top: 20px;\n}\n\n.aboutifo ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n.aboutifo ul li {\n    color: var(--userName);\n    /* color: #fff; */\n    font-size: 16px;\n}\n\n.aboutifo ul li span {\n    opacity: 0.5;\n    margin-right: 10px;\n}\n\n.aboutifo ul li + li {\n    margin-top: 12px;\n}\n\n.familyboxinfo {\n    /* height: 450px; */\n    overflow-y: scroll;\n    max-height: 450px;\n}\n.familyboxinfo::-webkit-scrollbar {\n    width: 0.5em !important;\n    display: none;\n}\n\n.familyboxinfo ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.familyboxinfo ul li {\n    width: 31%;\n    margin-top: 5%;\n}\n\n.familyboxinfo ul {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: stretch;\n    column-gap: 15px;\n    /* justify-content: space-between; */\n}\n\n.imageFamily img {\n    width: 100%;\n    height: 100px;\n    object-fit: cover;\n    object-position: top;\n    border-radius: 12px;\n}\n\n.nameFamily {\n    color: #fff;\n    margin-top: 10px;\n}\n\n.nameFamily h5 {\n    font-size: 14px;\n    line-height: 24px;\n    margin-bottom: 3px;\n    font-weight: 400;\n    color: var(--userName);\n}\n\n.nameFamily h6 {\n    opacity: 0.5;\n    font-size: 12px;\n}\n.upcomingifo ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.upcomingifo ul li {\n    color: #fff;\n}\n\n.upcmgtitle h5 {\n    font-size: 18px;\n    line-height: 24px;\n    margin-bottom: 3px;\n    color: var(--shotcusttext);\n}\n\n.comingImageTitle img {\n    width: 100%;\n    height: 150px;\n    object-fit: cover;\n    object-position: center;\n    border-radius: 12px;\n    margin-bottom: 10px;\n}\n\n.upcomingifo ul li + li {\n    margin-top: 20px;\n}\n\n.upcomingifo {\n    margin-top: 30px;\n    max-height: 500px;\n    overflow-y: scroll;\n}\n.upcomingifo::-webkit-scrollbar {\n    display: none;\n}\n\n.uoloadtext {\n    display: flex;\n    align-items: center;\n}\n\n.profileimg img {\n    width: 50px;\n    height: 50px;\n    object-fit: cover;\n    object-position: center;\n    border-radius: 100%;\n}\n\n.profileimg {\n    margin-right: 12px;\n}\n\n.blur-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5); /* Dark overlay */\n    backdrop-filter: blur(4px); /* Blur effect */\n    border-radius: 10px;\n    overflow: hidden;\n  }\n  \n.profileText h4 {\n    margin: 0;\n    font-size: 17px;\n    color: var(--shotcusttext);\n    /* color: #ffffff; */\n    /* opacity: 0.5; */\n    font-weight: 400;\n}\n\n.mindUpload {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.profileimgUploadIcon img {\n    height: 22px;\n}\n\n.uoloadtextmain .profileText h4 {\n    opacity: 1;\n    margin-bottom: 1px;\n}\n\n.uoloadtextmain .profileText span {\n    opacity: 0.6;\n    color: #fff;\n    font-size: 14px;\n}\n\n.uoloadtext span.tag {\n    background: var(--tag);\n    /* background: #2f2f2f; */\n    padding: 4px 15px;\n    /* color: rgb(255 255 255 / 50%); */\n    color: #ffffff;\n    display: inline-block;\n    border-radius: 4px;\n    font-size: 14px;\n    margin-left: 2%;\n}\n.comenttag span.tag {\n    background: #2f2f2f;\n    padding: 8px 15px;\n    color: rgb(255 255 255 / 50%);\n    display: inline-block;\n    border-radius: 6px;\n    font-size: 14px;\n}\n\n.comenttag {\n    /* width: 50%; */\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.comenttag span.time {\n    color: var(--shotcusttext);\n    /* color: #fff; */\n    /* opacity: 0.4; */\n    font-size: 12px;\n}\n\n.uoloadtextmain .uoloadtext {\n    /* width: 50%; */\n}\n\n.uoloadtextmain {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.postContent p {\n    font-size: 16px;\n    line-height: 28px;\n    margin: 0;\n    color: var(--shotcusttext);\n    /* color: #fff; */\n}\n\n.postaction {\n    flex-wrap: wrap;\n    row-gap: 10px;\n}\n\n.postaction ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.postaction ul li + li {\n    margin-left: 40px;\n}\n\n.postaction ul li img {\n    height: 25px;\n    margin-right: 10px;\n}\n\n.postaction ul li span {\n    /* color: #8b8b8b; */\n    /* color: #ffffff; */\n    color: var(--grey-comment);\n}\n\n.postContent {\n    border-bottom: 1px solid rgb(255 255 255 / 10%);\n    padding-bottom: 20px;\n    margin: 20px 0 20px;\n}\n\n.postedImage {\n    margin-block: 10px;\n    /* margin-top: 15px; */\n    /* margin-bottom: 5px; */\n    max-width: 100%;\n}\n\n.postedImage img {\n    width: 100%;\n    border-radius: 12px;\n}\n\n.uoloadtext.innerPrfilePostInner {\n    width: 100%;\n    align-items: start;\n}\n\n.postStatus {\n    margin-left: 20px;\n}\n\n.postStatus p {\n    font-size: 14px;\n    opacity: 0.3;\n    font-weight: 400;\n    margin: 0;\n    line-height: 20px;\n}\n\n.postedImage.UploadProfileimage {\n    position: relative;\n    padding-bottom: 50px;\n}\n\n.postedImage.UploadProfileimage .profileimage {\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: auto;\n    bottom: 0;\n}\n\n.postedImage.UploadProfileimage .profileimage img {\n    width: 100%;\n    height: 100%;\n}\n.uoloadtext.innerPrfilePostInner .profileText {\n    width: 500px;\n}\n\n.profileTextinner {\n    display: flex;\n    align-items: center;\n}\n.headerRightMenu ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    align-items: center;\n}\n.newheaderRight {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.headerRightIcon {\n    display: flex;\n    align-items: center;\n    margin-left: 20px;\n}\n\n.newiconheader {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.nottii > div + div {\n    margin-left: 20px;\n}\n\n.newiconheader > div {\n    margin-left: 18px;\n}\n.fullpage-nav {\n    padding: 0 !important;\n}\n.mes {\n    /* border-left: 1px solid rgb(255 255 255 / 51%); */\n    padding-left: 20px;\n    margin-left: 0 !important;\n}\n\n.headerRightMenu ul li a {\n    font-size: 16px;\n    line-height: 19px;\n    /* leading-trim and text-edge are draft CSS properties.\n\n  Read more: https://drafts.csswg.org/css-inline-3/#leading-trim\n  */\n    text-align: right;\n    color: #ffffff;\n}\n\n.headerRightMenu.headerRightMenu ul li + li {\n    margin-left: 25px;\n}\n\n.cirlenoti {\n    width: 10px;\n    height: 10px;\n    position: absolute;\n    background: #3478ff;\n    border-radius: 100%;\n    border: 2px solid #171717;\n    top: -3px;\n    right: 0;\n}\n\n.nottii {\n    position: relative;\n    border-left: 1px solid rgb(255 255 255 / 51%);\n    padding-left: 20px;\n}\n.openmobilemenu,\n.closeMenu {\n    display: none !important;\n}\n.profileIMg {\n    position: relative;\n}\n\n.innerdropdownmainLEft img {\n    width: 35px;\n    border-radius: 100%;\n    height: 35px;\n}\n\n.innerdropdownmainLEft a {\n    display: flex;\n    align-items: center;\n    color: #fff;\n}\n\n.innerdropdownmainLEft h5 {\n    margin: 0;\n    font-size: 15px;\n    margin-left: 10px;\n    max-width: 160px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.innerdropdownmain {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n/*headerNewStyle End*/\n.top-menu-new {\n    margin-top: 50px;\n    border-radius: 8px;\n    overflow: hidden;\n}\n.contactcenterBox .row {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.contactcenterBoxwrapInner {\n    margin-top: 60px;\n}\n.evebtdate {\n    font-family: \"Open Sans\", sans-serif;\n    background: rgb(255 255 255 / 78%);\n    display: inline-block;\n    padding: 8px;\n    border-radius: 5px;\n    position: absolute;\n    top: 20px;\n    right: 20px;\n}\n.contactcenterBoxwrapInner {\n    margin-top: 60px;\n    margin-bottom: 70px;\n    border-radius: 15px;\n    overflow: hidden;\n    box-shadow:  var(--event-box-shadow);\n}\n.contactcenterBoxImage {\n    position: relative;\n}\n.contactimagecont {\n    background: var(--container-bg);\n    padding: 30px;\n}\n\n.contactimagecont h3 {\n    font-family: \"Open Sans\", sans-serif;\n    color: var(--userName);\n    font-size: 22px;\n    line-height: 50px;\n    margin-bottom: 8px;\n}\n\n.contactimagecont h3 {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.contactimagecont h3 span {\n    font-family: \"Open Sans\", sans-serif;\n    color: #3478ff;\n    font-size: 16px;\n    line-height: 30px;\n    margin-bottom: 0;\n}\n\n.contactimagecont h5 {\n    font-family: \"Open Sans\", sans-serif;\n    color: var(--userName);\n    font-size: 16px;\n    line-height: 34px;\n    margin-bottom: 0;\n    opacity: 0.5;\n}\n.btnconect4 a {\n    background: #fff;\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 20px;\n    line-height: 28px;\n    padding: 12px 20px;\n    display: inline-block;\n    width: 160px;\n    text-align: center;\n    border-radius: 10px;\n}\n.postaction ul li {\n    display: flex;\n    align-items: center;\n}\n.contactcenterBoxwrap {\n    font-family: \"Open Sans\", sans-serif;\n}\n.userProfileicon img {\n    width: 40px;\n    height: 40px;\n    border-radius: 100%;\n    object-fit: cover;\n    object-position: center;\n}\n\n.cahtListcomments ul li {\n    display: flex;\n    align-items: start;\n    justify-content: flex-start;\n}\n\n.userProfileicon {\n    /* margin-right: 12px; */\n}\n\n.comentbox {\n    background: rgb(255 255 255 / 10%);\n    padding: 10px;\n    border-radius: 8px;\n    word-break: break-all;\n    width: fit-content;\n}\n\n.comentbox h5 {\n    font-size: 15px;\n    color: var(--shotcusttext);\n    /* color: #fff; */\n    opacity: 0.5;\n    line-height: 18px;\n    margin: 0 0 10px;\n}\n\n.comentbox p {\n    font-size: 14px;\n    margin: 0 !important;\n    line-height: 22px;\n}\n\n.cahtListcomments {\n    border-top: 1px solid rgb(255 255 255 / 10%);\n    margin-top: 20px;\n    padding-top: 30px;\n    max-height: 600px;\n    overflow-y: scroll;\n    padding-right: 10px;\n}\n.cahtListcomments::-webkit-scrollbar {\n    width: 0.1em !important;\n    /* display: none; */\n}\n\n.cahtListcomments::-webkit-scrollbar-thumb {\n    background-color: grey;\n}\n\n.userActins {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    margin-top: 7px;\n}\n.hashomenewcentercon .profilesecionmainwrwap {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.welcomeBox {\n    height: 100%;\n    background: #b5cbf6;\n    background: linear-gradient(149deg, #b5cbf6 0, #3478ff 100%);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 16px;\n    border-radius: 10px;\n    /* margin-bottom: 20px; */\n    margin-bottom: calc(var(--bs-gutter-x) * 1);\n}\n\n.welcomeLeft h2 {\n    font-size: 25px;\n    /* line-height: 64px; */\n    color: #fff;\n    line-height: 1.2;\n    font-weight: 500;\n}\n\n.welcomeLeft h2 span {\n    display: block;\n    font-size: 19px;\n    /* line-height: 54px; */\n}\n\n.notifictionocon {\n    display: flex;\n}\n\n.notifictionocon span {\n    margin-right: 20px;\n}\n.welcomebtn a {\n    background: #fff;\n    color: #3478ff !important;\n    width: 150px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    font-weight: bold;\n    font-size: 10px;\n}\n\n.welcomebtn {\n    display: flex;\n    flex-direction: column;\n}\n\n.welcomebtn a + a {\n    margin-top: 12px;\n}\n.welcomeboxright {\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n.hashomenewcentercon .prosecright {\n    /* width: 70%; */\n    width: 100%;\n}\n.timecoments {\n    color: var(--shotcusttext);\n    /* color: #fff; */\n    font-size: 12px;\n    opacity: 0.5;\n}\n.serviceshortctuts h3 {\n    font-size: 36px;\n    line-height: 48px;\n    color: #fff;\n    margin: 0 0 12px;\n}\n\n.serviceshortctuts ul li {\n    background-color: var(--container-bg);\n    /* background: #171717; */\n    width: calc(25% - 15px);\n    border-radius: 6px;\n    padding: 23px 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.shotcusttext {\n    color: var(--shotcusttext);\n    /* color: #fff; */\n    /* font-size: 18px; */\n}\n.serviceshortctuts ul {\n    display: flex;\n    align-items: stretch;\n    justify-content: space-between;\n}\n.connectSuggleft {\n    background: #202020;\n    padding: 30px;\n    border-radius: 15px;\n}\n\n.imagelinkbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 12px;\n}\n\n.connectSuggright {\n    background: #202020;\n    padding: 20px;\n    border-radius: 15px;\n    width: 49%;\n}\n\n.conlink img {\n    width: 50px;\n}\n.connectconet {\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n}\n.connectconet p {\n    margin: 0;\n    font-size: 18px;\n    line-height: 32px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n.coomainwrap {\n    display: flex;\n    align-items: stretch;\n    /* justify-content: space-between; */\n    overflow-x: scroll;\n    column-gap: 10px;\n}\n.coomainwrap::-webkit-scrollbar {\n    width: 0.5em !important;\n    display: none;\n}\n\n.coomainwrap::-webkit-scrollbar-thumb {\n    background-color: transparent;\n}\n\n.editable::-webkit-scrollbar {\n    width: 0.5em !important;\n    display: none;\n}\n\n.editable::-webkit-scrollbar-thumb {\n    background-color: transparent;\n}\n.upcomingTabs .connectSuggleft {\n    padding: 0;\n    background: transparent;\n}\n\n.upcomingTabs .upcmgtitle h5 {\n    color: #fff;\n    font-size: 24px;\n    line-height: 34px;\n}\n.mindUploadPost.hasboxbg h3 {\n    color: #fff;\n    font-size: 28px;\n    line-height: 40px;\n    margin-bottom: 20px;\n}\n.popupMain {\n    background: rgb(10 10 10 / 90%);\n    width: 100%;\n    height: 100%;\n    /* position: absolute; */\n    /* top: 0; */\n    z-index: 9999999;\n    /* display: flex; */\n    align-items: start;\n    justify-content: center;\n    border-radius: 10px;\n    max-width: 700px;\n}\n\n.popupInner {\n    /* width: 700px; */\n    min-width: 700px;\n    height: auto;\n    /* margin-top: 100px; */\n    background: #282a2a;\n    border-radius: 10px;\n    /* overflow: hidden; */\n    /* max-width: 100%; */\n    max-width: 700px;\n}\n\n.popupHeader {\n    background: #242626;\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n    padding: 20px;\n    border-radius: 10px;\n    justify-content: space-between;\n}\n\n.popupHeader h5 {\n    opacity: 0.5;\n}\n\n.popupHeader ul {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-top: 20px;\n}\n\n.popupHeader ul li {\n    background: #454646;\n    width: auto;\n    height: auto;\n    padding: 10px 15px;\n    border-radius: 7px;\n    font-size: 14px;\n}\n.mindUpload {\n    padding: 13px 19px;\n    /* padding-bottom: 0px; */\n}\n\n.popupMain .postContent {\n    padding: 20px;\n    padding-top: 0px;\n    border: none;\n    border-top: 1px solid rgb(255 255 255 / 10%);\n    padding-top: 20px;\n}\n.popupHeader ul li + li {\n    margin-left: 12px;\n}\n.postBtn a {\n    display: inline-block;\n    font-family: \"Open Sans\", sans-serif;\n    padding: 12px 50px;\n    margin-top: 20px;\n}\n\n.popupMain {\n    /* display: none; */\n}\n\n.postBtn {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n}\n.popupHeader ul li.active {\n    background: #fff;\n    color: #000;\n    font-size: 14px;\n}\n.serviceshortctuts {\n    margin: 0 0 15px;\n    margin-bottom: calc(var(--bs-gutter-x) * 1);\n}\n.shortcuticon img {\n    display: table;\n    margin: 0 auto;\n    height: 38px;\n    width: 38px;\n}\n.upcomingTabs p {\n    font-size: 16px;\n    line-height: 24px;\n}\n.shortcuticon {\n    margin-bottom: 12px;\n}\n.connectconetCon h3 {\n    font-size: 23px !important;\n    margin: 0 0 8px !important;\n}\n\n.connectconetCon h5 {\n    color: #fff;\n    opacity: 0.8;\n}\n\n.penBtns a {\n    width: 180px;\n    background: #fff;\n    height: 50px;\n    display: inline-block;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n}\n\n.penBtns {\n    display: flex;\n    align-items: start;\n    justify-content: flex-start;\n    margin-top: 20px;\n}\n\na.accptbtn {\n    background: #28a830;\n    color: #fff;\n}\n\na.declinebtn {\n    background: #ff3434;\n    color: #fff;\n    margin-left: 15px;\n}\n.likereplybtn {\n    margin-left: 18px;\n    color: #fff;\n    opacity: 0.8;\n    font-size: 14px;\n    line-height: 16px;\n}\n\n.likereplybtn span + span {\n    margin-left: 10px;\n}\n\n.likereplybtn span {\n    color: var(--shotcusttext);\n}\n\n.userActins {\n}\n\n.cahtListcomments ul li + li {\n    margin-top: 30px;\n}\n.contactcenterBoxwrap .mindUploadPost.hasboxbg {\n    margin: 50px 0 90px;\n}\n.btnconect4 a + a {\n    background: rgb(255 255 255 / 15%);\n    color: #fff;\n    margin-left: 20px;\n}\n\n.btnconect4 {\n    border-top: 1px solid #3a3a3a;\n    padding-top: 30px;\n    margin-top: 30px;\n}\n.conp p {\n    font-size: 16px;\n    line-height: 28px;\n    margin: 20px 0 0;\n}\n.popupMain .profileText h4 {\n    font-family: \"Open Sans\", sans-serif;\n    color: #fff;\n    opacity: 1;\n}\n\n.comment-content {\n    word-wrap: break-word; /* Allow long words to break and wrap onto the next line */\n    overflow-wrap: break-word; /* Standard name for word-wrap property */\n    max-width: 100%; /* Ensure the content doesn't exceed the width of its container */\n}\n\n@media (max-width: 991px) {\n    .bannerProfilephoto img {\n        height: 200px;\n    }\n\n    .profileimage {\n        margin-left: 15px;\n        width: 130px;\n        height: 130px;\n        min-width: 130px;\n        position: relative;\n        top: -30px;\n    }\n\n    .prfileimageconnection {\n        width: 100%;\n    }\n\n    .profileeditmain {\n        width: 100%;\n        margin: 0;\n        justify-content: end;\n        padding-left: 0;\n        margin-top: -10px;\n    }\n\n    .profileimageEditprofilemain {\n        flex-direction: column;\n        top: 0;\n        padding-bottom: 20px;\n        margin-bottom: 30px;\n    }\n\n    .nameconnection {\n        margin-top: 0;\n        margin-left: 20px;\n    }\n\n    .nameconnection h3 {\n        font-size: 16px;\n        line-height: 20px;\n        margin-bottom: 8px;\n    }\n\n    .nameconnection h5 {\n        font-size: 14px;\n        line-height: 16px;\n    }\n\n    a.hasnewbtn {\n        padding: 12px 15px;\n        font-size: 13px;\n        width: 100%;\n        text-align: center;\n    }\n\n    /* .profilesecionmainwrwap {\n        flex-direction: column-reverse;\n    } */\n\n    .prosecleft {\n        width: 100%;\n    }\n\n    .prosecright {\n        width: 100%;\n    }\n\n    .profileText h4 {\n        font-size: 14px;\n    }\n\n    .hasboxbg {\n        padding: 12px;\n    }\n\n    .uoloadtextmain .uoloadtext {\n        width: 100%;\n    }\n\n    .comenttag {\n        width: 100%;\n        margin-top: 12px;\n    }\n\n    .uoloadtextmain {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .comenttag span.tag {\n        padding: 4px 12px;\n        font-size: 12px;\n    }\n\n    .postContent p {\n        font-size: 14px;\n        line-height: 22px;\n    }\n\n    .postaction ul li span {\n        font-size: 12px;\n    }\n\n    .imageFamily img {\n        height: 100px;\n    }\n\n    .nameFamily h5 {\n        font-size: 14px;\n        line-height: 20px;\n    }\n\n    .nameFamily h6 {\n        font-size: 12px;\n    }\n\n    .titleaboutLInk h5 {\n        font-size: 20px;\n    }\n\n    .titleaboutLInk {\n        margin-bottom: 5px;\n    }\n\n    .upcmgtitle h5 {\n        font-size: 14px;\n    }\n    .uoloadtext.innerPrfilePostInner .profileText {\n        width: 100%;\n    }\n\n    .profileTextinner {\n        flex-direction: column;\n        align-items: start;\n    }\n\n    .postStatus {\n        margin: 4px 0 0;\n    }\n\n    .postStatus p {\n        font-size: 13px;\n    }\n\n    .uoloadtextmain .profileText span {\n        font-size: 11px;\n    }\n    .aboutifo ul li {\n        font-size: 14px;\n    }\n}\n@media (max-width: 767px) {\n    .profilePicture {\n        width: 100%;\n    }\n\n    .profileBlueboxtop {\n        flex-direction: column;\n    }\n\n    .prfileDetailsandFamily {\n        width: 100%;\n        text-align: center;\n        margin: 20px 0;\n    }\n\n    .condetails {\n        width: 100%;\n    }\n\n    .fam-right ul li {\n        padding: 0 !important;\n        height: 60px !important;\n    }\n\n    .custom-tab-list ul {\n        padding: 0;\n        flex-direction: column;\n    }\n\n    .custom-tab-list ul li + li {\n        border: none;\n        margin-top: 20px;\n    }\n\n    .custom-tab-list ul li {\n        width: 100%;\n    }\n\n    .profileBluebox {\n        margin-bottom: 30px;\n    }\n\n    .confrmpasschanges {\n        flex-direction: column;\n    }\n\n    .confirmpassinner {\n        width: 100%;\n    }\n\n    .confirmpassinner + .confirmpassinner {\n        margin: 30px 0 0;\n    }\n\n    .titlenewDrop {\n        margin-bottom: 40px;\n    }\n\n    .titlenewDrop h2 {\n        margin: 0 !important;\n    }\n    .titlewithbtnnotification {\n        /* flex-direction: column; */\n        /* text-align: left; */\n        /* align-items: flex-start; */\n    }\n\n    .titlewithbtnnotification h3 {\n        margin-bottom: 0;\n        font-size: 22px;\n    }\n\n    .involmentBoxmain .for-box-innner {\n        padding: 0 !important;\n    }\n\n    .ratesMain {\n        flex-direction: column;\n    }\n\n    .rateTitle {\n        width: 100%;\n        text-align: center;\n        margin-bottom: 30px;\n    }\n\n    .assgnbtnnot a {\n        font-size: 12px;\n        padding: 12px 22px !important;\n        width: auto !important;\n    }\n    .involdatetitle h4 {\n        font-size: 18px;\n        margin-top: 20px;\n    }\n    .involmentBoxmain:first-child {\n        margin: 0;\n        padding: 20px;\n    }\n    .notedate {\n        font-size: 13px;\n        margin-right: 10px;\n    }\n\n    .messgtnotemain .titlewithbtnnotification h3 {\n        width: auto;\n    }\n\n    .messgtnotemain .titlewithbtnnotification h3 span {\n        font-size: 12px;\n        margin-left: 20px;\n    }\n\n    .nnotcodelete img {\n        max-width: 18px;\n    }\n\n    .noteDetails p {\n        font-size: 14px;\n        line-height: 22px;\n        margin: 0;\n    }\n\n    .btngreen {\n        margin-top: 25px;\n    }\n    /*    header*/\n    .headerRightMenu {\n        position: fixed;\n        top: 0;\n        width: 100%;\n        left: 0;\n        background: #18191a;\n        padding: 20px;\n        z-index: 9999;\n        height: 100%;\n        display: none;\n    }\n\n    .newheaderRight {\n        width: 80% !important;\n        justify-content: flex-end;\n        display: none;\n    }\n\n    .logo-main img {\n        max-width: 80%;\n    }\n\n    .logo-main {\n        /* width: 20% !important; */\n        padding: 0 8px;\n    }\n\n    .headerRightMenu ul {\n        flex-direction: column;\n        align-items: start;\n        padding-top: 40px;\n    }\n\n    .headerRightMenu.headerRightMenu ul li + li {\n        margin: 12px 0 0px;\n        border-top: 1px solid #1e1f21;\n        width: 100%;\n        padding-top: 12px;\n    }\n    /* header.newHeader .container-fluid {\n        padding: 0 24px;\n    } */\n    .openmobilemenu,\n    .closeMenu {\n        display: block !important;\n    }\n    .headerRightMenu.active {\n        display: block;\n    }\n    .closeMenu {\n        width: 50px;\n        height: 50px;\n        position: absolute;\n        right: 0;\n        z-index: 999;\n        font-size: 25px;\n    }\n\n    /* .mobileMenuDesign .admin-dashboard-left h3 {\n        font-family: \"Open Sans\", sans-serif;\n        color: #fff;\n        opacity: 0.5;\n        font-size: 16px;\n        margin-bottom: 10px;\n    } */\n    .admin-dashboard-right {\n        width: 100% !important;\n        padding: 0 15px !important;\n    }\n    .top-menu-inner ul {\n        flex-direction: column;\n    }\n\n    .top-menu-inner ul li + li {\n        padding: 0 !important;\n    }\n\n    .welcomeBox {\n        flex-direction: column;\n        align-items: start;\n    }\n\n    .welcomeLeft h2 span {\n        font-size: 24px;\n        line-height: 30px;\n    }\n\n    .welcomeLeft h2 {\n        font-size: 32px;\n        line-height: 40px;\n    }\n\n    .welcomeboxright {\n        flex-direction: column;\n        width: 100%;\n        margin-top: 20px;\n    }\n\n    .welcomeLeft {\n        width: 100%;\n    }\n\n    .notifictionocon {\n        margin-bottom: 20px;\n    }\n\n    .serviceshortctuts ul li {\n        width: 48%;\n    }\n\n    .serviceshortctuts ul {\n        flex-wrap: wrap;\n    }\n\n    .hashomenewcentercon .prosecright {\n        width: 100%;\n    }\n\n    .serviceshortctuts h3 {\n        font-size: 24px;\n        line-height: 30px;\n    }\n\n    .serviceshortctuts ul li:nth-child(n + 3) {\n        margin-top: 4%;\n    }\n\n    .shotcusttext {\n        font-size: 18px;\n        text-align: center;\n    }\n\n    .coomainwrap {\n        flex-direction: column;\n    }\n\n    .connectSuggleft {\n        width: 100%;\n    }\n\n    .connectSuggleft + .connectSuggleft {\n        margin-top: 12px;\n    }\n\n    .has-footer-top {\n        padding: 40px 15px;\n    }\n\n    .footer-col {\n        width: 50%;\n        flex: 0 0 50%;\n        max-width: 50%;\n    }\n\n    .footer-col:nth-child(n + 3) {\n        margin-top: 20px;\n    }\n\n    .footer-col ul li a {\n        font-size: 14px;\n        line-height: 24px;\n    }\n\n    .footer-col ul li + li {\n        margin-top: 5px;\n    }\n\n    .footer-col h4 {\n        font-size: 18px;\n    }\n\n    .footer-b-left p {\n        padding: 0 20px;\n        font-size: 14px;\n        text-align: center;\n        line-height: 18px;\n    }\n    .mindUploadPost.hasboxbg h3 {\n        font-size: 22px;\n        line-height: 30px;\n        margin-top: 12px;\n    }\n\n    .connectconet p {\n        font-size: 16px;\n        line-height: 24px;\n        margin-top: 22px;\n    }\n    .newpromainwrap {\n        padding-bottom: 30px;\n    }\n    .contactcenterBoxImage img {\n        height: 250px;\n        object-fit: cover;\n        object-position: center;\n    }\n\n    .contactimagecont {\n        padding: 15px;\n    }\n\n    .contactimagecont h3 {\n        font-size: 26px;\n        line-height: 44px;\n        flex-direction: column;\n        align-items: start;\n    }\n\n    .contactimagecont h5 {\n        font-size: 18px;\n        line-height: 30px;\n    }\n    .userProfileicon {\n        min-width: 50px;\n    }\n    .btnconect4 {\n        display: flex;\n        align-items: start;\n    }\n\n    .btnconect4 a {\n        font-size: 16px;\n    }\n    .contactcenterBoxwrap .mindUploadPost.hasboxbg {\n        margin: 30px 0 50px;\n    }\n    .top-menu-inner ul li {\n        width: 50%;\n        text-align: center;\n    }\n\n    .top-menu-inner ul li a {\n        font-family: \"Open Sans\", sans-serif;\n        padding: 12px 0;\n        font-size: 18px;\n        color: #fff;\n        opacity: 0.8;\n    }\n\n    .top-menu-inner ul {\n        flex-wrap: wrap;\n        flex-direction: initial;\n        padding: 10px;\n    }\n    .welcomeBox {\n        padding: 20px;\n    }\n\n    .welcomebtn a {\n        height: 46px;\n    }\n\n    .welcomeLeft h2 {\n        font-size: 28px;\n        line-height: 40px;\n    }\n    .shortcuticon img {\n        max-width: 30px;\n    }\n    .connectconetCon h3 {\n        font-size: 20px !important;\n    }\n    .wraper {\n        overflow: hidden;\n    }\n    .wraper {\n        overflow: hidden;\n    }\n\n    .popupHeader ul {\n        flex-wrap: wrap;\n        align-items: start;\n    }\n\n    .popupHeader ul li {\n        margin-bottom: 12px;\n    }\n\n    .popupHeader ul li a {\n        font-size: 12px;\n    }\n\n    .popupHeader ul li {\n        font-size: 12px;\n    }\n\n    .popupInner {\n        /* width: 94%; */\n    }\n\n    .popupHeader ul li + li {\n        margin-left: 6px;\n    }\n}\n\n.upcomingEventsCol {\n    height: 63vh;\n    border-radius: 15px;\n    /* background-color: #171717; */\n    background-color: var(--container-bg);\n    padding-block: 10px;\n    overflow-y: scroll;\n}\n\n.upcomingEventsCol::-webkit-scrollbar {\n    width: 0.5em !important;\n    display: none;\n}\n\n.giving {\n    /* height: 50vh; */\n    min-height: 30vh;\n    border-radius: 15px;\n    /* background-color: #171717; */\n    background: linear-gradient(61deg, #f8acac 0, #fc4f4f 100%);\n    /* padding-block: 10px; */\n    /* padding: 15px; */\n    /* overflow-y: scroll; */\n}\n.topPart {\n    background: linear-gradient(61deg, #f8acac 0, #fc4f4f 100%);\n    border-top-left-radius: 15px;\n    border-top-right-radius: 15px;\n}\n\n.rs-progress-line-bg {\n    background: linear-gradient(61deg, #f8acac 0, #fc4f4f 100%);\n}\n\n.givingInput {\n    color: #ffffff;\n    background-color: transparent;\n    outline: unset;\n    /* border-bottom-color: #ffffff;\n    border-bottom-width: 1px; */\n    font-size: 10px;\n    width: 80%;\n    padding-bottom: 4px;\n}\n.givingInput::placeholder {\n    color: #ffffff;\n}\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Hide increment and decrement buttons in Firefox */\ninput[type=\"number\"] {\n    -moz-appearance: textfield;\n}\n\n.inputCont {\n    border-bottom-color: #ffffff;\n    border-bottom-width: 1px;\n}\n\n/*  */\n/* ToggleSwitch.css */\n.toggle-switch {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 24px;\n}\n\n.toggle-switch input {\n    display: none;\n}\n\n.subscriptionCont {\n    height: 50px;\n    overflow-y: scroll;\n    row-gap: 4px;\n}\n.subscriptionCont::-webkit-scrollbar {\n    width: 0.5em !important;\n    display: none;\n}\n\n/* .paymentMethods {\n    height: 70px;\n    overflow-y: scroll;\n    gap: 4px;\n    flex-wrap: wrap;\n}\n.paymentMethods::-webkit-scrollbar {\n    width: 0.5em !important;\n    display: none;\n} */\n\n.react-datepicker__input-container input {\n    width: 98% !important;\n    background-color: transparent;\n    font-size: 12px;\n    color: #fff;\n    outline: unset;\n}\n\n.react-datepicker-popper .react-datepicker__triangle {\n    display: none;\n}\n.react-datepicker {\n    left: 30%;\n}\n\n/*  */\n\n.postCol {\n    height: 98vh;\n    overflow-y: auto;\n    border-bottom-left-radius: 20px;\n    border-bottom-right-radius: 20px;\n    /* padding: 0 !important; */\n    /* padding-inline: calc(var(--bs-gutter-x) * 1) */\n}\n\n.postCol::-webkit-scrollbar {\n    width: 0.5em !important;\n    display: none;\n}\n\n.givingCont {\n    background-color: white;\n    border-radius: 15px;\n    margin-bottom: calc(var(--bs-gutter-x) * 1);\n}\n\n.rightCol {\n    height: 98vh;\n    display: flex;\n    flex-direction: column;\n    /* row-gap: 20px; */\n    overflow-y: scroll;\n    /* padding: 0 !important;\n    padding-left: 0 !important;\n    padding-right: 0 !important; */\n    /* padding-right: calc(var(--bs-gutter-x) * 1) */\n    padding-right: 0 !important;\n    /* justify-content: space-between; */\n}\n\n.mainCont {\n    padding-inline: calc(var(--bs-gutter-x) * 1);\n}\n\n.leftCol {\n    /* padding: 0 !important; */\n    padding-left: 0 !important;\n    height: 98vh;\n    /* overflow: scroll; */\n    border-radius: 15px;\n    /* justify-content: space-between; */\n    display: flex;\n}\n\n.leftCol::-webkit-scrollbar {\n    width: 0.5em !important;\n    display: none;\n}\n\n.rightCol::-webkit-scrollbar {\n    width: 0.5em !important;\n    display: none;\n}\n\n.connectSuggestionContainer {\n    background-color: var(--container-bg);\n    /* background-color: #171717; */\n    border-radius: 15px;\n    padding: 16px 10px 10px 10px;\n    margin-bottom: calc(var(--bs-gutter-x) * 1);\n}\n\n.scrollCont::-webkit-scrollbar {\n    width: 0.5em !important;\n    display: none;\n}\n\n.scrollCont {\n    overflow-y: scroll;\n    height: 20vh;\n}\n\n.connectSuggestionCard {\n    background-color: var(--container2-bg);\n    /* background-color: #202020; */\n    border-radius: 15px;\n    align-items: center;\n    padding: 10px;\n    justify-content: space-between;\n}\n\n.eventCard {\n    display: flex;\n    flex-direction: column;\n    border-radius: 15px;\n    /* background-color: #202020; */\n    background-color: var(--container2-bg);\n    padding: 15px;\n    justify-content: center;\n}\n\n.eventCard img {\n    width: 100%;\n    height: 105px;\n    object-fit: cover;\n    object-position: center;\n    border-radius: 12px;\n    margin-bottom: 10px;\n}\n\n.viewBtn {\n    border-radius: 5px;\n    background-color: var(--viewBtn);\n    /* background-color: #4b4b4b; */\n    align-items: center;\n    justify-content: center;\n    margin-top: 10px;\n    /* padding-block: 6px; */\n}\n.viewBtn p {\n    margin-bottom: 0;\n}\n\n.actionsCont {\n    display: flex;\n    justify-content: center;\n    margin-top: 0px;\n}\n\n.actionsCont a {\n    width: 50%;\n    height: 35px;\n    display: inline-block;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n}\n\n@media (min-width: 1200px) and (max-width: 1750px) {\n    .logo-main img {\n        max-height: 40px;\n    }\n    /* .container {\n        width: 100%;\n        max-width: 100%;\n        padding: 0 90px;\n    } */\n    header {\n        padding: 10px 0;\n        /* background-color: red !important; */\n    }\n}\n\n/* .accptbtn:hover{\n    color: white ;\n}\n.declinebtn:hover{\n    color: white;\n} */\n\n.header-Icon {\n    height: 30px;\n    width: 25px;\n    max-width: 25px;\n}\n\n.header-Logo {\n    display: none;\n}\n\n@media (max-width: 768px) {\n    .header-Logo {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding-block: 10px;\n    }\n    .mainHeader {\n        display: none !important;\n    }\n    .leftCol {\n        padding: 0 !important;\n    }\n    /* .header.newHeader .row {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    } */\n    .post-detail-wrapper {\n        flex-direction: column !important;\n    }\n}\n\n.replies-cont {\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.replies-cont::-webkit-scrollbar {\n    width: 0.1em !important;\n}\n\n.replies-cont::-webkit-scrollbar-thumb {\n    background-color: grey;\n}\n\n.even-row {\n    background-color: #171717;\n    color: #fff;\n}\n.odd-row {\n    background-color: #202020;\n    color: #fff;\n}\n.ant-table-cell {\n    /* background-color: #000 !important; */\n    color: #fff !important;\n    border-bottom-color: #000 !important;\n}\n\n.ant-table-cell::before {\n    background-color: #000 !important;\n}\n.ant-table-thead > tr > th {\n    background-color: #000 !important;\n    color: #fff !important;\n}\n\n.ant-table-cell-scrollbar {\n    box-shadow: none !important;\n}\n\n.ant-pagination-item-link {\n    color: #fff !important;\n}\n\n.ant-pagination-item:not(.ant-pagination-item-active):hover {\n    background-color: grey !important;\n}\n\n.ant-pagination-item {\n    background-color: transparent !important;\n    color: #fff !important;\n}\n\n.ant-pagination-item-active {\n    background-color: #007bff !important;\n    color: #fff !important ;\n}\n\n.ant-table-tbody::-webkit-scrollbar {\n    display: none !important;\n}\n.ant-picker-outlined {\n    background-color: #202020 !important;\n    color: #fff !important;\n}\n\n.ant-picker-input > input::-webkit-input-placeholder {\n    color: #fff !important;\n}\n\n.ant-picker-separator {\n    color: #fff !important;\n}\n\n.ant-picker-clear {\n    color: #fff !important;\n    opacity: 1 !important;\n}\n\n.ant-dropdown-menu {\n    background-color: #202020 !important;\n    /* border: 1px solid #d9d9d9; */\n}\n.ant-dropdown-menu-item {\n    color: #fff !important;\n}\n\n.ant-dropdown-menu-item-selected {\n    background-color: #007bff !important;\n}\n\n.ant-pagination-item-ellipsis {\n    color: #fff !important;\n}\n\n.ant-picker-panel-container {\n    background: #202020 !important;\n}\n.ant-picker-header {\n    color: #fff !important;\n}\n\n.ant-picker-header button {\n    color: #fff !important;\n}\n\n.ant-picker-content thead tr th {\n    color: white !important;\n}\n\n.ant-picker-cell-inner {\n    color: #fff !important;\n}\n\n.ant-picker-cell-in-range > div {\n    color: #000 !important;\n}\n\n.ant-dropdown-menu-item:hover {\n    background-color: rgb(255 255 255 / 6%) !important;\n}\n\n.excel-generate-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 120px;\n    height: 40px;\n    background-color: #007bff;\n    border-radius: 4px;\n    padding: 10px;\n    cursor: pointer;\n    color: #fff;\n    font-size: 16px;\n    font-weight: bold;\n    border: none;\n    outline: none;\n}\n\n/* Hover state */\n.excel-generate-button:hover {\n    background-color: #0056b3;\n}\n\n/* Active state */\n.excel-generate-button:active {\n    background-color: #004085;\n}\n\n/* Disabled state */\n.excel-generate-button:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n}\n\n@media (max-width: 460px) {\n    .ant-picker-panels {\n        display: flex !important;\n        flex-direction: column !important;\n    }\n}\n\n.annual-budget-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n    width: 100%;\n    height: calc(90% - 60px);\n    overflow: auto;\n    border-radius: 4px;\n}\n\n@media (max-width: 768px) {\n    .annual-budget-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 668px) {\n    .annual-budget-grid {\n        gap: 10px;\n        height: calc(90% - 25px);\n    }\n}\n\n.two-line-ellipsis {\n    display: -webkit-box;\n    -webkit-line-clamp: 2; /* Limit to 2 lines */\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.three-line-ellipsis{\n    display: -webkit-box;\n    -webkit-line-clamp: 3; /* Limit to 2 lines */\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.reply-input::-webkit-input-placeholder {\n    color: grey;\n}\n.noti-item:hover {\n    background-color: var(--hover-noti-color) !important;\n    cursor: pointer;\n}\n\n.convo-item:hover {\n    background-color: var(--hover-convo) !important;\n}\n\n.about-content {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    background-color: var(--container-bg);\n    border-radius: 20px;\n    padding: 40px;\n    cursor: pointer;\n    box-shadow: var(--event-box-shadow);\n}\n\n.about-content img {\n    height: 60px;\n    width: 60px;\n    filter: var(--img-brightness);\n}\n\n.about-content h3 {\n    color:var(--userName);\n    line-height: 1.2;\n    font-weight: 600;\n}\n\n.our-belief {\n    display: flex;\n    flex-direction: column;\n    width: 90%;\n    padding-block: 30px;\n    padding-inline: 20px;\n    font-family: sans-serif;\n}\n\n.our-belief h1 {\n    color: var(--userName);\n    margin-bottom: 30px;\n}\n.our-belief div {\n    margin-bottom: 40px;\n    row-gap: 20px;\n}\n\n.our-belief div p {\n    color:var(--ourbelief-p);\n    font-size: 24px;\n    line-height: 40px;\n    text-align: justify;\n}\n\n.our-belief div h2 {\n    color: var(--userName);\n    font-size: 20px;\n    line-height: 40px;\n    margin-top: 10px;\n}\n\n.our-code {\n    display: flex;\n    flex-direction: column;\n    width: 90%;\n    padding-block: 30px;\n    padding-inline: 20px;\n    font-family: sans-serif;\n}\n\n.our-code div h4 {\n    color: var(--userName);\n    font-weight: 500;\n    opacity: 0.5;\n    line-height: 40px;\n    font-size: 24px;\n}\n\n.our-code > div > h2 {\n    font-size: 30px;\n}\n\n.chatBox {\n    background-color: var(--widget-bg);\n    border-radius: 20px;\n    display: flex;\n    height: 100%;\n    flex-direction: column;\n    justify-content: space-between;\n    box-shadow: var(--box-shadow);\n\n}\n\n.chat-Input {\n    color: var(--notes-textarea-color);\n    background-color: transparent;\n    outline: none;\n    border: unset;\n    font-size: 14px;\n    resize: unset;\n}\n.chat-Input::placeholder {\n    color: gray;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
